const tokens = {
  "animations.backdrop-in": {
    "value": "fade-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-backdrop-in)"
  },
  "animations.backdrop-out": {
    "value": "fade-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-backdrop-out)"
  },
  "animations.dialog-in": {
    "value": "slide-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-dialog-in)"
  },
  "animations.dialog-out": {
    "value": "slide-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-dialog-out)"
  },
  "animations.drawer-in-left": {
    "value": "slide-in-left 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-left)"
  },
  "animations.drawer-out-left": {
    "value": "slide-out-left 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-left)"
  },
  "animations.drawer-in-right": {
    "value": "slide-in-right 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-right)"
  },
  "animations.drawer-out-right": {
    "value": "slide-out-right 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-right)"
  },
  "animations.skeleton-pulse": {
    "value": "skeleton-pulse 2s var(--easings-pulse) infinite",
    "variable": "var(--animations-skeleton-pulse)"
  },
  "animations.fade-in": {
    "value": "fade-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-fade-in)"
  },
  "animations.collapse-in": {
    "value": "collapse-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-collapse-in)"
  },
  "animations.collapse-out": {
    "value": "collapse-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-collapse-out)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "easings.pulse": {
    "value": "cubic-bezier(0.4, 0.0, 0.6, 1.0)",
    "variable": "var(--easings-pulse)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.2, 0.0, 0, 1.0)",
    "variable": "var(--easings-default)"
  },
  "easings.emphasized-in": {
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    "variable": "var(--easings-emphasized-in)"
  },
  "easings.emphasized-out": {
    "value": "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    "variable": "var(--easings-emphasized-out)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.2xs": {
    "value": "0.0625rem",
    "variable": "var(--radii-2xs)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.4.5": {
    "value": "1.125rem",
    "variable": "var(--sizes-4\\.5)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.4.5": {
    "value": "1.125rem",
    "variable": "var(--spacing-4\\.5)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.sans": {
    "value": "var(--font-dm-sans), -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif",
    "variable": "var(--fonts-sans)"
  },
  "fonts.mono": {
    "value": "var(--font-dm-mono), ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fontSizes.11": {
    "value": "0.6875rem",
    "variable": "var(--font-sizes-11)"
  },
  "fontSizes.13": {
    "value": "0.8125rem",
    "variable": "var(--font-sizes-13)"
  },
  "fontSizes.15": {
    "value": "0.9375rem",
    "variable": "var(--font-sizes-15)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.75",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "lineHeights.2xs": {
    "value": "1rem",
    "variable": "var(--line-heights-2xs)"
  },
  "lineHeights.xs": {
    "value": "1.125rem",
    "variable": "var(--line-heights-xs)"
  },
  "lineHeights.sm": {
    "value": "1.25rem",
    "variable": "var(--line-heights-sm)"
  },
  "lineHeights.md": {
    "value": "1.375rem",
    "variable": "var(--line-heights-md)"
  },
  "lineHeights.lg": {
    "value": "1.5rem",
    "variable": "var(--line-heights-lg)"
  },
  "lineHeights.xl": {
    "value": "1.75rem",
    "variable": "var(--line-heights-xl)"
  },
  "lineHeights.2xl": {
    "value": "2rem",
    "variable": "var(--line-heights-2xl)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--colors-transparent)"
  },
  "colors.gray.light.1": {
    "value": "#FDFCFC",
    "variable": "var(--colors-gray-light-1)"
  },
  "colors.gray.light.2": {
    "value": "#FDFAF9",
    "variable": "var(--colors-gray-light-2)"
  },
  "colors.gray.light.3": {
    "value": "#F8F4F2",
    "variable": "var(--colors-gray-light-3)"
  },
  "colors.gray.light.4": {
    "value": "#EEE8E6",
    "variable": "var(--colors-gray-light-4)"
  },
  "colors.gray.light.5": {
    "value": "#E8E2DF",
    "variable": "var(--colors-gray-light-5)"
  },
  "colors.gray.light.6": {
    "value": "#D9D2CF",
    "variable": "var(--colors-gray-light-6)"
  },
  "colors.gray.light.7": {
    "value": "#CCC5C2",
    "variable": "var(--colors-gray-light-7)"
  },
  "colors.gray.light.8": {
    "value": "#B8B2B0",
    "variable": "var(--colors-gray-light-8)"
  },
  "colors.gray.light.9": {
    "value": "#8A8483",
    "variable": "var(--colors-gray-light-9)"
  },
  "colors.gray.light.10": {
    "value": "#797472",
    "variable": "var(--colors-gray-light-10)"
  },
  "colors.gray.light.11": {
    "value": "#54504F",
    "variable": "var(--colors-gray-light-11)"
  },
  "colors.gray.light.12": {
    "value": "#141110",
    "variable": "var(--colors-gray-light-12)"
  },
  "colors.gray.light.a1": {
    "value": "#3D1A1003",
    "variable": "var(--colors-gray-light-a1)"
  },
  "colors.gray.light.a2": {
    "value": "#3D1A1008",
    "variable": "var(--colors-gray-light-a2)"
  },
  "colors.gray.light.a3": {
    "value": "#3D1A100D",
    "variable": "var(--colors-gray-light-a3)"
  },
  "colors.gray.light.a4": {
    "value": "#3D1A1012",
    "variable": "var(--colors-gray-light-a4)"
  },
  "colors.gray.light.a5": {
    "value": "#3D1A1017",
    "variable": "var(--colors-gray-light-a5)"
  },
  "colors.gray.light.a6": {
    "value": "#3D1A1024",
    "variable": "var(--colors-gray-light-a6)"
  },
  "colors.gray.light.a7": {
    "value": "#3D1A1030",
    "variable": "var(--colors-gray-light-a7)"
  },
  "colors.gray.light.a8": {
    "value": "#3D1A1045",
    "variable": "var(--colors-gray-light-a8)"
  },
  "colors.gray.light.a9": {
    "value": "#3D1A1073",
    "variable": "var(--colors-gray-light-a9)"
  },
  "colors.gray.light.a10": {
    "value": "#3D1A1080",
    "variable": "var(--colors-gray-light-a10)"
  },
  "colors.gray.light.a11": {
    "value": "#3D1A10A1",
    "variable": "var(--colors-gray-light-a11)"
  },
  "colors.gray.light.a12": {
    "value": "#3D1A10DE",
    "variable": "var(--colors-gray-light-a12)"
  },
  "colors.gray.dark.1": {
    "value": "#141715",
    "variable": "var(--colors-gray-dark-1)"
  },
  "colors.gray.dark.2": {
    "value": "#1B1E1C",
    "variable": "var(--colors-gray-dark-2)"
  },
  "colors.gray.dark.3": {
    "value": "#222523",
    "variable": "var(--colors-gray-dark-3)"
  },
  "colors.gray.dark.4": {
    "value": "#333635",
    "variable": "var(--colors-gray-dark-4)"
  },
  "colors.gray.dark.5": {
    "value": "#454846",
    "variable": "var(--colors-gray-dark-5)"
  },
  "colors.gray.dark.6": {
    "value": "#4F5250",
    "variable": "var(--colors-gray-dark-6)"
  },
  "colors.gray.dark.7": {
    "value": "#636664",
    "variable": "var(--colors-gray-dark-7)"
  },
  "colors.gray.dark.8": {
    "value": "#777A78",
    "variable": "var(--colors-gray-dark-8)"
  },
  "colors.gray.dark.9": {
    "value": "#9FA2A0",
    "variable": "var(--colors-gray-dark-9)"
  },
  "colors.gray.dark.10": {
    "value": "#AAABAA",
    "variable": "var(--colors-gray-dark-10)"
  },
  "colors.gray.dark.11": {
    "value": "#CECFCF",
    "variable": "var(--colors-gray-dark-11)"
  },
  "colors.gray.dark.12": {
    "value": "#FBFBFB",
    "variable": "var(--colors-gray-dark-12)"
  },
  "colors.gray.dark.a1": {
    "value": "#94969503",
    "variable": "var(--colors-gray-dark-a1)"
  },
  "colors.gray.dark.a2": {
    "value": "#9496950A",
    "variable": "var(--colors-gray-dark-a2)"
  },
  "colors.gray.dark.a3": {
    "value": "#9496950D",
    "variable": "var(--colors-gray-dark-a3)"
  },
  "colors.gray.dark.a4": {
    "value": "#9496951C",
    "variable": "var(--colors-gray-dark-a4)"
  },
  "colors.gray.dark.a5": {
    "value": "#94969521",
    "variable": "var(--colors-gray-dark-a5)"
  },
  "colors.gray.dark.a6": {
    "value": "#9496952B",
    "variable": "var(--colors-gray-dark-a6)"
  },
  "colors.gray.dark.a7": {
    "value": "#9496953B",
    "variable": "var(--colors-gray-dark-a7)"
  },
  "colors.gray.dark.a8": {
    "value": "#94969554",
    "variable": "var(--colors-gray-dark-a8)"
  },
  "colors.gray.dark.a9": {
    "value": "#94969563",
    "variable": "var(--colors-gray-dark-a9)"
  },
  "colors.gray.dark.a10": {
    "value": "#94969573",
    "variable": "var(--colors-gray-dark-a10)"
  },
  "colors.gray.dark.a11": {
    "value": "#949695B0",
    "variable": "var(--colors-gray-dark-a11)"
  },
  "colors.gray.dark.a12": {
    "value": "#949695ED",
    "variable": "var(--colors-gray-dark-a12)"
  },
  "colors.terra.light.1": {
    "value": "#FFFBF9",
    "variable": "var(--colors-terra-light-1)"
  },
  "colors.terra.light.2": {
    "value": "#FFF4F1",
    "variable": "var(--colors-terra-light-2)"
  },
  "colors.terra.light.3": {
    "value": "#FFE9E3",
    "variable": "var(--colors-terra-light-3)"
  },
  "colors.terra.light.4": {
    "value": "#FEDCD2",
    "variable": "var(--colors-terra-light-4)"
  },
  "colors.terra.light.5": {
    "value": "#FDCDBE",
    "variable": "var(--colors-terra-light-5)"
  },
  "colors.terra.light.6": {
    "value": "#FABBA8",
    "variable": "var(--colors-terra-light-6)"
  },
  "colors.terra.light.7": {
    "value": "#F5A38A",
    "variable": "var(--colors-terra-light-7)"
  },
  "colors.terra.light.8": {
    "value": "#EF8769",
    "variable": "var(--colors-terra-light-8)"
  },
  "colors.terra.light.9": {
    "value": "#E65C32",
    "variable": "var(--colors-terra-light-9)"
  },
  "colors.terra.light.10": {
    "value": "#C24A00",
    "variable": "var(--colors-terra-light-10)"
  },
  "colors.terra.light.11": {
    "value": "#C02F00",
    "variable": "var(--colors-terra-light-11)"
  },
  "colors.terra.light.12": {
    "value": "#5F0000",
    "variable": "var(--colors-terra-light-12)"
  },
  "colors.terra.light.a1": {
    "value": "#E65C3205",
    "variable": "var(--colors-terra-light-a1)"
  },
  "colors.terra.light.a2": {
    "value": "#E65C320A",
    "variable": "var(--colors-terra-light-a2)"
  },
  "colors.terra.light.a3": {
    "value": "#E65C3212",
    "variable": "var(--colors-terra-light-a3)"
  },
  "colors.terra.light.a4": {
    "value": "#E65C321C",
    "variable": "var(--colors-terra-light-a4)"
  },
  "colors.terra.light.a5": {
    "value": "#E65C3226",
    "variable": "var(--colors-terra-light-a5)"
  },
  "colors.terra.light.a6": {
    "value": "#E65C3233",
    "variable": "var(--colors-terra-light-a6)"
  },
  "colors.terra.light.a7": {
    "value": "#E65C3247",
    "variable": "var(--colors-terra-light-a7)"
  },
  "colors.terra.light.a8": {
    "value": "#E65C3261",
    "variable": "var(--colors-terra-light-a8)"
  },
  "colors.terra.light.a9": {
    "value": "#E65C3280",
    "variable": "var(--colors-terra-light-a9)"
  },
  "colors.terra.light.a10": {
    "value": "#E65C329E",
    "variable": "var(--colors-terra-light-a10)"
  },
  "colors.terra.light.a11": {
    "value": "#E65C32BF",
    "variable": "var(--colors-terra-light-a11)"
  },
  "colors.terra.light.a12": {
    "value": "#E65C32EB",
    "variable": "var(--colors-terra-light-a12)"
  },
  "colors.terra.dark.1": {
    "value": "#200803",
    "variable": "var(--colors-terra-dark-1)"
  },
  "colors.terra.dark.2": {
    "value": "#2E0B03",
    "variable": "var(--colors-terra-dark-2)"
  },
  "colors.terra.dark.3": {
    "value": "#401103",
    "variable": "var(--colors-terra-dark-3)"
  },
  "colors.terra.dark.4": {
    "value": "#511604",
    "variable": "var(--colors-terra-dark-4)"
  },
  "colors.terra.dark.5": {
    "value": "#611C05",
    "variable": "var(--colors-terra-dark-5)"
  },
  "colors.terra.dark.6": {
    "value": "#72240B",
    "variable": "var(--colors-terra-dark-6)"
  },
  "colors.terra.dark.7": {
    "value": "#883116",
    "variable": "var(--colors-terra-dark-7)"
  },
  "colors.terra.dark.8": {
    "value": "#A44427",
    "variable": "var(--colors-terra-dark-8)"
  },
  "colors.terra.dark.9": {
    "value": "#E65C32",
    "variable": "var(--colors-terra-dark-9)"
  },
  "colors.terra.dark.10": {
    "value": "#F26A42",
    "variable": "var(--colors-terra-dark-10)"
  },
  "colors.terra.dark.11": {
    "value": "#FF8A65",
    "variable": "var(--colors-terra-dark-11)"
  },
  "colors.terra.dark.12": {
    "value": "#FFD2BF",
    "variable": "var(--colors-terra-dark-12)"
  },
  "colors.terra.dark.a1": {
    "value": "#E65C3205",
    "variable": "var(--colors-terra-dark-a1)"
  },
  "colors.terra.dark.a2": {
    "value": "#E65C320D",
    "variable": "var(--colors-terra-dark-a2)"
  },
  "colors.terra.dark.a3": {
    "value": "#E65C321A",
    "variable": "var(--colors-terra-dark-a3)"
  },
  "colors.terra.dark.a4": {
    "value": "#E65C3229",
    "variable": "var(--colors-terra-dark-a4)"
  },
  "colors.terra.dark.a5": {
    "value": "#E65C3238",
    "variable": "var(--colors-terra-dark-a5)"
  },
  "colors.terra.dark.a6": {
    "value": "#E65C324D",
    "variable": "var(--colors-terra-dark-a6)"
  },
  "colors.terra.dark.a7": {
    "value": "#E65C3266",
    "variable": "var(--colors-terra-dark-a7)"
  },
  "colors.terra.dark.a8": {
    "value": "#E65C3285",
    "variable": "var(--colors-terra-dark-a8)"
  },
  "colors.terra.dark.a9": {
    "value": "#E65C32B3",
    "variable": "var(--colors-terra-dark-a9)"
  },
  "colors.terra.dark.a10": {
    "value": "#E65C32CC",
    "variable": "var(--colors-terra-dark-a10)"
  },
  "colors.terra.dark.a11": {
    "value": "#E65C32E6",
    "variable": "var(--colors-terra-dark-a11)"
  },
  "colors.terra.dark.a12": {
    "value": "#E65C32F5",
    "variable": "var(--colors-terra-dark-a12)"
  },
  "colors.lilac.light.1": {
    "value": "#fdfdfe",
    "variable": "var(--colors-lilac-light-1)"
  },
  "colors.lilac.light.2": {
    "value": "#f8f8fd",
    "variable": "var(--colors-lilac-light-2)"
  },
  "colors.lilac.light.3": {
    "value": "#f2f1f9",
    "variable": "var(--colors-lilac-light-3)"
  },
  "colors.lilac.light.4": {
    "value": "#e8e8f8",
    "variable": "var(--colors-lilac-light-4)"
  },
  "colors.lilac.light.5": {
    "value": "#deddf4",
    "variable": "var(--colors-lilac-light-5)"
  },
  "colors.lilac.light.6": {
    "value": "#d1cfee",
    "variable": "var(--colors-lilac-light-6)"
  },
  "colors.lilac.light.7": {
    "value": "#bebbe2",
    "variable": "var(--colors-lilac-light-7)"
  },
  "colors.lilac.light.8": {
    "value": "#a5a2ce",
    "variable": "var(--colors-lilac-light-8)"
  },
  "colors.lilac.light.9": {
    "value": "#6d6992",
    "variable": "var(--colors-lilac-light-9)"
  },
  "colors.lilac.light.10": {
    "value": "#605c84",
    "variable": "var(--colors-lilac-light-10)"
  },
  "colors.lilac.light.11": {
    "value": "#646089",
    "variable": "var(--colors-lilac-light-11)"
  },
  "colors.lilac.light.12": {
    "value": "#302c4e",
    "variable": "var(--colors-lilac-light-12)"
  },
  "colors.lilac.light.a1": {
    "value": "#00008002",
    "variable": "var(--colors-lilac-light-a1)"
  },
  "colors.lilac.light.a2": {
    "value": "#0000b707",
    "variable": "var(--colors-lilac-light-a2)"
  },
  "colors.lilac.light.a3": {
    "value": "#1300920e",
    "variable": "var(--colors-lilac-light-a3)"
  },
  "colors.lilac.light.a4": {
    "value": "#0000b217",
    "variable": "var(--colors-lilac-light-a4)"
  },
  "colors.lilac.light.a5": {
    "value": "#0800ad22",
    "variable": "var(--colors-lilac-light-a5)"
  },
  "colors.lilac.light.a6": {
    "value": "#0b00a530",
    "variable": "var(--colors-lilac-light-a6)"
  },
  "colors.lilac.light.a7": {
    "value": "#0c009344",
    "variable": "var(--colors-lilac-light-a7)"
  },
  "colors.lilac.light.a8": {
    "value": "#0900795d",
    "variable": "var(--colors-lilac-light-a8)"
  },
  "colors.lilac.light.a9": {
    "value": "#07004696",
    "variable": "var(--colors-lilac-light-a9)"
  },
  "colors.lilac.light.a10": {
    "value": "#07003fa3",
    "variable": "var(--colors-lilac-light-a10)"
  },
  "colors.lilac.light.a11": {
    "value": "#0700429f",
    "variable": "var(--colors-lilac-light-a11)"
  },
  "colors.lilac.light.a12": {
    "value": "#050029d3",
    "variable": "var(--colors-lilac-light-a12)"
  },
  "colors.lilac.dark.1": {
    "value": "#17151f",
    "variable": "var(--colors-lilac-dark-1)"
  },
  "colors.lilac.dark.2": {
    "value": "#1c1a28",
    "variable": "var(--colors-lilac-dark-2)"
  },
  "colors.lilac.dark.3": {
    "value": "#251f34",
    "variable": "var(--colors-lilac-dark-3)"
  },
  "colors.lilac.dark.4": {
    "value": "#2c2440",
    "variable": "var(--colors-lilac-dark-4)"
  },
  "colors.lilac.dark.5": {
    "value": "#32294c",
    "variable": "var(--colors-lilac-dark-5)"
  },
  "colors.lilac.dark.6": {
    "value": "#392f5a",
    "variable": "var(--colors-lilac-dark-6)"
  },
  "colors.lilac.dark.7": {
    "value": "#443869",
    "variable": "var(--colors-lilac-dark-7)"
  },
  "colors.lilac.dark.8": {
    "value": "#52457d",
    "variable": "var(--colors-lilac-dark-8)"
  },
  "colors.lilac.dark.9": {
    "value": "#6d6992",
    "variable": "var(--colors-lilac-dark-9)"
  },
  "colors.lilac.dark.10": {
    "value": "#605c84",
    "variable": "var(--colors-lilac-dark-10)"
  },
  "colors.lilac.dark.11": {
    "value": "#9690b3",
    "variable": "var(--colors-lilac-dark-11)"
  },
  "colors.lilac.dark.12": {
    "value": "#e3e1f2",
    "variable": "var(--colors-lilac-dark-12)"
  },
  "colors.lilac.dark.a1": {
    "value": "#2b20ff0a",
    "variable": "var(--colors-lilac-dark-a1)"
  },
  "colors.lilac.dark.a2": {
    "value": "#4f3dff13",
    "variable": "var(--colors-lilac-dark-a2)"
  },
  "colors.lilac.dark.a3": {
    "value": "#4f38ff20",
    "variable": "var(--colors-lilac-dark-a3)"
  },
  "colors.lilac.dark.a4": {
    "value": "#5437ff2d",
    "variable": "var(--colors-lilac-dark-a4)"
  },
  "colors.lilac.dark.a5": {
    "value": "#5737ff39",
    "variable": "var(--colors-lilac-dark-a5)"
  },
  "colors.lilac.dark.a6": {
    "value": "#5c38ff47",
    "variable": "var(--colors-lilac-dark-a6)"
  },
  "colors.lilac.dark.a7": {
    "value": "#623aff57",
    "variable": "var(--colors-lilac-dark-a7)"
  },
  "colors.lilac.dark.a8": {
    "value": "#673eff6b",
    "variable": "var(--colors-lilac-dark-a8)"
  },
  "colors.lilac.dark.a9": {
    "value": "#6d6992",
    "variable": "var(--colors-lilac-dark-a9)"
  },
  "colors.lilac.dark.a10": {
    "value": "#605c84",
    "variable": "var(--colors-lilac-dark-a10)"
  },
  "colors.lilac.dark.a11": {
    "value": "#9690b3",
    "variable": "var(--colors-lilac-dark-a11)"
  },
  "colors.lilac.dark.a12": {
    "value": "#e3e1f2",
    "variable": "var(--colors-lilac-dark-a12)"
  },
  "colors.moss.light.1": {
    "value": "#F9FDFB",
    "variable": "var(--colors-moss-light-1)"
  },
  "colors.moss.light.2": {
    "value": "#F1F9F5",
    "variable": "var(--colors-moss-light-2)"
  },
  "colors.moss.light.3": {
    "value": "#E2F3EA",
    "variable": "var(--colors-moss-light-3)"
  },
  "colors.moss.light.4": {
    "value": "#CFECDC",
    "variable": "var(--colors-moss-light-4)"
  },
  "colors.moss.light.5": {
    "value": "#B7E4CC",
    "variable": "var(--colors-moss-light-5)"
  },
  "colors.moss.light.6": {
    "value": "#9DDABB",
    "variable": "var(--colors-moss-light-6)"
  },
  "colors.moss.light.7": {
    "value": "#78CDA4",
    "variable": "var(--colors-moss-light-7)"
  },
  "colors.moss.light.8": {
    "value": "#42BC89",
    "variable": "var(--colors-moss-light-8)"
  },
  "colors.moss.light.9": {
    "value": "#00A269",
    "variable": "var(--colors-moss-light-9)"
  },
  "colors.moss.light.10": {
    "value": "#183829",
    "variable": "var(--colors-moss-light-10)"
  },
  "colors.moss.light.11": {
    "value": "#254234",
    "variable": "var(--colors-moss-light-11)"
  },
  "colors.moss.light.12": {
    "value": "#133224",
    "variable": "var(--colors-moss-light-12)"
  },
  "colors.moss.dark.1": {
    "value": "#000F06",
    "variable": "var(--colors-moss-dark-1)"
  },
  "colors.moss.dark.2": {
    "value": "#00180A",
    "variable": "var(--colors-moss-dark-2)"
  },
  "colors.moss.dark.3": {
    "value": "#00230F",
    "variable": "var(--colors-moss-dark-3)"
  },
  "colors.moss.dark.4": {
    "value": "#002F15",
    "variable": "var(--colors-moss-dark-4)"
  },
  "colors.moss.dark.5": {
    "value": "#003C1C",
    "variable": "var(--colors-moss-dark-5)"
  },
  "colors.moss.dark.6": {
    "value": "#004925",
    "variable": "var(--colors-moss-dark-6)"
  },
  "colors.moss.dark.7": {
    "value": "#005B31",
    "variable": "var(--colors-moss-dark-7)"
  },
  "colors.moss.dark.8": {
    "value": "#007242",
    "variable": "var(--colors-moss-dark-8)"
  },
  "colors.moss.dark.9": {
    "value": "#008E59",
    "variable": "var(--colors-moss-dark-9)"
  },
  "colors.moss.dark.10": {
    "value": "#00A670",
    "variable": "var(--colors-moss-dark-10)"
  },
  "colors.moss.dark.11": {
    "value": "#56CB98",
    "variable": "var(--colors-moss-dark-11)"
  },
  "colors.moss.dark.12": {
    "value": "#C2F6DB",
    "variable": "var(--colors-moss-dark-12)"
  },
  "colors.red.light.1": {
    "value": "#FEFBFA",
    "variable": "var(--colors-red-light-1)"
  },
  "colors.red.light.2": {
    "value": "#FDF4F3",
    "variable": "var(--colors-red-light-2)"
  },
  "colors.red.light.3": {
    "value": "#FFE9E5",
    "variable": "var(--colors-red-light-3)"
  },
  "colors.red.light.4": {
    "value": "#FFD9D3",
    "variable": "var(--colors-red-light-4)"
  },
  "colors.red.light.5": {
    "value": "#FFC8BE",
    "variable": "var(--colors-red-light-5)"
  },
  "colors.red.light.6": {
    "value": "#FFB4A8",
    "variable": "var(--colors-red-light-6)"
  },
  "colors.red.light.7": {
    "value": "#FF998A",
    "variable": "var(--colors-red-light-7)"
  },
  "colors.red.light.8": {
    "value": "#F97867",
    "variable": "var(--colors-red-light-8)"
  },
  "colors.red.light.9": {
    "value": "#CC0000",
    "variable": "var(--colors-red-light-9)"
  },
  "colors.red.light.10": {
    "value": "#BD0000",
    "variable": "var(--colors-red-light-10)"
  },
  "colors.red.light.11": {
    "value": "#A50000",
    "variable": "var(--colors-red-light-11)"
  },
  "colors.red.light.12": {
    "value": "#5F0000",
    "variable": "var(--colors-red-light-12)"
  },
  "colors.red.light.a1": {
    "value": "#ff000003",
    "variable": "var(--colors-red-light-a1)"
  },
  "colors.red.light.a2": {
    "value": "#ff000008",
    "variable": "var(--colors-red-light-a2)"
  },
  "colors.red.light.a3": {
    "value": "#f3000d14",
    "variable": "var(--colors-red-light-a3)"
  },
  "colors.red.light.a4": {
    "value": "#ff000824",
    "variable": "var(--colors-red-light-a4)"
  },
  "colors.red.light.a5": {
    "value": "#ff000632",
    "variable": "var(--colors-red-light-a5)"
  },
  "colors.red.light.a6": {
    "value": "#f8000442",
    "variable": "var(--colors-red-light-a6)"
  },
  "colors.red.light.a7": {
    "value": "#df000356",
    "variable": "var(--colors-red-light-a7)"
  },
  "colors.red.light.a8": {
    "value": "#d2000571",
    "variable": "var(--colors-red-light-a8)"
  },
  "colors.red.light.a9": {
    "value": "#db0007b7",
    "variable": "var(--colors-red-light-a9)"
  },
  "colors.red.light.a10": {
    "value": "#d10005c1",
    "variable": "var(--colors-red-light-a10)"
  },
  "colors.red.light.a11": {
    "value": "#c40006d3",
    "variable": "var(--colors-red-light-a11)"
  },
  "colors.red.light.a12": {
    "value": "#55000de8",
    "variable": "var(--colors-red-light-a12)"
  },
  "colors.red.dark.1": {
    "value": "#180503",
    "variable": "var(--colors-red-dark-1)"
  },
  "colors.red.dark.2": {
    "value": "#250705",
    "variable": "var(--colors-red-dark-2)"
  },
  "colors.red.dark.3": {
    "value": "#360A06",
    "variable": "var(--colors-red-dark-3)"
  },
  "colors.red.dark.4": {
    "value": "#480C07",
    "variable": "var(--colors-red-dark-4)"
  },
  "colors.red.dark.5": {
    "value": "#59100B",
    "variable": "var(--colors-red-dark-5)"
  },
  "colors.red.dark.6": {
    "value": "#6B1811",
    "variable": "var(--colors-red-dark-6)"
  },
  "colors.red.dark.7": {
    "value": "#822219",
    "variable": "var(--colors-red-dark-7)"
  },
  "colors.red.dark.8": {
    "value": "#9F3025",
    "variable": "var(--colors-red-dark-8)"
  },
  "colors.red.dark.9": {
    "value": "#CC0000",
    "variable": "var(--colors-red-dark-9)"
  },
  "colors.red.dark.10": {
    "value": "#D72D22",
    "variable": "var(--colors-red-dark-10)"
  },
  "colors.red.dark.11": {
    "value": "#E7594A",
    "variable": "var(--colors-red-dark-11)"
  },
  "colors.red.dark.12": {
    "value": "#FFD4C8",
    "variable": "var(--colors-red-dark-12)"
  },
  "colors.red.dark.a1": {
    "value": "#f4121209",
    "variable": "var(--colors-red-dark-a1)"
  },
  "colors.red.dark.a2": {
    "value": "#f22f3e11",
    "variable": "var(--colors-red-dark-a2)"
  },
  "colors.red.dark.a3": {
    "value": "#ff173f2d",
    "variable": "var(--colors-red-dark-a3)"
  },
  "colors.red.dark.a4": {
    "value": "#fe0a3b44",
    "variable": "var(--colors-red-dark-a4)"
  },
  "colors.red.dark.a5": {
    "value": "#ff204756",
    "variable": "var(--colors-red-dark-a5)"
  },
  "colors.red.dark.a6": {
    "value": "#ff3e5668",
    "variable": "var(--colors-red-dark-a6)"
  },
  "colors.red.dark.a7": {
    "value": "#ff536184",
    "variable": "var(--colors-red-dark-a7)"
  },
  "colors.red.dark.a8": {
    "value": "#ff5d61b0",
    "variable": "var(--colors-red-dark-a8)"
  },
  "colors.red.dark.a9": {
    "value": "#fe4e54e4",
    "variable": "var(--colors-red-dark-a9)"
  },
  "colors.red.dark.a10": {
    "value": "#ff6465eb",
    "variable": "var(--colors-red-dark-a10)"
  },
  "colors.red.dark.a11": {
    "value": "#ff9592",
    "variable": "var(--colors-red-dark-a11)"
  },
  "colors.red.dark.a12": {
    "value": "#ffd1d9",
    "variable": "var(--colors-red-dark-a12)"
  },
  "colors.violet.light.1": {
    "value": "#fdfcfe",
    "variable": "var(--colors-violet-light-1)"
  },
  "colors.violet.light.2": {
    "value": "#faf8ff",
    "variable": "var(--colors-violet-light-2)"
  },
  "colors.violet.light.3": {
    "value": "#f4f0fe",
    "variable": "var(--colors-violet-light-3)"
  },
  "colors.violet.light.4": {
    "value": "#ebe4ff",
    "variable": "var(--colors-violet-light-4)"
  },
  "colors.violet.light.5": {
    "value": "#e1d9ff",
    "variable": "var(--colors-violet-light-5)"
  },
  "colors.violet.light.6": {
    "value": "#d4cafe",
    "variable": "var(--colors-violet-light-6)"
  },
  "colors.violet.light.7": {
    "value": "#c2b5f5",
    "variable": "var(--colors-violet-light-7)"
  },
  "colors.violet.light.8": {
    "value": "#aa99ec",
    "variable": "var(--colors-violet-light-8)"
  },
  "colors.violet.light.9": {
    "value": "#6e56cf",
    "variable": "var(--colors-violet-light-9)"
  },
  "colors.violet.light.10": {
    "value": "#654dc4",
    "variable": "var(--colors-violet-light-10)"
  },
  "colors.violet.light.11": {
    "value": "#6550b9",
    "variable": "var(--colors-violet-light-11)"
  },
  "colors.violet.light.12": {
    "value": "#2f265f",
    "variable": "var(--colors-violet-light-12)"
  },
  "colors.violet.light.a1": {
    "value": "#5500aa03",
    "variable": "var(--colors-violet-light-a1)"
  },
  "colors.violet.light.a2": {
    "value": "#4900ff07",
    "variable": "var(--colors-violet-light-a2)"
  },
  "colors.violet.light.a3": {
    "value": "#4400ee0f",
    "variable": "var(--colors-violet-light-a3)"
  },
  "colors.violet.light.a4": {
    "value": "#4300ff1b",
    "variable": "var(--colors-violet-light-a4)"
  },
  "colors.violet.light.a5": {
    "value": "#3600ff26",
    "variable": "var(--colors-violet-light-a5)"
  },
  "colors.violet.light.a6": {
    "value": "#3100fb35",
    "variable": "var(--colors-violet-light-a6)"
  },
  "colors.violet.light.a7": {
    "value": "#2d01dd4a",
    "variable": "var(--colors-violet-light-a7)"
  },
  "colors.violet.light.a8": {
    "value": "#2b00d066",
    "variable": "var(--colors-violet-light-a8)"
  },
  "colors.violet.light.a9": {
    "value": "#2400b7a9",
    "variable": "var(--colors-violet-light-a9)"
  },
  "colors.violet.light.a10": {
    "value": "#2300abb2",
    "variable": "var(--colors-violet-light-a10)"
  },
  "colors.violet.light.a11": {
    "value": "#1f0099af",
    "variable": "var(--colors-violet-light-a11)"
  },
  "colors.violet.light.a12": {
    "value": "#0b0043d9",
    "variable": "var(--colors-violet-light-a12)"
  },
  "colors.violet.dark.1": {
    "value": "#14121f",
    "variable": "var(--colors-violet-dark-1)"
  },
  "colors.violet.dark.2": {
    "value": "#1b1525",
    "variable": "var(--colors-violet-dark-2)"
  },
  "colors.violet.dark.3": {
    "value": "#291f43",
    "variable": "var(--colors-violet-dark-3)"
  },
  "colors.violet.dark.4": {
    "value": "#33255b",
    "variable": "var(--colors-violet-dark-4)"
  },
  "colors.violet.dark.5": {
    "value": "#3c2e69",
    "variable": "var(--colors-violet-dark-5)"
  },
  "colors.violet.dark.6": {
    "value": "#473876",
    "variable": "var(--colors-violet-dark-6)"
  },
  "colors.violet.dark.7": {
    "value": "#56468b",
    "variable": "var(--colors-violet-dark-7)"
  },
  "colors.violet.dark.8": {
    "value": "#6958ad",
    "variable": "var(--colors-violet-dark-8)"
  },
  "colors.violet.dark.9": {
    "value": "#6e56cf",
    "variable": "var(--colors-violet-dark-9)"
  },
  "colors.violet.dark.10": {
    "value": "#7d66d9",
    "variable": "var(--colors-violet-dark-10)"
  },
  "colors.violet.dark.11": {
    "value": "#baa7ff",
    "variable": "var(--colors-violet-dark-11)"
  },
  "colors.violet.dark.12": {
    "value": "#e2ddfe",
    "variable": "var(--colors-violet-dark-12)"
  },
  "colors.violet.dark.a1": {
    "value": "#4422ff0f",
    "variable": "var(--colors-violet-dark-a1)"
  },
  "colors.violet.dark.a2": {
    "value": "#853ff916",
    "variable": "var(--colors-violet-dark-a2)"
  },
  "colors.violet.dark.a3": {
    "value": "#8354fe36",
    "variable": "var(--colors-violet-dark-a3)"
  },
  "colors.violet.dark.a4": {
    "value": "#7d51fd50",
    "variable": "var(--colors-violet-dark-a4)"
  },
  "colors.violet.dark.a5": {
    "value": "#845ffd5f",
    "variable": "var(--colors-violet-dark-a5)"
  },
  "colors.violet.dark.a6": {
    "value": "#8f6cfd6d",
    "variable": "var(--colors-violet-dark-a6)"
  },
  "colors.violet.dark.a7": {
    "value": "#9879ff83",
    "variable": "var(--colors-violet-dark-a7)"
  },
  "colors.violet.dark.a8": {
    "value": "#977dfea8",
    "variable": "var(--colors-violet-dark-a8)"
  },
  "colors.violet.dark.a9": {
    "value": "#8668ffcc",
    "variable": "var(--colors-violet-dark-a9)"
  },
  "colors.violet.dark.a10": {
    "value": "#9176fed7",
    "variable": "var(--colors-violet-dark-a10)"
  },
  "colors.violet.dark.a11": {
    "value": "#baa7ff",
    "variable": "var(--colors-violet-dark-a11)"
  },
  "colors.violet.dark.a12": {
    "value": "#e3defffe",
    "variable": "var(--colors-violet-dark-a12)"
  },
  "colors.yellow.light.1": {
    "value": "#fdfdf9",
    "variable": "var(--colors-yellow-light-1)"
  },
  "colors.yellow.light.2": {
    "value": "#fefce9",
    "variable": "var(--colors-yellow-light-2)"
  },
  "colors.yellow.light.3": {
    "value": "#fffab8",
    "variable": "var(--colors-yellow-light-3)"
  },
  "colors.yellow.light.4": {
    "value": "#fff394",
    "variable": "var(--colors-yellow-light-4)"
  },
  "colors.yellow.light.5": {
    "value": "#ffe770",
    "variable": "var(--colors-yellow-light-5)"
  },
  "colors.yellow.light.6": {
    "value": "#f3d768",
    "variable": "var(--colors-yellow-light-6)"
  },
  "colors.yellow.light.7": {
    "value": "#e4c767",
    "variable": "var(--colors-yellow-light-7)"
  },
  "colors.yellow.light.8": {
    "value": "#d5ae39",
    "variable": "var(--colors-yellow-light-8)"
  },
  "colors.yellow.light.9": {
    "value": "#ffe629",
    "variable": "var(--colors-yellow-light-9)"
  },
  "colors.yellow.light.10": {
    "value": "#ffdc00",
    "variable": "var(--colors-yellow-light-10)"
  },
  "colors.yellow.light.11": {
    "value": "#9e6c00",
    "variable": "var(--colors-yellow-light-11)"
  },
  "colors.yellow.light.12": {
    "value": "#473b1f",
    "variable": "var(--colors-yellow-light-12)"
  },
  "colors.yellow.light.a1": {
    "value": "#aaaa0006",
    "variable": "var(--colors-yellow-light-a1)"
  },
  "colors.yellow.light.a2": {
    "value": "#f4dd0016",
    "variable": "var(--colors-yellow-light-a2)"
  },
  "colors.yellow.light.a3": {
    "value": "#ffee0047",
    "variable": "var(--colors-yellow-light-a3)"
  },
  "colors.yellow.light.a4": {
    "value": "#ffe3016b",
    "variable": "var(--colors-yellow-light-a4)"
  },
  "colors.yellow.light.a5": {
    "value": "#ffd5008f",
    "variable": "var(--colors-yellow-light-a5)"
  },
  "colors.yellow.light.a6": {
    "value": "#ebbc0097",
    "variable": "var(--colors-yellow-light-a6)"
  },
  "colors.yellow.light.a7": {
    "value": "#d2a10098",
    "variable": "var(--colors-yellow-light-a7)"
  },
  "colors.yellow.light.a8": {
    "value": "#c99700c6",
    "variable": "var(--colors-yellow-light-a8)"
  },
  "colors.yellow.light.a9": {
    "value": "#ffe100d6",
    "variable": "var(--colors-yellow-light-a9)"
  },
  "colors.yellow.light.a10": {
    "value": "#ffdc00",
    "variable": "var(--colors-yellow-light-a10)"
  },
  "colors.yellow.light.a11": {
    "value": "#9e6c00",
    "variable": "var(--colors-yellow-light-a11)"
  },
  "colors.yellow.light.a12": {
    "value": "#2e2000e0",
    "variable": "var(--colors-yellow-light-a12)"
  },
  "colors.yellow.dark.1": {
    "value": "#14120b",
    "variable": "var(--colors-yellow-dark-1)"
  },
  "colors.yellow.dark.2": {
    "value": "#1b180f",
    "variable": "var(--colors-yellow-dark-2)"
  },
  "colors.yellow.dark.3": {
    "value": "#2d2305",
    "variable": "var(--colors-yellow-dark-3)"
  },
  "colors.yellow.dark.4": {
    "value": "#362b00",
    "variable": "var(--colors-yellow-dark-4)"
  },
  "colors.yellow.dark.5": {
    "value": "#433500",
    "variable": "var(--colors-yellow-dark-5)"
  },
  "colors.yellow.dark.6": {
    "value": "#524202",
    "variable": "var(--colors-yellow-dark-6)"
  },
  "colors.yellow.dark.7": {
    "value": "#665417",
    "variable": "var(--colors-yellow-dark-7)"
  },
  "colors.yellow.dark.8": {
    "value": "#836a21",
    "variable": "var(--colors-yellow-dark-8)"
  },
  "colors.yellow.dark.9": {
    "value": "#ffe629",
    "variable": "var(--colors-yellow-dark-9)"
  },
  "colors.yellow.dark.10": {
    "value": "#ffff57",
    "variable": "var(--colors-yellow-dark-10)"
  },
  "colors.yellow.dark.11": {
    "value": "#f5e147",
    "variable": "var(--colors-yellow-dark-11)"
  },
  "colors.yellow.dark.12": {
    "value": "#f6eeb4",
    "variable": "var(--colors-yellow-dark-12)"
  },
  "colors.yellow.dark.a1": {
    "value": "#d1510004",
    "variable": "var(--colors-yellow-dark-a1)"
  },
  "colors.yellow.dark.a2": {
    "value": "#f9b4000b",
    "variable": "var(--colors-yellow-dark-a2)"
  },
  "colors.yellow.dark.a3": {
    "value": "#ffaa001e",
    "variable": "var(--colors-yellow-dark-a3)"
  },
  "colors.yellow.dark.a4": {
    "value": "#fdb70028",
    "variable": "var(--colors-yellow-dark-a4)"
  },
  "colors.yellow.dark.a5": {
    "value": "#febb0036",
    "variable": "var(--colors-yellow-dark-a5)"
  },
  "colors.yellow.dark.a6": {
    "value": "#fec40046",
    "variable": "var(--colors-yellow-dark-a6)"
  },
  "colors.yellow.dark.a7": {
    "value": "#fdcb225c",
    "variable": "var(--colors-yellow-dark-a7)"
  },
  "colors.yellow.dark.a8": {
    "value": "#fdca327b",
    "variable": "var(--colors-yellow-dark-a8)"
  },
  "colors.yellow.dark.a9": {
    "value": "#ffe629",
    "variable": "var(--colors-yellow-dark-a9)"
  },
  "colors.yellow.dark.a10": {
    "value": "#ffff57",
    "variable": "var(--colors-yellow-dark-a10)"
  },
  "colors.yellow.dark.a11": {
    "value": "#fee949f5",
    "variable": "var(--colors-yellow-dark-a11)"
  },
  "colors.yellow.dark.a12": {
    "value": "#fef6baf6",
    "variable": "var(--colors-yellow-dark-a12)"
  },
  "colors.orange.light.1": {
    "value": "#fefcfb",
    "variable": "var(--colors-orange-light-1)"
  },
  "colors.orange.light.2": {
    "value": "#fff7ed",
    "variable": "var(--colors-orange-light-2)"
  },
  "colors.orange.light.3": {
    "value": "#ffefd6",
    "variable": "var(--colors-orange-light-3)"
  },
  "colors.orange.light.4": {
    "value": "#ffdfb5",
    "variable": "var(--colors-orange-light-4)"
  },
  "colors.orange.light.5": {
    "value": "#ffd19a",
    "variable": "var(--colors-orange-light-5)"
  },
  "colors.orange.light.6": {
    "value": "#ffc182",
    "variable": "var(--colors-orange-light-6)"
  },
  "colors.orange.light.7": {
    "value": "#f5ae73",
    "variable": "var(--colors-orange-light-7)"
  },
  "colors.orange.light.8": {
    "value": "#ec9455",
    "variable": "var(--colors-orange-light-8)"
  },
  "colors.orange.light.9": {
    "value": "#f76b15",
    "variable": "var(--colors-orange-light-9)"
  },
  "colors.orange.light.10": {
    "value": "#ef5f00",
    "variable": "var(--colors-orange-light-10)"
  },
  "colors.orange.light.11": {
    "value": "#cc4e00",
    "variable": "var(--colors-orange-light-11)"
  },
  "colors.orange.light.12": {
    "value": "#582d1d",
    "variable": "var(--colors-orange-light-12)"
  },
  "colors.orange.light.a1": {
    "value": "#c0400004",
    "variable": "var(--colors-orange-light-a1)"
  },
  "colors.orange.light.a2": {
    "value": "#ff8e0012",
    "variable": "var(--colors-orange-light-a2)"
  },
  "colors.orange.light.a3": {
    "value": "#ff9c0029",
    "variable": "var(--colors-orange-light-a3)"
  },
  "colors.orange.light.a4": {
    "value": "#ff91014a",
    "variable": "var(--colors-orange-light-a4)"
  },
  "colors.orange.light.a5": {
    "value": "#ff8b0065",
    "variable": "var(--colors-orange-light-a5)"
  },
  "colors.orange.light.a6": {
    "value": "#ff81007d",
    "variable": "var(--colors-orange-light-a6)"
  },
  "colors.orange.light.a7": {
    "value": "#ed6c008c",
    "variable": "var(--colors-orange-light-a7)"
  },
  "colors.orange.light.a8": {
    "value": "#e35f00aa",
    "variable": "var(--colors-orange-light-a8)"
  },
  "colors.orange.light.a9": {
    "value": "#f65e00ea",
    "variable": "var(--colors-orange-light-a9)"
  },
  "colors.orange.light.a10": {
    "value": "#ef5f00",
    "variable": "var(--colors-orange-light-a10)"
  },
  "colors.orange.light.a11": {
    "value": "#cc4e00",
    "variable": "var(--colors-orange-light-a11)"
  },
  "colors.orange.light.a12": {
    "value": "#431200e2",
    "variable": "var(--colors-orange-light-a12)"
  },
  "colors.orange.dark.1": {
    "value": "#17120e",
    "variable": "var(--colors-orange-dark-1)"
  },
  "colors.orange.dark.2": {
    "value": "#1e160f",
    "variable": "var(--colors-orange-dark-2)"
  },
  "colors.orange.dark.3": {
    "value": "#331e0b",
    "variable": "var(--colors-orange-dark-3)"
  },
  "colors.orange.dark.4": {
    "value": "#462100",
    "variable": "var(--colors-orange-dark-4)"
  },
  "colors.orange.dark.5": {
    "value": "#562800",
    "variable": "var(--colors-orange-dark-5)"
  },
  "colors.orange.dark.6": {
    "value": "#66350c",
    "variable": "var(--colors-orange-dark-6)"
  },
  "colors.orange.dark.7": {
    "value": "#7e451d",
    "variable": "var(--colors-orange-dark-7)"
  },
  "colors.orange.dark.8": {
    "value": "#a35829",
    "variable": "var(--colors-orange-dark-8)"
  },
  "colors.orange.dark.9": {
    "value": "#f76b15",
    "variable": "var(--colors-orange-dark-9)"
  },
  "colors.orange.dark.10": {
    "value": "#ff801f",
    "variable": "var(--colors-orange-dark-10)"
  },
  "colors.orange.dark.11": {
    "value": "#ffa057",
    "variable": "var(--colors-orange-dark-11)"
  },
  "colors.orange.dark.12": {
    "value": "#ffe0c2",
    "variable": "var(--colors-orange-dark-12)"
  },
  "colors.orange.dark.a1": {
    "value": "#ec360007",
    "variable": "var(--colors-orange-dark-a1)"
  },
  "colors.orange.dark.a2": {
    "value": "#fe6d000e",
    "variable": "var(--colors-orange-dark-a2)"
  },
  "colors.orange.dark.a3": {
    "value": "#fb6a0025",
    "variable": "var(--colors-orange-dark-a3)"
  },
  "colors.orange.dark.a4": {
    "value": "#ff590039",
    "variable": "var(--colors-orange-dark-a4)"
  },
  "colors.orange.dark.a5": {
    "value": "#ff61004a",
    "variable": "var(--colors-orange-dark-a5)"
  },
  "colors.orange.dark.a6": {
    "value": "#fd75045c",
    "variable": "var(--colors-orange-dark-a6)"
  },
  "colors.orange.dark.a7": {
    "value": "#ff832c75",
    "variable": "var(--colors-orange-dark-a7)"
  },
  "colors.orange.dark.a8": {
    "value": "#fe84389d",
    "variable": "var(--colors-orange-dark-a8)"
  },
  "colors.orange.dark.a9": {
    "value": "#fe6d15f7",
    "variable": "var(--colors-orange-dark-a9)"
  },
  "colors.orange.dark.a10": {
    "value": "#ff801f",
    "variable": "var(--colors-orange-dark-a10)"
  },
  "colors.orange.dark.a11": {
    "value": "#ffa057",
    "variable": "var(--colors-orange-dark-a11)"
  },
  "colors.orange.dark.a12": {
    "value": "#ffe0c2",
    "variable": "var(--colors-orange-dark-a12)"
  },
  "colors.green.light.1": {
    "value": "#fbfefc",
    "variable": "var(--colors-green-light-1)"
  },
  "colors.green.light.2": {
    "value": "#f4fbf6",
    "variable": "var(--colors-green-light-2)"
  },
  "colors.green.light.3": {
    "value": "#e6f6eb",
    "variable": "var(--colors-green-light-3)"
  },
  "colors.green.light.4": {
    "value": "#d6f1df",
    "variable": "var(--colors-green-light-4)"
  },
  "colors.green.light.5": {
    "value": "#c4e8d1",
    "variable": "var(--colors-green-light-5)"
  },
  "colors.green.light.6": {
    "value": "#adddc0",
    "variable": "var(--colors-green-light-6)"
  },
  "colors.green.light.7": {
    "value": "#8eceaa",
    "variable": "var(--colors-green-light-7)"
  },
  "colors.green.light.8": {
    "value": "#5bb98b",
    "variable": "var(--colors-green-light-8)"
  },
  "colors.green.light.9": {
    "value": "#30a46c",
    "variable": "var(--colors-green-light-9)"
  },
  "colors.green.light.10": {
    "value": "#2b9a66",
    "variable": "var(--colors-green-light-10)"
  },
  "colors.green.light.11": {
    "value": "#218358",
    "variable": "var(--colors-green-light-11)"
  },
  "colors.green.light.12": {
    "value": "#193b2d",
    "variable": "var(--colors-green-light-12)"
  },
  "colors.green.light.a1": {
    "value": "#00c04004",
    "variable": "var(--colors-green-light-a1)"
  },
  "colors.green.light.a2": {
    "value": "#00a32f0b",
    "variable": "var(--colors-green-light-a2)"
  },
  "colors.green.light.a3": {
    "value": "#00a43319",
    "variable": "var(--colors-green-light-a3)"
  },
  "colors.green.light.a4": {
    "value": "#00a83829",
    "variable": "var(--colors-green-light-a4)"
  },
  "colors.green.light.a5": {
    "value": "#019c393b",
    "variable": "var(--colors-green-light-a5)"
  },
  "colors.green.light.a6": {
    "value": "#00963c52",
    "variable": "var(--colors-green-light-a6)"
  },
  "colors.green.light.a7": {
    "value": "#00914071",
    "variable": "var(--colors-green-light-a7)"
  },
  "colors.green.light.a8": {
    "value": "#00924ba4",
    "variable": "var(--colors-green-light-a8)"
  },
  "colors.green.light.a9": {
    "value": "#008f4acf",
    "variable": "var(--colors-green-light-a9)"
  },
  "colors.green.light.a10": {
    "value": "#008647d4",
    "variable": "var(--colors-green-light-a10)"
  },
  "colors.green.light.a11": {
    "value": "#00713fde",
    "variable": "var(--colors-green-light-a11)"
  },
  "colors.green.light.a12": {
    "value": "#002616e6",
    "variable": "var(--colors-green-light-a12)"
  },
  "colors.green.dark.1": {
    "value": "#0e1512",
    "variable": "var(--colors-green-dark-1)"
  },
  "colors.green.dark.2": {
    "value": "#121b17",
    "variable": "var(--colors-green-dark-2)"
  },
  "colors.green.dark.3": {
    "value": "#132d21",
    "variable": "var(--colors-green-dark-3)"
  },
  "colors.green.dark.4": {
    "value": "#113b29",
    "variable": "var(--colors-green-dark-4)"
  },
  "colors.green.dark.5": {
    "value": "#174933",
    "variable": "var(--colors-green-dark-5)"
  },
  "colors.green.dark.6": {
    "value": "#20573e",
    "variable": "var(--colors-green-dark-6)"
  },
  "colors.green.dark.7": {
    "value": "#28684a",
    "variable": "var(--colors-green-dark-7)"
  },
  "colors.green.dark.8": {
    "value": "#2f7c57",
    "variable": "var(--colors-green-dark-8)"
  },
  "colors.green.dark.9": {
    "value": "#30a46c",
    "variable": "var(--colors-green-dark-9)"
  },
  "colors.green.dark.10": {
    "value": "#33b074",
    "variable": "var(--colors-green-dark-10)"
  },
  "colors.green.dark.11": {
    "value": "#3dd68c",
    "variable": "var(--colors-green-dark-11)"
  },
  "colors.green.dark.12": {
    "value": "#b1f1cb",
    "variable": "var(--colors-green-dark-12)"
  },
  "colors.green.dark.a1": {
    "value": "#00de4505",
    "variable": "var(--colors-green-dark-a1)"
  },
  "colors.green.dark.a2": {
    "value": "#29f99d0b",
    "variable": "var(--colors-green-dark-a2)"
  },
  "colors.green.dark.a3": {
    "value": "#22ff991e",
    "variable": "var(--colors-green-dark-a3)"
  },
  "colors.green.dark.a4": {
    "value": "#11ff992d",
    "variable": "var(--colors-green-dark-a4)"
  },
  "colors.green.dark.a5": {
    "value": "#2bffa23c",
    "variable": "var(--colors-green-dark-a5)"
  },
  "colors.green.dark.a6": {
    "value": "#44ffaa4b",
    "variable": "var(--colors-green-dark-a6)"
  },
  "colors.green.dark.a7": {
    "value": "#50fdac5e",
    "variable": "var(--colors-green-dark-a7)"
  },
  "colors.green.dark.a8": {
    "value": "#54ffad73",
    "variable": "var(--colors-green-dark-a8)"
  },
  "colors.green.dark.a9": {
    "value": "#44ffa49e",
    "variable": "var(--colors-green-dark-a9)"
  },
  "colors.green.dark.a10": {
    "value": "#43fea4ab",
    "variable": "var(--colors-green-dark-a10)"
  },
  "colors.green.dark.a11": {
    "value": "#46fea5d4",
    "variable": "var(--colors-green-dark-a11)"
  },
  "colors.green.dark.a12": {
    "value": "#bbffd7f0",
    "variable": "var(--colors-green-dark-a12)"
  },
  "colors.tomato.light.1": {
    "value": "#fffcfc",
    "variable": "var(--colors-tomato-light-1)"
  },
  "colors.tomato.light.2": {
    "value": "#fff8f7",
    "variable": "var(--colors-tomato-light-2)"
  },
  "colors.tomato.light.3": {
    "value": "#feebe7",
    "variable": "var(--colors-tomato-light-3)"
  },
  "colors.tomato.light.4": {
    "value": "#ffdcd3",
    "variable": "var(--colors-tomato-light-4)"
  },
  "colors.tomato.light.5": {
    "value": "#ffcdc2",
    "variable": "var(--colors-tomato-light-5)"
  },
  "colors.tomato.light.6": {
    "value": "#fdbdaf",
    "variable": "var(--colors-tomato-light-6)"
  },
  "colors.tomato.light.7": {
    "value": "#f5a898",
    "variable": "var(--colors-tomato-light-7)"
  },
  "colors.tomato.light.8": {
    "value": "#ec8e7b",
    "variable": "var(--colors-tomato-light-8)"
  },
  "colors.tomato.light.9": {
    "value": "#e54d2e",
    "variable": "var(--colors-tomato-light-9)"
  },
  "colors.tomato.light.10": {
    "value": "#dd4425",
    "variable": "var(--colors-tomato-light-10)"
  },
  "colors.tomato.light.11": {
    "value": "#d13415",
    "variable": "var(--colors-tomato-light-11)"
  },
  "colors.tomato.light.12": {
    "value": "#5c271f",
    "variable": "var(--colors-tomato-light-12)"
  },
  "colors.tomato.light.a1": {
    "value": "#ff000003",
    "variable": "var(--colors-tomato-light-a1)"
  },
  "colors.tomato.light.a2": {
    "value": "#ff200008",
    "variable": "var(--colors-tomato-light-a2)"
  },
  "colors.tomato.light.a3": {
    "value": "#f52b0018",
    "variable": "var(--colors-tomato-light-a3)"
  },
  "colors.tomato.light.a4": {
    "value": "#ff35002c",
    "variable": "var(--colors-tomato-light-a4)"
  },
  "colors.tomato.light.a5": {
    "value": "#ff2e003d",
    "variable": "var(--colors-tomato-light-a5)"
  },
  "colors.tomato.light.a6": {
    "value": "#f92d0050",
    "variable": "var(--colors-tomato-light-a6)"
  },
  "colors.tomato.light.a7": {
    "value": "#e7280067",
    "variable": "var(--colors-tomato-light-a7)"
  },
  "colors.tomato.light.a8": {
    "value": "#db250084",
    "variable": "var(--colors-tomato-light-a8)"
  },
  "colors.tomato.light.a9": {
    "value": "#df2600d1",
    "variable": "var(--colors-tomato-light-a9)"
  },
  "colors.tomato.light.a10": {
    "value": "#d72400da",
    "variable": "var(--colors-tomato-light-a10)"
  },
  "colors.tomato.light.a11": {
    "value": "#cd2200ea",
    "variable": "var(--colors-tomato-light-a11)"
  },
  "colors.tomato.light.a12": {
    "value": "#460900e0",
    "variable": "var(--colors-tomato-light-a12)"
  },
  "colors.tomato.dark.1": {
    "value": "#181111",
    "variable": "var(--colors-tomato-dark-1)"
  },
  "colors.tomato.dark.2": {
    "value": "#1f1513",
    "variable": "var(--colors-tomato-dark-2)"
  },
  "colors.tomato.dark.3": {
    "value": "#391714",
    "variable": "var(--colors-tomato-dark-3)"
  },
  "colors.tomato.dark.4": {
    "value": "#4e1511",
    "variable": "var(--colors-tomato-dark-4)"
  },
  "colors.tomato.dark.5": {
    "value": "#5e1c16",
    "variable": "var(--colors-tomato-dark-5)"
  },
  "colors.tomato.dark.6": {
    "value": "#6e2920",
    "variable": "var(--colors-tomato-dark-6)"
  },
  "colors.tomato.dark.7": {
    "value": "#853a2d",
    "variable": "var(--colors-tomato-dark-7)"
  },
  "colors.tomato.dark.8": {
    "value": "#ac4d39",
    "variable": "var(--colors-tomato-dark-8)"
  },
  "colors.tomato.dark.9": {
    "value": "#e54d2e",
    "variable": "var(--colors-tomato-dark-9)"
  },
  "colors.tomato.dark.10": {
    "value": "#ec6142",
    "variable": "var(--colors-tomato-dark-10)"
  },
  "colors.tomato.dark.11": {
    "value": "#ff977d",
    "variable": "var(--colors-tomato-dark-11)"
  },
  "colors.tomato.dark.12": {
    "value": "#fbd3cb",
    "variable": "var(--colors-tomato-dark-12)"
  },
  "colors.tomato.dark.a1": {
    "value": "#f1121208",
    "variable": "var(--colors-tomato-dark-a1)"
  },
  "colors.tomato.dark.a2": {
    "value": "#ff55330f",
    "variable": "var(--colors-tomato-dark-a2)"
  },
  "colors.tomato.dark.a3": {
    "value": "#ff35232b",
    "variable": "var(--colors-tomato-dark-a3)"
  },
  "colors.tomato.dark.a4": {
    "value": "#fd201142",
    "variable": "var(--colors-tomato-dark-a4)"
  },
  "colors.tomato.dark.a5": {
    "value": "#fe332153",
    "variable": "var(--colors-tomato-dark-a5)"
  },
  "colors.tomato.dark.a6": {
    "value": "#ff4f3864",
    "variable": "var(--colors-tomato-dark-a6)"
  },
  "colors.tomato.dark.a7": {
    "value": "#fd644a7d",
    "variable": "var(--colors-tomato-dark-a7)"
  },
  "colors.tomato.dark.a8": {
    "value": "#fe6d4ea7",
    "variable": "var(--colors-tomato-dark-a8)"
  },
  "colors.tomato.dark.a9": {
    "value": "#fe5431e4",
    "variable": "var(--colors-tomato-dark-a9)"
  },
  "colors.tomato.dark.a10": {
    "value": "#ff6847eb",
    "variable": "var(--colors-tomato-dark-a10)"
  },
  "colors.tomato.dark.a11": {
    "value": "#ff977d",
    "variable": "var(--colors-tomato-dark-a11)"
  },
  "colors.tomato.dark.a12": {
    "value": "#ffd6cefb",
    "variable": "var(--colors-tomato-dark-a12)"
  },
  "colors.neutral.light.1": {
    "value": "#FDFCFC",
    "variable": "var(--colors-neutral-light-1)"
  },
  "colors.neutral.light.2": {
    "value": "#FDFAF9",
    "variable": "var(--colors-neutral-light-2)"
  },
  "colors.neutral.light.3": {
    "value": "#F8F4F2",
    "variable": "var(--colors-neutral-light-3)"
  },
  "colors.neutral.light.4": {
    "value": "#EEE8E6",
    "variable": "var(--colors-neutral-light-4)"
  },
  "colors.neutral.light.5": {
    "value": "#E8E2DF",
    "variable": "var(--colors-neutral-light-5)"
  },
  "colors.neutral.light.6": {
    "value": "#D9D2CF",
    "variable": "var(--colors-neutral-light-6)"
  },
  "colors.neutral.light.7": {
    "value": "#CCC5C2",
    "variable": "var(--colors-neutral-light-7)"
  },
  "colors.neutral.light.8": {
    "value": "#B8B2B0",
    "variable": "var(--colors-neutral-light-8)"
  },
  "colors.neutral.light.9": {
    "value": "#8A8483",
    "variable": "var(--colors-neutral-light-9)"
  },
  "colors.neutral.light.10": {
    "value": "#797472",
    "variable": "var(--colors-neutral-light-10)"
  },
  "colors.neutral.light.11": {
    "value": "#54504F",
    "variable": "var(--colors-neutral-light-11)"
  },
  "colors.neutral.light.12": {
    "value": "#141110",
    "variable": "var(--colors-neutral-light-12)"
  },
  "colors.neutral.light.a1": {
    "value": "#3D1A1003",
    "variable": "var(--colors-neutral-light-a1)"
  },
  "colors.neutral.light.a2": {
    "value": "#3D1A1008",
    "variable": "var(--colors-neutral-light-a2)"
  },
  "colors.neutral.light.a3": {
    "value": "#3D1A100D",
    "variable": "var(--colors-neutral-light-a3)"
  },
  "colors.neutral.light.a4": {
    "value": "#3D1A1012",
    "variable": "var(--colors-neutral-light-a4)"
  },
  "colors.neutral.light.a5": {
    "value": "#3D1A1017",
    "variable": "var(--colors-neutral-light-a5)"
  },
  "colors.neutral.light.a6": {
    "value": "#3D1A1024",
    "variable": "var(--colors-neutral-light-a6)"
  },
  "colors.neutral.light.a7": {
    "value": "#3D1A1030",
    "variable": "var(--colors-neutral-light-a7)"
  },
  "colors.neutral.light.a8": {
    "value": "#3D1A1045",
    "variable": "var(--colors-neutral-light-a8)"
  },
  "colors.neutral.light.a9": {
    "value": "#3D1A1073",
    "variable": "var(--colors-neutral-light-a9)"
  },
  "colors.neutral.light.a10": {
    "value": "#3D1A1080",
    "variable": "var(--colors-neutral-light-a10)"
  },
  "colors.neutral.light.a11": {
    "value": "#3D1A10A1",
    "variable": "var(--colors-neutral-light-a11)"
  },
  "colors.neutral.light.a12": {
    "value": "#3D1A10DE",
    "variable": "var(--colors-neutral-light-a12)"
  },
  "colors.neutral.dark.1": {
    "value": "#141715",
    "variable": "var(--colors-neutral-dark-1)"
  },
  "colors.neutral.dark.2": {
    "value": "#1B1E1C",
    "variable": "var(--colors-neutral-dark-2)"
  },
  "colors.neutral.dark.3": {
    "value": "#222523",
    "variable": "var(--colors-neutral-dark-3)"
  },
  "colors.neutral.dark.4": {
    "value": "#333635",
    "variable": "var(--colors-neutral-dark-4)"
  },
  "colors.neutral.dark.5": {
    "value": "#454846",
    "variable": "var(--colors-neutral-dark-5)"
  },
  "colors.neutral.dark.6": {
    "value": "#4F5250",
    "variable": "var(--colors-neutral-dark-6)"
  },
  "colors.neutral.dark.7": {
    "value": "#636664",
    "variable": "var(--colors-neutral-dark-7)"
  },
  "colors.neutral.dark.8": {
    "value": "#777A78",
    "variable": "var(--colors-neutral-dark-8)"
  },
  "colors.neutral.dark.9": {
    "value": "#9FA2A0",
    "variable": "var(--colors-neutral-dark-9)"
  },
  "colors.neutral.dark.10": {
    "value": "#AAABAA",
    "variable": "var(--colors-neutral-dark-10)"
  },
  "colors.neutral.dark.11": {
    "value": "#CECFCF",
    "variable": "var(--colors-neutral-dark-11)"
  },
  "colors.neutral.dark.12": {
    "value": "#FBFBFB",
    "variable": "var(--colors-neutral-dark-12)"
  },
  "colors.neutral.dark.a1": {
    "value": "#94969503",
    "variable": "var(--colors-neutral-dark-a1)"
  },
  "colors.neutral.dark.a2": {
    "value": "#9496950A",
    "variable": "var(--colors-neutral-dark-a2)"
  },
  "colors.neutral.dark.a3": {
    "value": "#9496950D",
    "variable": "var(--colors-neutral-dark-a3)"
  },
  "colors.neutral.dark.a4": {
    "value": "#9496951C",
    "variable": "var(--colors-neutral-dark-a4)"
  },
  "colors.neutral.dark.a5": {
    "value": "#94969521",
    "variable": "var(--colors-neutral-dark-a5)"
  },
  "colors.neutral.dark.a6": {
    "value": "#9496952B",
    "variable": "var(--colors-neutral-dark-a6)"
  },
  "colors.neutral.dark.a7": {
    "value": "#9496953B",
    "variable": "var(--colors-neutral-dark-a7)"
  },
  "colors.neutral.dark.a8": {
    "value": "#94969554",
    "variable": "var(--colors-neutral-dark-a8)"
  },
  "colors.neutral.dark.a9": {
    "value": "#94969563",
    "variable": "var(--colors-neutral-dark-a9)"
  },
  "colors.neutral.dark.a10": {
    "value": "#94969573",
    "variable": "var(--colors-neutral-dark-a10)"
  },
  "colors.neutral.dark.a11": {
    "value": "#949695B0",
    "variable": "var(--colors-neutral-dark-a11)"
  },
  "colors.neutral.dark.a12": {
    "value": "#949695ED",
    "variable": "var(--colors-neutral-dark-a12)"
  },
  "colors.crimson.light.1": {
    "value": "#fffcfd",
    "variable": "var(--colors-crimson-light-1)"
  },
  "colors.crimson.light.2": {
    "value": "#fef7f9",
    "variable": "var(--colors-crimson-light-2)"
  },
  "colors.crimson.light.3": {
    "value": "#ffe9f0",
    "variable": "var(--colors-crimson-light-3)"
  },
  "colors.crimson.light.4": {
    "value": "#fedce7",
    "variable": "var(--colors-crimson-light-4)"
  },
  "colors.crimson.light.5": {
    "value": "#facedd",
    "variable": "var(--colors-crimson-light-5)"
  },
  "colors.crimson.light.6": {
    "value": "#f3bed1",
    "variable": "var(--colors-crimson-light-6)"
  },
  "colors.crimson.light.7": {
    "value": "#eaacc3",
    "variable": "var(--colors-crimson-light-7)"
  },
  "colors.crimson.light.8": {
    "value": "#e093b2",
    "variable": "var(--colors-crimson-light-8)"
  },
  "colors.crimson.light.9": {
    "value": "#e93d82",
    "variable": "var(--colors-crimson-light-9)"
  },
  "colors.crimson.light.10": {
    "value": "#df3478",
    "variable": "var(--colors-crimson-light-10)"
  },
  "colors.crimson.light.11": {
    "value": "#cb1d63",
    "variable": "var(--colors-crimson-light-11)"
  },
  "colors.crimson.light.12": {
    "value": "#621639",
    "variable": "var(--colors-crimson-light-12)"
  },
  "colors.crimson.light.a1": {
    "value": "#ff005503",
    "variable": "var(--colors-crimson-light-a1)"
  },
  "colors.crimson.light.a2": {
    "value": "#e0004008",
    "variable": "var(--colors-crimson-light-a2)"
  },
  "colors.crimson.light.a3": {
    "value": "#ff005216",
    "variable": "var(--colors-crimson-light-a3)"
  },
  "colors.crimson.light.a4": {
    "value": "#f8005123",
    "variable": "var(--colors-crimson-light-a4)"
  },
  "colors.crimson.light.a5": {
    "value": "#e5004f31",
    "variable": "var(--colors-crimson-light-a5)"
  },
  "colors.crimson.light.a6": {
    "value": "#d0004b41",
    "variable": "var(--colors-crimson-light-a6)"
  },
  "colors.crimson.light.a7": {
    "value": "#bf004753",
    "variable": "var(--colors-crimson-light-a7)"
  },
  "colors.crimson.light.a8": {
    "value": "#b6004a6c",
    "variable": "var(--colors-crimson-light-a8)"
  },
  "colors.crimson.light.a9": {
    "value": "#e2005bc2",
    "variable": "var(--colors-crimson-light-a9)"
  },
  "colors.crimson.light.a10": {
    "value": "#d70056cb",
    "variable": "var(--colors-crimson-light-a10)"
  },
  "colors.crimson.light.a11": {
    "value": "#c4004fe2",
    "variable": "var(--colors-crimson-light-a11)"
  },
  "colors.crimson.light.a12": {
    "value": "#530026e9",
    "variable": "var(--colors-crimson-light-a12)"
  },
  "colors.crimson.dark.1": {
    "value": "#191114",
    "variable": "var(--colors-crimson-dark-1)"
  },
  "colors.crimson.dark.2": {
    "value": "#201318",
    "variable": "var(--colors-crimson-dark-2)"
  },
  "colors.crimson.dark.3": {
    "value": "#381525",
    "variable": "var(--colors-crimson-dark-3)"
  },
  "colors.crimson.dark.4": {
    "value": "#4d122f",
    "variable": "var(--colors-crimson-dark-4)"
  },
  "colors.crimson.dark.5": {
    "value": "#5c1839",
    "variable": "var(--colors-crimson-dark-5)"
  },
  "colors.crimson.dark.6": {
    "value": "#6d2545",
    "variable": "var(--colors-crimson-dark-6)"
  },
  "colors.crimson.dark.7": {
    "value": "#873356",
    "variable": "var(--colors-crimson-dark-7)"
  },
  "colors.crimson.dark.8": {
    "value": "#b0436e",
    "variable": "var(--colors-crimson-dark-8)"
  },
  "colors.crimson.dark.9": {
    "value": "#e93d82",
    "variable": "var(--colors-crimson-dark-9)"
  },
  "colors.crimson.dark.10": {
    "value": "#ee518a",
    "variable": "var(--colors-crimson-dark-10)"
  },
  "colors.crimson.dark.11": {
    "value": "#ff92ad",
    "variable": "var(--colors-crimson-dark-11)"
  },
  "colors.crimson.dark.12": {
    "value": "#fdd3e8",
    "variable": "var(--colors-crimson-dark-12)"
  },
  "colors.crimson.dark.a1": {
    "value": "#f4126709",
    "variable": "var(--colors-crimson-dark-a1)"
  },
  "colors.crimson.dark.a2": {
    "value": "#f22f7a11",
    "variable": "var(--colors-crimson-dark-a2)"
  },
  "colors.crimson.dark.a3": {
    "value": "#fe2a8b2a",
    "variable": "var(--colors-crimson-dark-a3)"
  },
  "colors.crimson.dark.a4": {
    "value": "#fd158741",
    "variable": "var(--colors-crimson-dark-a4)"
  },
  "colors.crimson.dark.a5": {
    "value": "#fd278f51",
    "variable": "var(--colors-crimson-dark-a5)"
  },
  "colors.crimson.dark.a6": {
    "value": "#fe459763",
    "variable": "var(--colors-crimson-dark-a6)"
  },
  "colors.crimson.dark.a7": {
    "value": "#fd559b7f",
    "variable": "var(--colors-crimson-dark-a7)"
  },
  "colors.crimson.dark.a8": {
    "value": "#fe5b9bab",
    "variable": "var(--colors-crimson-dark-a8)"
  },
  "colors.crimson.dark.a9": {
    "value": "#fe418de8",
    "variable": "var(--colors-crimson-dark-a9)"
  },
  "colors.crimson.dark.a10": {
    "value": "#ff5693ed",
    "variable": "var(--colors-crimson-dark-a10)"
  },
  "colors.crimson.dark.a11": {
    "value": "#ff92ad",
    "variable": "var(--colors-crimson-dark-a11)"
  },
  "colors.crimson.dark.a12": {
    "value": "#ffd5eafd",
    "variable": "var(--colors-crimson-dark-a12)"
  },
  "colors.sky.light.1": {
    "value": "#f9feff",
    "variable": "var(--colors-sky-light-1)"
  },
  "colors.sky.light.2": {
    "value": "#f1fafd",
    "variable": "var(--colors-sky-light-2)"
  },
  "colors.sky.light.3": {
    "value": "#e1f6fd",
    "variable": "var(--colors-sky-light-3)"
  },
  "colors.sky.light.4": {
    "value": "#d1f0fa",
    "variable": "var(--colors-sky-light-4)"
  },
  "colors.sky.light.5": {
    "value": "#bee7f5",
    "variable": "var(--colors-sky-light-5)"
  },
  "colors.sky.light.6": {
    "value": "#a9daed",
    "variable": "var(--colors-sky-light-6)"
  },
  "colors.sky.light.7": {
    "value": "#8dcae3",
    "variable": "var(--colors-sky-light-7)"
  },
  "colors.sky.light.8": {
    "value": "#60b3d7",
    "variable": "var(--colors-sky-light-8)"
  },
  "colors.sky.light.9": {
    "value": "#7ce2fe",
    "variable": "var(--colors-sky-light-9)"
  },
  "colors.sky.light.10": {
    "value": "#74daf8",
    "variable": "var(--colors-sky-light-10)"
  },
  "colors.sky.light.11": {
    "value": "#00749e",
    "variable": "var(--colors-sky-light-11)"
  },
  "colors.sky.light.12": {
    "value": "#1d3e56",
    "variable": "var(--colors-sky-light-12)"
  },
  "colors.sky.light.a1": {
    "value": "#00d5ff06",
    "variable": "var(--colors-sky-light-a1)"
  },
  "colors.sky.light.a2": {
    "value": "#00a4db0e",
    "variable": "var(--colors-sky-light-a2)"
  },
  "colors.sky.light.a3": {
    "value": "#00b3ee1e",
    "variable": "var(--colors-sky-light-a3)"
  },
  "colors.sky.light.a4": {
    "value": "#00ace42e",
    "variable": "var(--colors-sky-light-a4)"
  },
  "colors.sky.light.a5": {
    "value": "#00a1d841",
    "variable": "var(--colors-sky-light-a5)"
  },
  "colors.sky.light.a6": {
    "value": "#0092ca56",
    "variable": "var(--colors-sky-light-a6)"
  },
  "colors.sky.light.a7": {
    "value": "#0089c172",
    "variable": "var(--colors-sky-light-a7)"
  },
  "colors.sky.light.a8": {
    "value": "#0085bf9f",
    "variable": "var(--colors-sky-light-a8)"
  },
  "colors.sky.light.a9": {
    "value": "#00c7fe83",
    "variable": "var(--colors-sky-light-a9)"
  },
  "colors.sky.light.a10": {
    "value": "#00bcf38b",
    "variable": "var(--colors-sky-light-a10)"
  },
  "colors.sky.light.a11": {
    "value": "#00749e",
    "variable": "var(--colors-sky-light-a11)"
  },
  "colors.sky.light.a12": {
    "value": "#002540e2",
    "variable": "var(--colors-sky-light-a12)"
  },
  "colors.sky.dark.1": {
    "value": "#0d141f",
    "variable": "var(--colors-sky-dark-1)"
  },
  "colors.sky.dark.2": {
    "value": "#111a27",
    "variable": "var(--colors-sky-dark-2)"
  },
  "colors.sky.dark.3": {
    "value": "#112840",
    "variable": "var(--colors-sky-dark-3)"
  },
  "colors.sky.dark.4": {
    "value": "#113555",
    "variable": "var(--colors-sky-dark-4)"
  },
  "colors.sky.dark.5": {
    "value": "#154467",
    "variable": "var(--colors-sky-dark-5)"
  },
  "colors.sky.dark.6": {
    "value": "#1b537b",
    "variable": "var(--colors-sky-dark-6)"
  },
  "colors.sky.dark.7": {
    "value": "#1f6692",
    "variable": "var(--colors-sky-dark-7)"
  },
  "colors.sky.dark.8": {
    "value": "#197cae",
    "variable": "var(--colors-sky-dark-8)"
  },
  "colors.sky.dark.9": {
    "value": "#7ce2fe",
    "variable": "var(--colors-sky-dark-9)"
  },
  "colors.sky.dark.10": {
    "value": "#a8eeff",
    "variable": "var(--colors-sky-dark-10)"
  },
  "colors.sky.dark.11": {
    "value": "#75c7f0",
    "variable": "var(--colors-sky-dark-11)"
  },
  "colors.sky.dark.12": {
    "value": "#c2f3ff",
    "variable": "var(--colors-sky-dark-12)"
  },
  "colors.sky.dark.a1": {
    "value": "#0044ff0f",
    "variable": "var(--colors-sky-dark-a1)"
  },
  "colors.sky.dark.a2": {
    "value": "#1171fb18",
    "variable": "var(--colors-sky-dark-a2)"
  },
  "colors.sky.dark.a3": {
    "value": "#1184fc33",
    "variable": "var(--colors-sky-dark-a3)"
  },
  "colors.sky.dark.a4": {
    "value": "#128fff49",
    "variable": "var(--colors-sky-dark-a4)"
  },
  "colors.sky.dark.a5": {
    "value": "#1c9dfd5d",
    "variable": "var(--colors-sky-dark-a5)"
  },
  "colors.sky.dark.a6": {
    "value": "#28a5ff72",
    "variable": "var(--colors-sky-dark-a6)"
  },
  "colors.sky.dark.a7": {
    "value": "#2badfe8b",
    "variable": "var(--colors-sky-dark-a7)"
  },
  "colors.sky.dark.a8": {
    "value": "#1db2fea9",
    "variable": "var(--colors-sky-dark-a8)"
  },
  "colors.sky.dark.a9": {
    "value": "#7ce3fffe",
    "variable": "var(--colors-sky-dark-a9)"
  },
  "colors.sky.dark.a10": {
    "value": "#a8eeff",
    "variable": "var(--colors-sky-dark-a10)"
  },
  "colors.sky.dark.a11": {
    "value": "#7cd3ffef",
    "variable": "var(--colors-sky-dark-a11)"
  },
  "colors.sky.dark.a12": {
    "value": "#c2f3ff",
    "variable": "var(--colors-sky-dark-a12)"
  },
  "colors.purple.light.1": {
    "value": "#fefcfe",
    "variable": "var(--colors-purple-light-1)"
  },
  "colors.purple.light.2": {
    "value": "#fbf7fe",
    "variable": "var(--colors-purple-light-2)"
  },
  "colors.purple.light.3": {
    "value": "#f7edfe",
    "variable": "var(--colors-purple-light-3)"
  },
  "colors.purple.light.4": {
    "value": "#f2e2fc",
    "variable": "var(--colors-purple-light-4)"
  },
  "colors.purple.light.5": {
    "value": "#ead5f9",
    "variable": "var(--colors-purple-light-5)"
  },
  "colors.purple.light.6": {
    "value": "#e0c4f4",
    "variable": "var(--colors-purple-light-6)"
  },
  "colors.purple.light.7": {
    "value": "#d1afec",
    "variable": "var(--colors-purple-light-7)"
  },
  "colors.purple.light.8": {
    "value": "#be93e4",
    "variable": "var(--colors-purple-light-8)"
  },
  "colors.purple.light.9": {
    "value": "#8e4ec6",
    "variable": "var(--colors-purple-light-9)"
  },
  "colors.purple.light.10": {
    "value": "#8347b9",
    "variable": "var(--colors-purple-light-10)"
  },
  "colors.purple.light.11": {
    "value": "#8145b5",
    "variable": "var(--colors-purple-light-11)"
  },
  "colors.purple.light.12": {
    "value": "#402060",
    "variable": "var(--colors-purple-light-12)"
  },
  "colors.purple.light.a1": {
    "value": "#aa00aa03",
    "variable": "var(--colors-purple-light-a1)"
  },
  "colors.purple.light.a2": {
    "value": "#8000e008",
    "variable": "var(--colors-purple-light-a2)"
  },
  "colors.purple.light.a3": {
    "value": "#8e00f112",
    "variable": "var(--colors-purple-light-a3)"
  },
  "colors.purple.light.a4": {
    "value": "#8d00e51d",
    "variable": "var(--colors-purple-light-a4)"
  },
  "colors.purple.light.a5": {
    "value": "#8000db2a",
    "variable": "var(--colors-purple-light-a5)"
  },
  "colors.purple.light.a6": {
    "value": "#7a01d03b",
    "variable": "var(--colors-purple-light-a6)"
  },
  "colors.purple.light.a7": {
    "value": "#6d00c350",
    "variable": "var(--colors-purple-light-a7)"
  },
  "colors.purple.light.a8": {
    "value": "#6600c06c",
    "variable": "var(--colors-purple-light-a8)"
  },
  "colors.purple.light.a9": {
    "value": "#5c00adb1",
    "variable": "var(--colors-purple-light-a9)"
  },
  "colors.purple.light.a10": {
    "value": "#53009eb8",
    "variable": "var(--colors-purple-light-a10)"
  },
  "colors.purple.light.a11": {
    "value": "#52009aba",
    "variable": "var(--colors-purple-light-a11)"
  },
  "colors.purple.light.a12": {
    "value": "#250049df",
    "variable": "var(--colors-purple-light-a12)"
  },
  "colors.purple.dark.1": {
    "value": "#18111b",
    "variable": "var(--colors-purple-dark-1)"
  },
  "colors.purple.dark.2": {
    "value": "#1e1523",
    "variable": "var(--colors-purple-dark-2)"
  },
  "colors.purple.dark.3": {
    "value": "#301c3b",
    "variable": "var(--colors-purple-dark-3)"
  },
  "colors.purple.dark.4": {
    "value": "#3d224e",
    "variable": "var(--colors-purple-dark-4)"
  },
  "colors.purple.dark.5": {
    "value": "#48295c",
    "variable": "var(--colors-purple-dark-5)"
  },
  "colors.purple.dark.6": {
    "value": "#54346b",
    "variable": "var(--colors-purple-dark-6)"
  },
  "colors.purple.dark.7": {
    "value": "#664282",
    "variable": "var(--colors-purple-dark-7)"
  },
  "colors.purple.dark.8": {
    "value": "#8457aa",
    "variable": "var(--colors-purple-dark-8)"
  },
  "colors.purple.dark.9": {
    "value": "#8e4ec6",
    "variable": "var(--colors-purple-dark-9)"
  },
  "colors.purple.dark.10": {
    "value": "#9a5cd0",
    "variable": "var(--colors-purple-dark-10)"
  },
  "colors.purple.dark.11": {
    "value": "#d19dff",
    "variable": "var(--colors-purple-dark-11)"
  },
  "colors.purple.dark.12": {
    "value": "#ecd9fa",
    "variable": "var(--colors-purple-dark-12)"
  },
  "colors.purple.dark.a1": {
    "value": "#b412f90b",
    "variable": "var(--colors-purple-dark-a1)"
  },
  "colors.purple.dark.a2": {
    "value": "#b744f714",
    "variable": "var(--colors-purple-dark-a2)"
  },
  "colors.purple.dark.a3": {
    "value": "#c150ff2d",
    "variable": "var(--colors-purple-dark-a3)"
  },
  "colors.purple.dark.a4": {
    "value": "#bb53fd42",
    "variable": "var(--colors-purple-dark-a4)"
  },
  "colors.purple.dark.a5": {
    "value": "#be5cfd51",
    "variable": "var(--colors-purple-dark-a5)"
  },
  "colors.purple.dark.a6": {
    "value": "#c16dfd61",
    "variable": "var(--colors-purple-dark-a6)"
  },
  "colors.purple.dark.a7": {
    "value": "#c378fd7a",
    "variable": "var(--colors-purple-dark-a7)"
  },
  "colors.purple.dark.a8": {
    "value": "#c47effa4",
    "variable": "var(--colors-purple-dark-a8)"
  },
  "colors.purple.dark.a9": {
    "value": "#b661ffc2",
    "variable": "var(--colors-purple-dark-a9)"
  },
  "colors.purple.dark.a10": {
    "value": "#bc6fffcd",
    "variable": "var(--colors-purple-dark-a10)"
  },
  "colors.purple.dark.a11": {
    "value": "#d19dff",
    "variable": "var(--colors-purple-dark-a11)"
  },
  "colors.purple.dark.a12": {
    "value": "#f1ddfffa",
    "variable": "var(--colors-purple-dark-a12)"
  },
  "colors.blue.light.1": {
    "value": "#fbfdff",
    "variable": "var(--colors-blue-light-1)"
  },
  "colors.blue.light.2": {
    "value": "#f4faff",
    "variable": "var(--colors-blue-light-2)"
  },
  "colors.blue.light.3": {
    "value": "#e6f4fe",
    "variable": "var(--colors-blue-light-3)"
  },
  "colors.blue.light.4": {
    "value": "#d5efff",
    "variable": "var(--colors-blue-light-4)"
  },
  "colors.blue.light.5": {
    "value": "#c2e5ff",
    "variable": "var(--colors-blue-light-5)"
  },
  "colors.blue.light.6": {
    "value": "#acd8fc",
    "variable": "var(--colors-blue-light-6)"
  },
  "colors.blue.light.7": {
    "value": "#8ec8f6",
    "variable": "var(--colors-blue-light-7)"
  },
  "colors.blue.light.8": {
    "value": "#5eb1ef",
    "variable": "var(--colors-blue-light-8)"
  },
  "colors.blue.light.9": {
    "value": "#0090ff",
    "variable": "var(--colors-blue-light-9)"
  },
  "colors.blue.light.10": {
    "value": "#0588f0",
    "variable": "var(--colors-blue-light-10)"
  },
  "colors.blue.light.11": {
    "value": "#0d74ce",
    "variable": "var(--colors-blue-light-11)"
  },
  "colors.blue.light.12": {
    "value": "#113264",
    "variable": "var(--colors-blue-light-12)"
  },
  "colors.blue.light.a1": {
    "value": "#0080ff04",
    "variable": "var(--colors-blue-light-a1)"
  },
  "colors.blue.light.a2": {
    "value": "#008cff0b",
    "variable": "var(--colors-blue-light-a2)"
  },
  "colors.blue.light.a3": {
    "value": "#008ff519",
    "variable": "var(--colors-blue-light-a3)"
  },
  "colors.blue.light.a4": {
    "value": "#009eff2a",
    "variable": "var(--colors-blue-light-a4)"
  },
  "colors.blue.light.a5": {
    "value": "#0093ff3d",
    "variable": "var(--colors-blue-light-a5)"
  },
  "colors.blue.light.a6": {
    "value": "#0088f653",
    "variable": "var(--colors-blue-light-a6)"
  },
  "colors.blue.light.a7": {
    "value": "#0083eb71",
    "variable": "var(--colors-blue-light-a7)"
  },
  "colors.blue.light.a8": {
    "value": "#0084e6a1",
    "variable": "var(--colors-blue-light-a8)"
  },
  "colors.blue.light.a9": {
    "value": "#0090ff",
    "variable": "var(--colors-blue-light-a9)"
  },
  "colors.blue.light.a10": {
    "value": "#0086f0fa",
    "variable": "var(--colors-blue-light-a10)"
  },
  "colors.blue.light.a11": {
    "value": "#006dcbf2",
    "variable": "var(--colors-blue-light-a11)"
  },
  "colors.blue.light.a12": {
    "value": "#002359ee",
    "variable": "var(--colors-blue-light-a12)"
  },
  "colors.blue.dark.1": {
    "value": "#0d1520",
    "variable": "var(--colors-blue-dark-1)"
  },
  "colors.blue.dark.2": {
    "value": "#111927",
    "variable": "var(--colors-blue-dark-2)"
  },
  "colors.blue.dark.3": {
    "value": "#0d2847",
    "variable": "var(--colors-blue-dark-3)"
  },
  "colors.blue.dark.4": {
    "value": "#003362",
    "variable": "var(--colors-blue-dark-4)"
  },
  "colors.blue.dark.5": {
    "value": "#004074",
    "variable": "var(--colors-blue-dark-5)"
  },
  "colors.blue.dark.6": {
    "value": "#104d87",
    "variable": "var(--colors-blue-dark-6)"
  },
  "colors.blue.dark.7": {
    "value": "#205d9e",
    "variable": "var(--colors-blue-dark-7)"
  },
  "colors.blue.dark.8": {
    "value": "#2870bd",
    "variable": "var(--colors-blue-dark-8)"
  },
  "colors.blue.dark.9": {
    "value": "#0090ff",
    "variable": "var(--colors-blue-dark-9)"
  },
  "colors.blue.dark.10": {
    "value": "#3b9eff",
    "variable": "var(--colors-blue-dark-10)"
  },
  "colors.blue.dark.11": {
    "value": "#70b8ff",
    "variable": "var(--colors-blue-dark-11)"
  },
  "colors.blue.dark.12": {
    "value": "#c2e6ff",
    "variable": "var(--colors-blue-dark-12)"
  },
  "colors.blue.dark.a1": {
    "value": "#004df211",
    "variable": "var(--colors-blue-dark-a1)"
  },
  "colors.blue.dark.a2": {
    "value": "#1166fb18",
    "variable": "var(--colors-blue-dark-a2)"
  },
  "colors.blue.dark.a3": {
    "value": "#0077ff3a",
    "variable": "var(--colors-blue-dark-a3)"
  },
  "colors.blue.dark.a4": {
    "value": "#0075ff57",
    "variable": "var(--colors-blue-dark-a4)"
  },
  "colors.blue.dark.a5": {
    "value": "#0081fd6b",
    "variable": "var(--colors-blue-dark-a5)"
  },
  "colors.blue.dark.a6": {
    "value": "#0f89fd7f",
    "variable": "var(--colors-blue-dark-a6)"
  },
  "colors.blue.dark.a7": {
    "value": "#2a91fe98",
    "variable": "var(--colors-blue-dark-a7)"
  },
  "colors.blue.dark.a8": {
    "value": "#3094feb9",
    "variable": "var(--colors-blue-dark-a8)"
  },
  "colors.blue.dark.a9": {
    "value": "#0090ff",
    "variable": "var(--colors-blue-dark-a9)"
  },
  "colors.blue.dark.a10": {
    "value": "#3b9eff",
    "variable": "var(--colors-blue-dark-a10)"
  },
  "colors.blue.dark.a11": {
    "value": "#70b8ff",
    "variable": "var(--colors-blue-dark-a11)"
  },
  "colors.blue.dark.a12": {
    "value": "#c2e6ff",
    "variable": "var(--colors-blue-dark-a12)"
  },
  "colors.cyan.light.1": {
    "value": "#fafdfe",
    "variable": "var(--colors-cyan-light-1)"
  },
  "colors.cyan.light.2": {
    "value": "#f2fafb",
    "variable": "var(--colors-cyan-light-2)"
  },
  "colors.cyan.light.3": {
    "value": "#def7f9",
    "variable": "var(--colors-cyan-light-3)"
  },
  "colors.cyan.light.4": {
    "value": "#caf1f6",
    "variable": "var(--colors-cyan-light-4)"
  },
  "colors.cyan.light.5": {
    "value": "#b5e9f0",
    "variable": "var(--colors-cyan-light-5)"
  },
  "colors.cyan.light.6": {
    "value": "#9ddde7",
    "variable": "var(--colors-cyan-light-6)"
  },
  "colors.cyan.light.7": {
    "value": "#7dcedc",
    "variable": "var(--colors-cyan-light-7)"
  },
  "colors.cyan.light.8": {
    "value": "#3db9cf",
    "variable": "var(--colors-cyan-light-8)"
  },
  "colors.cyan.light.9": {
    "value": "#00a2c7",
    "variable": "var(--colors-cyan-light-9)"
  },
  "colors.cyan.light.10": {
    "value": "#0797b9",
    "variable": "var(--colors-cyan-light-10)"
  },
  "colors.cyan.light.11": {
    "value": "#107d98",
    "variable": "var(--colors-cyan-light-11)"
  },
  "colors.cyan.light.12": {
    "value": "#0d3c48",
    "variable": "var(--colors-cyan-light-12)"
  },
  "colors.cyan.light.a1": {
    "value": "#0099cc05",
    "variable": "var(--colors-cyan-light-a1)"
  },
  "colors.cyan.light.a2": {
    "value": "#009db10d",
    "variable": "var(--colors-cyan-light-a2)"
  },
  "colors.cyan.light.a3": {
    "value": "#00c2d121",
    "variable": "var(--colors-cyan-light-a3)"
  },
  "colors.cyan.light.a4": {
    "value": "#00bcd435",
    "variable": "var(--colors-cyan-light-a4)"
  },
  "colors.cyan.light.a5": {
    "value": "#01b4cc4a",
    "variable": "var(--colors-cyan-light-a5)"
  },
  "colors.cyan.light.a6": {
    "value": "#00a7c162",
    "variable": "var(--colors-cyan-light-a6)"
  },
  "colors.cyan.light.a7": {
    "value": "#009fbb82",
    "variable": "var(--colors-cyan-light-a7)"
  },
  "colors.cyan.light.a8": {
    "value": "#00a3c0c2",
    "variable": "var(--colors-cyan-light-a8)"
  },
  "colors.cyan.light.a9": {
    "value": "#00a2c7",
    "variable": "var(--colors-cyan-light-a9)"
  },
  "colors.cyan.light.a10": {
    "value": "#0094b7f8",
    "variable": "var(--colors-cyan-light-a10)"
  },
  "colors.cyan.light.a11": {
    "value": "#007491ef",
    "variable": "var(--colors-cyan-light-a11)"
  },
  "colors.cyan.light.a12": {
    "value": "#00323ef2",
    "variable": "var(--colors-cyan-light-a12)"
  },
  "colors.cyan.dark.1": {
    "value": "#0b161a",
    "variable": "var(--colors-cyan-dark-1)"
  },
  "colors.cyan.dark.2": {
    "value": "#101b20",
    "variable": "var(--colors-cyan-dark-2)"
  },
  "colors.cyan.dark.3": {
    "value": "#082c36",
    "variable": "var(--colors-cyan-dark-3)"
  },
  "colors.cyan.dark.4": {
    "value": "#003848",
    "variable": "var(--colors-cyan-dark-4)"
  },
  "colors.cyan.dark.5": {
    "value": "#004558",
    "variable": "var(--colors-cyan-dark-5)"
  },
  "colors.cyan.dark.6": {
    "value": "#045468",
    "variable": "var(--colors-cyan-dark-6)"
  },
  "colors.cyan.dark.7": {
    "value": "#12677e",
    "variable": "var(--colors-cyan-dark-7)"
  },
  "colors.cyan.dark.8": {
    "value": "#11809c",
    "variable": "var(--colors-cyan-dark-8)"
  },
  "colors.cyan.dark.9": {
    "value": "#00a2c7",
    "variable": "var(--colors-cyan-dark-9)"
  },
  "colors.cyan.dark.10": {
    "value": "#23afd0",
    "variable": "var(--colors-cyan-dark-10)"
  },
  "colors.cyan.dark.11": {
    "value": "#4ccce6",
    "variable": "var(--colors-cyan-dark-11)"
  },
  "colors.cyan.dark.12": {
    "value": "#b6ecf7",
    "variable": "var(--colors-cyan-dark-12)"
  },
  "colors.cyan.dark.a1": {
    "value": "#0091f70a",
    "variable": "var(--colors-cyan-dark-a1)"
  },
  "colors.cyan.dark.a2": {
    "value": "#02a7f211",
    "variable": "var(--colors-cyan-dark-a2)"
  },
  "colors.cyan.dark.a3": {
    "value": "#00befd28",
    "variable": "var(--colors-cyan-dark-a3)"
  },
  "colors.cyan.dark.a4": {
    "value": "#00baff3b",
    "variable": "var(--colors-cyan-dark-a4)"
  },
  "colors.cyan.dark.a5": {
    "value": "#00befd4d",
    "variable": "var(--colors-cyan-dark-a5)"
  },
  "colors.cyan.dark.a6": {
    "value": "#00c7fd5e",
    "variable": "var(--colors-cyan-dark-a6)"
  },
  "colors.cyan.dark.a7": {
    "value": "#14cdff75",
    "variable": "var(--colors-cyan-dark-a7)"
  },
  "colors.cyan.dark.a8": {
    "value": "#11cfff95",
    "variable": "var(--colors-cyan-dark-a8)"
  },
  "colors.cyan.dark.a9": {
    "value": "#00cfffc3",
    "variable": "var(--colors-cyan-dark-a9)"
  },
  "colors.cyan.dark.a10": {
    "value": "#28d6ffcd",
    "variable": "var(--colors-cyan-dark-a10)"
  },
  "colors.cyan.dark.a11": {
    "value": "#52e1fee5",
    "variable": "var(--colors-cyan-dark-a11)"
  },
  "colors.cyan.dark.a12": {
    "value": "#bbf3fef7",
    "variable": "var(--colors-cyan-dark-a12)"
  },
  "colors.pink.light.1": {
    "value": "#fffcfe",
    "variable": "var(--colors-pink-light-1)"
  },
  "colors.pink.light.2": {
    "value": "#fef7fb",
    "variable": "var(--colors-pink-light-2)"
  },
  "colors.pink.light.3": {
    "value": "#fee9f5",
    "variable": "var(--colors-pink-light-3)"
  },
  "colors.pink.light.4": {
    "value": "#fbdcef",
    "variable": "var(--colors-pink-light-4)"
  },
  "colors.pink.light.5": {
    "value": "#f6cee7",
    "variable": "var(--colors-pink-light-5)"
  },
  "colors.pink.light.6": {
    "value": "#efbfdd",
    "variable": "var(--colors-pink-light-6)"
  },
  "colors.pink.light.7": {
    "value": "#e7acd0",
    "variable": "var(--colors-pink-light-7)"
  },
  "colors.pink.light.8": {
    "value": "#dd93c2",
    "variable": "var(--colors-pink-light-8)"
  },
  "colors.pink.light.9": {
    "value": "#d6409f",
    "variable": "var(--colors-pink-light-9)"
  },
  "colors.pink.light.10": {
    "value": "#cf3897",
    "variable": "var(--colors-pink-light-10)"
  },
  "colors.pink.light.11": {
    "value": "#c2298a",
    "variable": "var(--colors-pink-light-11)"
  },
  "colors.pink.light.12": {
    "value": "#651249",
    "variable": "var(--colors-pink-light-12)"
  },
  "colors.pink.light.a1": {
    "value": "#ff00aa03",
    "variable": "var(--colors-pink-light-a1)"
  },
  "colors.pink.light.a2": {
    "value": "#e0008008",
    "variable": "var(--colors-pink-light-a2)"
  },
  "colors.pink.light.a3": {
    "value": "#f4008c16",
    "variable": "var(--colors-pink-light-a3)"
  },
  "colors.pink.light.a4": {
    "value": "#e2008b23",
    "variable": "var(--colors-pink-light-a4)"
  },
  "colors.pink.light.a5": {
    "value": "#d1008331",
    "variable": "var(--colors-pink-light-a5)"
  },
  "colors.pink.light.a6": {
    "value": "#c0007840",
    "variable": "var(--colors-pink-light-a6)"
  },
  "colors.pink.light.a7": {
    "value": "#b6006f53",
    "variable": "var(--colors-pink-light-a7)"
  },
  "colors.pink.light.a8": {
    "value": "#af006f6c",
    "variable": "var(--colors-pink-light-a8)"
  },
  "colors.pink.light.a9": {
    "value": "#c8007fbf",
    "variable": "var(--colors-pink-light-a9)"
  },
  "colors.pink.light.a10": {
    "value": "#c2007ac7",
    "variable": "var(--colors-pink-light-a10)"
  },
  "colors.pink.light.a11": {
    "value": "#b60074d6",
    "variable": "var(--colors-pink-light-a11)"
  },
  "colors.pink.light.a12": {
    "value": "#59003bed",
    "variable": "var(--colors-pink-light-a12)"
  },
  "colors.pink.dark.1": {
    "value": "#191117",
    "variable": "var(--colors-pink-dark-1)"
  },
  "colors.pink.dark.2": {
    "value": "#21121d",
    "variable": "var(--colors-pink-dark-2)"
  },
  "colors.pink.dark.3": {
    "value": "#37172f",
    "variable": "var(--colors-pink-dark-3)"
  },
  "colors.pink.dark.4": {
    "value": "#4b143d",
    "variable": "var(--colors-pink-dark-4)"
  },
  "colors.pink.dark.5": {
    "value": "#591c47",
    "variable": "var(--colors-pink-dark-5)"
  },
  "colors.pink.dark.6": {
    "value": "#692955",
    "variable": "var(--colors-pink-dark-6)"
  },
  "colors.pink.dark.7": {
    "value": "#833869",
    "variable": "var(--colors-pink-dark-7)"
  },
  "colors.pink.dark.8": {
    "value": "#a84885",
    "variable": "var(--colors-pink-dark-8)"
  },
  "colors.pink.dark.9": {
    "value": "#d6409f",
    "variable": "var(--colors-pink-dark-9)"
  },
  "colors.pink.dark.10": {
    "value": "#de51a8",
    "variable": "var(--colors-pink-dark-10)"
  },
  "colors.pink.dark.11": {
    "value": "#ff8dcc",
    "variable": "var(--colors-pink-dark-11)"
  },
  "colors.pink.dark.12": {
    "value": "#fdd1ea",
    "variable": "var(--colors-pink-dark-12)"
  },
  "colors.pink.dark.a1": {
    "value": "#f412bc09",
    "variable": "var(--colors-pink-dark-a1)"
  },
  "colors.pink.dark.a2": {
    "value": "#f420bb12",
    "variable": "var(--colors-pink-dark-a2)"
  },
  "colors.pink.dark.a3": {
    "value": "#fe37cc29",
    "variable": "var(--colors-pink-dark-a3)"
  },
  "colors.pink.dark.a4": {
    "value": "#fc1ec43f",
    "variable": "var(--colors-pink-dark-a4)"
  },
  "colors.pink.dark.a5": {
    "value": "#fd35c24e",
    "variable": "var(--colors-pink-dark-a5)"
  },
  "colors.pink.dark.a6": {
    "value": "#fd51c75f",
    "variable": "var(--colors-pink-dark-a6)"
  },
  "colors.pink.dark.a7": {
    "value": "#fd62c87b",
    "variable": "var(--colors-pink-dark-a7)"
  },
  "colors.pink.dark.a8": {
    "value": "#ff68c8a2",
    "variable": "var(--colors-pink-dark-a8)"
  },
  "colors.pink.dark.a9": {
    "value": "#fe49bcd4",
    "variable": "var(--colors-pink-dark-a9)"
  },
  "colors.pink.dark.a10": {
    "value": "#ff5cc0dc",
    "variable": "var(--colors-pink-dark-a10)"
  },
  "colors.pink.dark.a11": {
    "value": "#ff8dcc",
    "variable": "var(--colors-pink-dark-a11)"
  },
  "colors.pink.dark.a12": {
    "value": "#ffd3ecfd",
    "variable": "var(--colors-pink-dark-a12)"
  },
  "colors.white": {
    "value": "#ffffff",
    "variable": "var(--colors-white)"
  },
  "colors.white.a1": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-white-a1)"
  },
  "colors.white.a2": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--colors-white-a2)"
  },
  "colors.white.a3": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-white-a3)"
  },
  "colors.white.a4": {
    "value": "rgba(255, 255, 255, 0.2)",
    "variable": "var(--colors-white-a4)"
  },
  "colors.white.a5": {
    "value": "rgba(255, 255, 255, 0.3)",
    "variable": "var(--colors-white-a5)"
  },
  "colors.white.a6": {
    "value": "rgba(255, 255, 255, 0.4)",
    "variable": "var(--colors-white-a6)"
  },
  "colors.white.a7": {
    "value": "rgba(255, 255, 255, 0.5)",
    "variable": "var(--colors-white-a7)"
  },
  "colors.white.a8": {
    "value": "rgba(255, 255, 255, 0.6)",
    "variable": "var(--colors-white-a8)"
  },
  "colors.white.a9": {
    "value": "rgba(255, 255, 255, 0.7)",
    "variable": "var(--colors-white-a9)"
  },
  "colors.white.a10": {
    "value": "rgba(255, 255, 255, 0.8)",
    "variable": "var(--colors-white-a10)"
  },
  "colors.white.a11": {
    "value": "rgba(255, 255, 255, 0.9)",
    "variable": "var(--colors-white-a11)"
  },
  "colors.white.a12": {
    "value": "rgba(255, 255, 255, 0.95)",
    "variable": "var(--colors-white-a12)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.black.a1": {
    "value": "rgba(0, 0, 0, 0.05)",
    "variable": "var(--colors-black-a1)"
  },
  "colors.black.a2": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--colors-black-a2)"
  },
  "colors.black.a3": {
    "value": "rgba(0, 0, 0, 0.15)",
    "variable": "var(--colors-black-a3)"
  },
  "colors.black.a4": {
    "value": "rgba(0, 0, 0, 0.2)",
    "variable": "var(--colors-black-a4)"
  },
  "colors.black.a5": {
    "value": "rgba(0, 0, 0, 0.3)",
    "variable": "var(--colors-black-a5)"
  },
  "colors.black.a6": {
    "value": "rgba(0, 0, 0, 0.4)",
    "variable": "var(--colors-black-a6)"
  },
  "colors.black.a7": {
    "value": "rgba(0, 0, 0, 0.5)",
    "variable": "var(--colors-black-a7)"
  },
  "colors.black.a8": {
    "value": "rgba(0, 0, 0, 0.6)",
    "variable": "var(--colors-black-a8)"
  },
  "colors.black.a9": {
    "value": "rgba(0, 0, 0, 0.7)",
    "variable": "var(--colors-black-a9)"
  },
  "colors.black.a10": {
    "value": "rgba(0, 0, 0, 0.8)",
    "variable": "var(--colors-black-a10)"
  },
  "colors.black.a11": {
    "value": "rgba(0, 0, 0, 0.9)",
    "variable": "var(--colors-black-a11)"
  },
  "colors.black.a12": {
    "value": "rgba(0, 0, 0, 0.95)",
    "variable": "var(--colors-black-a12)"
  },
  "zIndex.hide": {
    "value": -1,
    "variable": "var(--z-index-hide)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--z-index-base)"
  },
  "zIndex.docked": {
    "value": 10,
    "variable": "var(--z-index-docked)"
  },
  "zIndex.dropdown": {
    "value": 1000,
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.sticky": {
    "value": 1100,
    "variable": "var(--z-index-sticky)"
  },
  "zIndex.banner": {
    "value": 1200,
    "variable": "var(--z-index-banner)"
  },
  "zIndex.overlay": {
    "value": 1300,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.modal": {
    "value": 1400,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.popover": {
    "value": 1500,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.skipLink": {
    "value": 1600,
    "variable": "var(--z-index-skip-link)"
  },
  "zIndex.toast": {
    "value": 1700,
    "variable": "var(--z-index-toast)"
  },
  "zIndex.tooltip": {
    "value": 10000,
    "variable": "var(--z-index-tooltip)"
  },
  "shadows.tooltip": {
    "value": "0 12px 32px rgba(0, 0, 0, 0.5), 0 2px 6px rgba(0, 0, 0, 0.3)",
    "variable": "var(--shadows-tooltip)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--breakpoints-2xl)"
  },
  "radii.l1": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-l1)"
  },
  "radii.l2": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-l2)"
  },
  "radii.l3": {
    "value": "var(--radii-xl)",
    "variable": "var(--radii-l3)"
  },
  "colors.terra.alpha": {
    "value": "var(--colors-orange-a2)",
    "variable": "var(--colors-terra-alpha)"
  },
  "colors.terra.alphaEmphasized": {
    "value": "var(--colors-orange-a9)",
    "variable": "var(--colors-terra-alpha-emphasized)"
  },
  "colors.bg.accent.hoverAlpha": {
    "value": "var(--colors-terra-alpha)",
    "variable": "var(--colors-bg-accent-hover-alpha)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--spacing-4\\.5) * -1)",
    "variable": "var(--spacing-4\\.5)"
  },
  "shadows.xs": {
    "value": "var(--shadows-xs)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "var(--shadows-sm)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "var(--shadows-md)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "var(--shadows-lg)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "var(--shadows-xl)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "var(--shadows-2xl)",
    "variable": "var(--shadows-2xl)"
  },
  "colors.gray.1": {
    "value": "var(--colors-gray-1)",
    "variable": "var(--colors-gray-1)"
  },
  "colors.gray.2": {
    "value": "var(--colors-gray-2)",
    "variable": "var(--colors-gray-2)"
  },
  "colors.gray.3": {
    "value": "var(--colors-gray-3)",
    "variable": "var(--colors-gray-3)"
  },
  "colors.gray.4": {
    "value": "var(--colors-gray-4)",
    "variable": "var(--colors-gray-4)"
  },
  "colors.gray.5": {
    "value": "var(--colors-gray-5)",
    "variable": "var(--colors-gray-5)"
  },
  "colors.gray.6": {
    "value": "var(--colors-gray-6)",
    "variable": "var(--colors-gray-6)"
  },
  "colors.gray.7": {
    "value": "var(--colors-gray-7)",
    "variable": "var(--colors-gray-7)"
  },
  "colors.gray.8": {
    "value": "var(--colors-gray-8)",
    "variable": "var(--colors-gray-8)"
  },
  "colors.gray.9": {
    "value": "var(--colors-gray-9)",
    "variable": "var(--colors-gray-9)"
  },
  "colors.gray.10": {
    "value": "var(--colors-gray-10)",
    "variable": "var(--colors-gray-10)"
  },
  "colors.gray.11": {
    "value": "var(--colors-gray-11)",
    "variable": "var(--colors-gray-11)"
  },
  "colors.gray.12": {
    "value": "var(--colors-gray-12)",
    "variable": "var(--colors-gray-12)"
  },
  "colors.gray.a1": {
    "value": "var(--colors-gray-a1)",
    "variable": "var(--colors-gray-a1)"
  },
  "colors.gray.a2": {
    "value": "var(--colors-gray-a2)",
    "variable": "var(--colors-gray-a2)"
  },
  "colors.gray.a3": {
    "value": "var(--colors-gray-a3)",
    "variable": "var(--colors-gray-a3)"
  },
  "colors.gray.a4": {
    "value": "var(--colors-gray-a4)",
    "variable": "var(--colors-gray-a4)"
  },
  "colors.gray.a5": {
    "value": "var(--colors-gray-a5)",
    "variable": "var(--colors-gray-a5)"
  },
  "colors.gray.a6": {
    "value": "var(--colors-gray-a6)",
    "variable": "var(--colors-gray-a6)"
  },
  "colors.gray.a7": {
    "value": "var(--colors-gray-a7)",
    "variable": "var(--colors-gray-a7)"
  },
  "colors.gray.a8": {
    "value": "var(--colors-gray-a8)",
    "variable": "var(--colors-gray-a8)"
  },
  "colors.gray.a9": {
    "value": "var(--colors-gray-a9)",
    "variable": "var(--colors-gray-a9)"
  },
  "colors.gray.a10": {
    "value": "var(--colors-gray-a10)",
    "variable": "var(--colors-gray-a10)"
  },
  "colors.gray.a11": {
    "value": "var(--colors-gray-a11)",
    "variable": "var(--colors-gray-a11)"
  },
  "colors.gray.a12": {
    "value": "var(--colors-gray-a12)",
    "variable": "var(--colors-gray-a12)"
  },
  "colors.gray.default": {
    "value": "var(--colors-gray-default)",
    "variable": "var(--colors-gray-default)"
  },
  "colors.gray.emphasized": {
    "value": "var(--colors-gray-emphasized)",
    "variable": "var(--colors-gray-emphasized)"
  },
  "colors.gray.fg": {
    "value": "var(--colors-gray-fg)",
    "variable": "var(--colors-gray-fg)"
  },
  "colors.gray.text": {
    "value": "var(--colors-gray-text)",
    "variable": "var(--colors-gray-text)"
  },
  "colors.terra.1": {
    "value": "var(--colors-terra-1)",
    "variable": "var(--colors-terra-1)"
  },
  "colors.terra.2": {
    "value": "var(--colors-terra-2)",
    "variable": "var(--colors-terra-2)"
  },
  "colors.terra.3": {
    "value": "var(--colors-terra-3)",
    "variable": "var(--colors-terra-3)"
  },
  "colors.terra.4": {
    "value": "var(--colors-terra-4)",
    "variable": "var(--colors-terra-4)"
  },
  "colors.terra.5": {
    "value": "var(--colors-terra-5)",
    "variable": "var(--colors-terra-5)"
  },
  "colors.terra.6": {
    "value": "var(--colors-terra-6)",
    "variable": "var(--colors-terra-6)"
  },
  "colors.terra.7": {
    "value": "var(--colors-terra-7)",
    "variable": "var(--colors-terra-7)"
  },
  "colors.terra.8": {
    "value": "var(--colors-terra-8)",
    "variable": "var(--colors-terra-8)"
  },
  "colors.terra.9": {
    "value": "var(--colors-terra-9)",
    "variable": "var(--colors-terra-9)"
  },
  "colors.terra.10": {
    "value": "var(--colors-terra-10)",
    "variable": "var(--colors-terra-10)"
  },
  "colors.terra.11": {
    "value": "var(--colors-terra-11)",
    "variable": "var(--colors-terra-11)"
  },
  "colors.terra.12": {
    "value": "var(--colors-terra-12)",
    "variable": "var(--colors-terra-12)"
  },
  "colors.terra.a1": {
    "value": "var(--colors-terra-a1)",
    "variable": "var(--colors-terra-a1)"
  },
  "colors.terra.a2": {
    "value": "var(--colors-terra-a2)",
    "variable": "var(--colors-terra-a2)"
  },
  "colors.terra.a3": {
    "value": "var(--colors-terra-a3)",
    "variable": "var(--colors-terra-a3)"
  },
  "colors.terra.a4": {
    "value": "var(--colors-terra-a4)",
    "variable": "var(--colors-terra-a4)"
  },
  "colors.terra.a5": {
    "value": "var(--colors-terra-a5)",
    "variable": "var(--colors-terra-a5)"
  },
  "colors.terra.a6": {
    "value": "var(--colors-terra-a6)",
    "variable": "var(--colors-terra-a6)"
  },
  "colors.terra.a7": {
    "value": "var(--colors-terra-a7)",
    "variable": "var(--colors-terra-a7)"
  },
  "colors.terra.a8": {
    "value": "var(--colors-terra-a8)",
    "variable": "var(--colors-terra-a8)"
  },
  "colors.terra.a9": {
    "value": "var(--colors-terra-a9)",
    "variable": "var(--colors-terra-a9)"
  },
  "colors.terra.a10": {
    "value": "var(--colors-terra-a10)",
    "variable": "var(--colors-terra-a10)"
  },
  "colors.terra.a11": {
    "value": "var(--colors-terra-a11)",
    "variable": "var(--colors-terra-a11)"
  },
  "colors.terra.a12": {
    "value": "var(--colors-terra-a12)",
    "variable": "var(--colors-terra-a12)"
  },
  "colors.terra.default": {
    "value": "var(--colors-terra-default)",
    "variable": "var(--colors-terra-default)"
  },
  "colors.terra.emphasized": {
    "value": "var(--colors-terra-emphasized)",
    "variable": "var(--colors-terra-emphasized)"
  },
  "colors.terra.fg": {
    "value": "var(--colors-terra-fg)",
    "variable": "var(--colors-terra-fg)"
  },
  "colors.terra.surface": {
    "value": "var(--colors-terra-surface)",
    "variable": "var(--colors-terra-surface)"
  },
  "colors.terra.indicator": {
    "value": "var(--colors-terra-indicator)",
    "variable": "var(--colors-terra-indicator)"
  },
  "colors.terra.track": {
    "value": "var(--colors-terra-track)",
    "variable": "var(--colors-terra-track)"
  },
  "colors.lilac.1": {
    "value": "var(--colors-lilac-1)",
    "variable": "var(--colors-lilac-1)"
  },
  "colors.lilac.2": {
    "value": "var(--colors-lilac-2)",
    "variable": "var(--colors-lilac-2)"
  },
  "colors.lilac.3": {
    "value": "var(--colors-lilac-3)",
    "variable": "var(--colors-lilac-3)"
  },
  "colors.lilac.4": {
    "value": "var(--colors-lilac-4)",
    "variable": "var(--colors-lilac-4)"
  },
  "colors.lilac.5": {
    "value": "var(--colors-lilac-5)",
    "variable": "var(--colors-lilac-5)"
  },
  "colors.lilac.6": {
    "value": "var(--colors-lilac-6)",
    "variable": "var(--colors-lilac-6)"
  },
  "colors.lilac.7": {
    "value": "var(--colors-lilac-7)",
    "variable": "var(--colors-lilac-7)"
  },
  "colors.lilac.8": {
    "value": "var(--colors-lilac-8)",
    "variable": "var(--colors-lilac-8)"
  },
  "colors.lilac.9": {
    "value": "var(--colors-lilac-9)",
    "variable": "var(--colors-lilac-9)"
  },
  "colors.lilac.10": {
    "value": "var(--colors-lilac-10)",
    "variable": "var(--colors-lilac-10)"
  },
  "colors.lilac.11": {
    "value": "var(--colors-lilac-11)",
    "variable": "var(--colors-lilac-11)"
  },
  "colors.lilac.12": {
    "value": "var(--colors-lilac-12)",
    "variable": "var(--colors-lilac-12)"
  },
  "colors.lilac.a1": {
    "value": "var(--colors-lilac-a1)",
    "variable": "var(--colors-lilac-a1)"
  },
  "colors.lilac.a2": {
    "value": "var(--colors-lilac-a2)",
    "variable": "var(--colors-lilac-a2)"
  },
  "colors.lilac.a3": {
    "value": "var(--colors-lilac-a3)",
    "variable": "var(--colors-lilac-a3)"
  },
  "colors.lilac.a4": {
    "value": "var(--colors-lilac-a4)",
    "variable": "var(--colors-lilac-a4)"
  },
  "colors.lilac.a5": {
    "value": "var(--colors-lilac-a5)",
    "variable": "var(--colors-lilac-a5)"
  },
  "colors.lilac.a6": {
    "value": "var(--colors-lilac-a6)",
    "variable": "var(--colors-lilac-a6)"
  },
  "colors.lilac.a7": {
    "value": "var(--colors-lilac-a7)",
    "variable": "var(--colors-lilac-a7)"
  },
  "colors.lilac.a8": {
    "value": "var(--colors-lilac-a8)",
    "variable": "var(--colors-lilac-a8)"
  },
  "colors.lilac.a9": {
    "value": "var(--colors-lilac-a9)",
    "variable": "var(--colors-lilac-a9)"
  },
  "colors.lilac.a10": {
    "value": "var(--colors-lilac-a10)",
    "variable": "var(--colors-lilac-a10)"
  },
  "colors.lilac.a11": {
    "value": "var(--colors-lilac-a11)",
    "variable": "var(--colors-lilac-a11)"
  },
  "colors.lilac.a12": {
    "value": "var(--colors-lilac-a12)",
    "variable": "var(--colors-lilac-a12)"
  },
  "colors.lilac.default": {
    "value": "var(--colors-lilac-default)",
    "variable": "var(--colors-lilac-default)"
  },
  "colors.lilac.emphasized": {
    "value": "var(--colors-lilac-emphasized)",
    "variable": "var(--colors-lilac-emphasized)"
  },
  "colors.lilac.fg": {
    "value": "var(--colors-lilac-fg)",
    "variable": "var(--colors-lilac-fg)"
  },
  "colors.lilac.surface": {
    "value": "var(--colors-lilac-surface)",
    "variable": "var(--colors-lilac-surface)"
  },
  "colors.lilac.indicator": {
    "value": "var(--colors-lilac-indicator)",
    "variable": "var(--colors-lilac-indicator)"
  },
  "colors.lilac.track": {
    "value": "var(--colors-lilac-track)",
    "variable": "var(--colors-lilac-track)"
  },
  "colors.moss.1": {
    "value": "var(--colors-moss-1)",
    "variable": "var(--colors-moss-1)"
  },
  "colors.moss.2": {
    "value": "var(--colors-moss-2)",
    "variable": "var(--colors-moss-2)"
  },
  "colors.moss.3": {
    "value": "var(--colors-moss-3)",
    "variable": "var(--colors-moss-3)"
  },
  "colors.moss.4": {
    "value": "var(--colors-moss-4)",
    "variable": "var(--colors-moss-4)"
  },
  "colors.moss.5": {
    "value": "var(--colors-moss-5)",
    "variable": "var(--colors-moss-5)"
  },
  "colors.moss.6": {
    "value": "var(--colors-moss-6)",
    "variable": "var(--colors-moss-6)"
  },
  "colors.moss.7": {
    "value": "var(--colors-moss-7)",
    "variable": "var(--colors-moss-7)"
  },
  "colors.moss.8": {
    "value": "var(--colors-moss-8)",
    "variable": "var(--colors-moss-8)"
  },
  "colors.moss.9": {
    "value": "var(--colors-moss-9)",
    "variable": "var(--colors-moss-9)"
  },
  "colors.moss.10": {
    "value": "var(--colors-moss-10)",
    "variable": "var(--colors-moss-10)"
  },
  "colors.moss.11": {
    "value": "var(--colors-moss-11)",
    "variable": "var(--colors-moss-11)"
  },
  "colors.moss.12": {
    "value": "var(--colors-moss-12)",
    "variable": "var(--colors-moss-12)"
  },
  "colors.red.1": {
    "value": "var(--colors-red-1)",
    "variable": "var(--colors-red-1)"
  },
  "colors.red.2": {
    "value": "var(--colors-red-2)",
    "variable": "var(--colors-red-2)"
  },
  "colors.red.3": {
    "value": "var(--colors-red-3)",
    "variable": "var(--colors-red-3)"
  },
  "colors.red.4": {
    "value": "var(--colors-red-4)",
    "variable": "var(--colors-red-4)"
  },
  "colors.red.5": {
    "value": "var(--colors-red-5)",
    "variable": "var(--colors-red-5)"
  },
  "colors.red.6": {
    "value": "var(--colors-red-6)",
    "variable": "var(--colors-red-6)"
  },
  "colors.red.7": {
    "value": "var(--colors-red-7)",
    "variable": "var(--colors-red-7)"
  },
  "colors.red.8": {
    "value": "var(--colors-red-8)",
    "variable": "var(--colors-red-8)"
  },
  "colors.red.9": {
    "value": "var(--colors-red-9)",
    "variable": "var(--colors-red-9)"
  },
  "colors.red.10": {
    "value": "var(--colors-red-10)",
    "variable": "var(--colors-red-10)"
  },
  "colors.red.11": {
    "value": "var(--colors-red-11)",
    "variable": "var(--colors-red-11)"
  },
  "colors.red.12": {
    "value": "var(--colors-red-12)",
    "variable": "var(--colors-red-12)"
  },
  "colors.red.a1": {
    "value": "var(--colors-red-a1)",
    "variable": "var(--colors-red-a1)"
  },
  "colors.red.a2": {
    "value": "var(--colors-red-a2)",
    "variable": "var(--colors-red-a2)"
  },
  "colors.red.a3": {
    "value": "var(--colors-red-a3)",
    "variable": "var(--colors-red-a3)"
  },
  "colors.red.a4": {
    "value": "var(--colors-red-a4)",
    "variable": "var(--colors-red-a4)"
  },
  "colors.red.a5": {
    "value": "var(--colors-red-a5)",
    "variable": "var(--colors-red-a5)"
  },
  "colors.red.a6": {
    "value": "var(--colors-red-a6)",
    "variable": "var(--colors-red-a6)"
  },
  "colors.red.a7": {
    "value": "var(--colors-red-a7)",
    "variable": "var(--colors-red-a7)"
  },
  "colors.red.a8": {
    "value": "var(--colors-red-a8)",
    "variable": "var(--colors-red-a8)"
  },
  "colors.red.a9": {
    "value": "var(--colors-red-a9)",
    "variable": "var(--colors-red-a9)"
  },
  "colors.red.a10": {
    "value": "var(--colors-red-a10)",
    "variable": "var(--colors-red-a10)"
  },
  "colors.red.a11": {
    "value": "var(--colors-red-a11)",
    "variable": "var(--colors-red-a11)"
  },
  "colors.red.a12": {
    "value": "var(--colors-red-a12)",
    "variable": "var(--colors-red-a12)"
  },
  "colors.red.default": {
    "value": "var(--colors-red-default)",
    "variable": "var(--colors-red-default)"
  },
  "colors.red.emphasized": {
    "value": "var(--colors-red-emphasized)",
    "variable": "var(--colors-red-emphasized)"
  },
  "colors.red.fg": {
    "value": "var(--colors-red-fg)",
    "variable": "var(--colors-red-fg)"
  },
  "colors.red.text": {
    "value": "var(--colors-red-text)",
    "variable": "var(--colors-red-text)"
  },
  "colors.violet.1": {
    "value": "var(--colors-violet-1)",
    "variable": "var(--colors-violet-1)"
  },
  "colors.violet.2": {
    "value": "var(--colors-violet-2)",
    "variable": "var(--colors-violet-2)"
  },
  "colors.violet.3": {
    "value": "var(--colors-violet-3)",
    "variable": "var(--colors-violet-3)"
  },
  "colors.violet.4": {
    "value": "var(--colors-violet-4)",
    "variable": "var(--colors-violet-4)"
  },
  "colors.violet.5": {
    "value": "var(--colors-violet-5)",
    "variable": "var(--colors-violet-5)"
  },
  "colors.violet.6": {
    "value": "var(--colors-violet-6)",
    "variable": "var(--colors-violet-6)"
  },
  "colors.violet.7": {
    "value": "var(--colors-violet-7)",
    "variable": "var(--colors-violet-7)"
  },
  "colors.violet.8": {
    "value": "var(--colors-violet-8)",
    "variable": "var(--colors-violet-8)"
  },
  "colors.violet.9": {
    "value": "var(--colors-violet-9)",
    "variable": "var(--colors-violet-9)"
  },
  "colors.violet.10": {
    "value": "var(--colors-violet-10)",
    "variable": "var(--colors-violet-10)"
  },
  "colors.violet.11": {
    "value": "var(--colors-violet-11)",
    "variable": "var(--colors-violet-11)"
  },
  "colors.violet.12": {
    "value": "var(--colors-violet-12)",
    "variable": "var(--colors-violet-12)"
  },
  "colors.violet.a1": {
    "value": "var(--colors-violet-a1)",
    "variable": "var(--colors-violet-a1)"
  },
  "colors.violet.a2": {
    "value": "var(--colors-violet-a2)",
    "variable": "var(--colors-violet-a2)"
  },
  "colors.violet.a3": {
    "value": "var(--colors-violet-a3)",
    "variable": "var(--colors-violet-a3)"
  },
  "colors.violet.a4": {
    "value": "var(--colors-violet-a4)",
    "variable": "var(--colors-violet-a4)"
  },
  "colors.violet.a5": {
    "value": "var(--colors-violet-a5)",
    "variable": "var(--colors-violet-a5)"
  },
  "colors.violet.a6": {
    "value": "var(--colors-violet-a6)",
    "variable": "var(--colors-violet-a6)"
  },
  "colors.violet.a7": {
    "value": "var(--colors-violet-a7)",
    "variable": "var(--colors-violet-a7)"
  },
  "colors.violet.a8": {
    "value": "var(--colors-violet-a8)",
    "variable": "var(--colors-violet-a8)"
  },
  "colors.violet.a9": {
    "value": "var(--colors-violet-a9)",
    "variable": "var(--colors-violet-a9)"
  },
  "colors.violet.a10": {
    "value": "var(--colors-violet-a10)",
    "variable": "var(--colors-violet-a10)"
  },
  "colors.violet.a11": {
    "value": "var(--colors-violet-a11)",
    "variable": "var(--colors-violet-a11)"
  },
  "colors.violet.a12": {
    "value": "var(--colors-violet-a12)",
    "variable": "var(--colors-violet-a12)"
  },
  "colors.violet.default": {
    "value": "var(--colors-violet-default)",
    "variable": "var(--colors-violet-default)"
  },
  "colors.violet.emphasized": {
    "value": "var(--colors-violet-emphasized)",
    "variable": "var(--colors-violet-emphasized)"
  },
  "colors.violet.fg": {
    "value": "var(--colors-violet-fg)",
    "variable": "var(--colors-violet-fg)"
  },
  "colors.violet.text": {
    "value": "var(--colors-violet-text)",
    "variable": "var(--colors-violet-text)"
  },
  "colors.purple.1": {
    "value": "var(--colors-purple-1)",
    "variable": "var(--colors-purple-1)"
  },
  "colors.purple.2": {
    "value": "var(--colors-purple-2)",
    "variable": "var(--colors-purple-2)"
  },
  "colors.purple.3": {
    "value": "var(--colors-purple-3)",
    "variable": "var(--colors-purple-3)"
  },
  "colors.purple.4": {
    "value": "var(--colors-purple-4)",
    "variable": "var(--colors-purple-4)"
  },
  "colors.purple.5": {
    "value": "var(--colors-purple-5)",
    "variable": "var(--colors-purple-5)"
  },
  "colors.purple.6": {
    "value": "var(--colors-purple-6)",
    "variable": "var(--colors-purple-6)"
  },
  "colors.purple.7": {
    "value": "var(--colors-purple-7)",
    "variable": "var(--colors-purple-7)"
  },
  "colors.purple.8": {
    "value": "var(--colors-purple-8)",
    "variable": "var(--colors-purple-8)"
  },
  "colors.purple.9": {
    "value": "var(--colors-purple-9)",
    "variable": "var(--colors-purple-9)"
  },
  "colors.purple.10": {
    "value": "var(--colors-purple-10)",
    "variable": "var(--colors-purple-10)"
  },
  "colors.purple.11": {
    "value": "var(--colors-purple-11)",
    "variable": "var(--colors-purple-11)"
  },
  "colors.purple.12": {
    "value": "var(--colors-purple-12)",
    "variable": "var(--colors-purple-12)"
  },
  "colors.purple.a1": {
    "value": "var(--colors-purple-a1)",
    "variable": "var(--colors-purple-a1)"
  },
  "colors.purple.a2": {
    "value": "var(--colors-purple-a2)",
    "variable": "var(--colors-purple-a2)"
  },
  "colors.purple.a3": {
    "value": "var(--colors-purple-a3)",
    "variable": "var(--colors-purple-a3)"
  },
  "colors.purple.a4": {
    "value": "var(--colors-purple-a4)",
    "variable": "var(--colors-purple-a4)"
  },
  "colors.purple.a5": {
    "value": "var(--colors-purple-a5)",
    "variable": "var(--colors-purple-a5)"
  },
  "colors.purple.a6": {
    "value": "var(--colors-purple-a6)",
    "variable": "var(--colors-purple-a6)"
  },
  "colors.purple.a7": {
    "value": "var(--colors-purple-a7)",
    "variable": "var(--colors-purple-a7)"
  },
  "colors.purple.a8": {
    "value": "var(--colors-purple-a8)",
    "variable": "var(--colors-purple-a8)"
  },
  "colors.purple.a9": {
    "value": "var(--colors-purple-a9)",
    "variable": "var(--colors-purple-a9)"
  },
  "colors.purple.a10": {
    "value": "var(--colors-purple-a10)",
    "variable": "var(--colors-purple-a10)"
  },
  "colors.purple.a11": {
    "value": "var(--colors-purple-a11)",
    "variable": "var(--colors-purple-a11)"
  },
  "colors.purple.a12": {
    "value": "var(--colors-purple-a12)",
    "variable": "var(--colors-purple-a12)"
  },
  "colors.purple.default": {
    "value": "var(--colors-purple-default)",
    "variable": "var(--colors-purple-default)"
  },
  "colors.purple.emphasized": {
    "value": "var(--colors-purple-emphasized)",
    "variable": "var(--colors-purple-emphasized)"
  },
  "colors.purple.fg": {
    "value": "var(--colors-purple-fg)",
    "variable": "var(--colors-purple-fg)"
  },
  "colors.purple.text": {
    "value": "var(--colors-purple-text)",
    "variable": "var(--colors-purple-text)"
  },
  "colors.crimson.1": {
    "value": "var(--colors-crimson-1)",
    "variable": "var(--colors-crimson-1)"
  },
  "colors.crimson.2": {
    "value": "var(--colors-crimson-2)",
    "variable": "var(--colors-crimson-2)"
  },
  "colors.crimson.3": {
    "value": "var(--colors-crimson-3)",
    "variable": "var(--colors-crimson-3)"
  },
  "colors.crimson.4": {
    "value": "var(--colors-crimson-4)",
    "variable": "var(--colors-crimson-4)"
  },
  "colors.crimson.5": {
    "value": "var(--colors-crimson-5)",
    "variable": "var(--colors-crimson-5)"
  },
  "colors.crimson.6": {
    "value": "var(--colors-crimson-6)",
    "variable": "var(--colors-crimson-6)"
  },
  "colors.crimson.7": {
    "value": "var(--colors-crimson-7)",
    "variable": "var(--colors-crimson-7)"
  },
  "colors.crimson.8": {
    "value": "var(--colors-crimson-8)",
    "variable": "var(--colors-crimson-8)"
  },
  "colors.crimson.9": {
    "value": "var(--colors-crimson-9)",
    "variable": "var(--colors-crimson-9)"
  },
  "colors.crimson.10": {
    "value": "var(--colors-crimson-10)",
    "variable": "var(--colors-crimson-10)"
  },
  "colors.crimson.11": {
    "value": "var(--colors-crimson-11)",
    "variable": "var(--colors-crimson-11)"
  },
  "colors.crimson.12": {
    "value": "var(--colors-crimson-12)",
    "variable": "var(--colors-crimson-12)"
  },
  "colors.crimson.a1": {
    "value": "var(--colors-crimson-a1)",
    "variable": "var(--colors-crimson-a1)"
  },
  "colors.crimson.a2": {
    "value": "var(--colors-crimson-a2)",
    "variable": "var(--colors-crimson-a2)"
  },
  "colors.crimson.a3": {
    "value": "var(--colors-crimson-a3)",
    "variable": "var(--colors-crimson-a3)"
  },
  "colors.crimson.a4": {
    "value": "var(--colors-crimson-a4)",
    "variable": "var(--colors-crimson-a4)"
  },
  "colors.crimson.a5": {
    "value": "var(--colors-crimson-a5)",
    "variable": "var(--colors-crimson-a5)"
  },
  "colors.crimson.a6": {
    "value": "var(--colors-crimson-a6)",
    "variable": "var(--colors-crimson-a6)"
  },
  "colors.crimson.a7": {
    "value": "var(--colors-crimson-a7)",
    "variable": "var(--colors-crimson-a7)"
  },
  "colors.crimson.a8": {
    "value": "var(--colors-crimson-a8)",
    "variable": "var(--colors-crimson-a8)"
  },
  "colors.crimson.a9": {
    "value": "var(--colors-crimson-a9)",
    "variable": "var(--colors-crimson-a9)"
  },
  "colors.crimson.a10": {
    "value": "var(--colors-crimson-a10)",
    "variable": "var(--colors-crimson-a10)"
  },
  "colors.crimson.a11": {
    "value": "var(--colors-crimson-a11)",
    "variable": "var(--colors-crimson-a11)"
  },
  "colors.crimson.a12": {
    "value": "var(--colors-crimson-a12)",
    "variable": "var(--colors-crimson-a12)"
  },
  "colors.crimson.default": {
    "value": "var(--colors-crimson-default)",
    "variable": "var(--colors-crimson-default)"
  },
  "colors.crimson.emphasized": {
    "value": "var(--colors-crimson-emphasized)",
    "variable": "var(--colors-crimson-emphasized)"
  },
  "colors.crimson.fg": {
    "value": "var(--colors-crimson-fg)",
    "variable": "var(--colors-crimson-fg)"
  },
  "colors.crimson.text": {
    "value": "var(--colors-crimson-text)",
    "variable": "var(--colors-crimson-text)"
  },
  "colors.orange.1": {
    "value": "var(--colors-orange-1)",
    "variable": "var(--colors-orange-1)"
  },
  "colors.orange.2": {
    "value": "var(--colors-orange-2)",
    "variable": "var(--colors-orange-2)"
  },
  "colors.orange.3": {
    "value": "var(--colors-orange-3)",
    "variable": "var(--colors-orange-3)"
  },
  "colors.orange.4": {
    "value": "var(--colors-orange-4)",
    "variable": "var(--colors-orange-4)"
  },
  "colors.orange.5": {
    "value": "var(--colors-orange-5)",
    "variable": "var(--colors-orange-5)"
  },
  "colors.orange.6": {
    "value": "var(--colors-orange-6)",
    "variable": "var(--colors-orange-6)"
  },
  "colors.orange.7": {
    "value": "var(--colors-orange-7)",
    "variable": "var(--colors-orange-7)"
  },
  "colors.orange.8": {
    "value": "var(--colors-orange-8)",
    "variable": "var(--colors-orange-8)"
  },
  "colors.orange.9": {
    "value": "var(--colors-orange-9)",
    "variable": "var(--colors-orange-9)"
  },
  "colors.orange.10": {
    "value": "var(--colors-orange-10)",
    "variable": "var(--colors-orange-10)"
  },
  "colors.orange.11": {
    "value": "var(--colors-orange-11)",
    "variable": "var(--colors-orange-11)"
  },
  "colors.orange.12": {
    "value": "var(--colors-orange-12)",
    "variable": "var(--colors-orange-12)"
  },
  "colors.orange.a1": {
    "value": "var(--colors-orange-a1)",
    "variable": "var(--colors-orange-a1)"
  },
  "colors.orange.a2": {
    "value": "var(--colors-orange-a2)",
    "variable": "var(--colors-orange-a2)"
  },
  "colors.orange.a3": {
    "value": "var(--colors-orange-a3)",
    "variable": "var(--colors-orange-a3)"
  },
  "colors.orange.a4": {
    "value": "var(--colors-orange-a4)",
    "variable": "var(--colors-orange-a4)"
  },
  "colors.orange.a5": {
    "value": "var(--colors-orange-a5)",
    "variable": "var(--colors-orange-a5)"
  },
  "colors.orange.a6": {
    "value": "var(--colors-orange-a6)",
    "variable": "var(--colors-orange-a6)"
  },
  "colors.orange.a7": {
    "value": "var(--colors-orange-a7)",
    "variable": "var(--colors-orange-a7)"
  },
  "colors.orange.a8": {
    "value": "var(--colors-orange-a8)",
    "variable": "var(--colors-orange-a8)"
  },
  "colors.orange.a9": {
    "value": "var(--colors-orange-a9)",
    "variable": "var(--colors-orange-a9)"
  },
  "colors.orange.a10": {
    "value": "var(--colors-orange-a10)",
    "variable": "var(--colors-orange-a10)"
  },
  "colors.orange.a11": {
    "value": "var(--colors-orange-a11)",
    "variable": "var(--colors-orange-a11)"
  },
  "colors.orange.a12": {
    "value": "var(--colors-orange-a12)",
    "variable": "var(--colors-orange-a12)"
  },
  "colors.orange.default": {
    "value": "var(--colors-orange-default)",
    "variable": "var(--colors-orange-default)"
  },
  "colors.orange.emphasized": {
    "value": "var(--colors-orange-emphasized)",
    "variable": "var(--colors-orange-emphasized)"
  },
  "colors.orange.fg": {
    "value": "var(--colors-orange-fg)",
    "variable": "var(--colors-orange-fg)"
  },
  "colors.orange.text": {
    "value": "var(--colors-orange-text)",
    "variable": "var(--colors-orange-text)"
  },
  "colors.neutral.1": {
    "value": "var(--colors-neutral-1)",
    "variable": "var(--colors-neutral-1)"
  },
  "colors.neutral.2": {
    "value": "var(--colors-neutral-2)",
    "variable": "var(--colors-neutral-2)"
  },
  "colors.neutral.3": {
    "value": "var(--colors-neutral-3)",
    "variable": "var(--colors-neutral-3)"
  },
  "colors.neutral.4": {
    "value": "var(--colors-neutral-4)",
    "variable": "var(--colors-neutral-4)"
  },
  "colors.neutral.5": {
    "value": "var(--colors-neutral-5)",
    "variable": "var(--colors-neutral-5)"
  },
  "colors.neutral.6": {
    "value": "var(--colors-neutral-6)",
    "variable": "var(--colors-neutral-6)"
  },
  "colors.neutral.7": {
    "value": "var(--colors-neutral-7)",
    "variable": "var(--colors-neutral-7)"
  },
  "colors.neutral.8": {
    "value": "var(--colors-neutral-8)",
    "variable": "var(--colors-neutral-8)"
  },
  "colors.neutral.9": {
    "value": "var(--colors-neutral-9)",
    "variable": "var(--colors-neutral-9)"
  },
  "colors.neutral.10": {
    "value": "var(--colors-neutral-10)",
    "variable": "var(--colors-neutral-10)"
  },
  "colors.neutral.11": {
    "value": "var(--colors-neutral-11)",
    "variable": "var(--colors-neutral-11)"
  },
  "colors.neutral.12": {
    "value": "var(--colors-neutral-12)",
    "variable": "var(--colors-neutral-12)"
  },
  "colors.neutral.a1": {
    "value": "var(--colors-neutral-a1)",
    "variable": "var(--colors-neutral-a1)"
  },
  "colors.neutral.a2": {
    "value": "var(--colors-neutral-a2)",
    "variable": "var(--colors-neutral-a2)"
  },
  "colors.neutral.a3": {
    "value": "var(--colors-neutral-a3)",
    "variable": "var(--colors-neutral-a3)"
  },
  "colors.neutral.a4": {
    "value": "var(--colors-neutral-a4)",
    "variable": "var(--colors-neutral-a4)"
  },
  "colors.neutral.a5": {
    "value": "var(--colors-neutral-a5)",
    "variable": "var(--colors-neutral-a5)"
  },
  "colors.neutral.a6": {
    "value": "var(--colors-neutral-a6)",
    "variable": "var(--colors-neutral-a6)"
  },
  "colors.neutral.a7": {
    "value": "var(--colors-neutral-a7)",
    "variable": "var(--colors-neutral-a7)"
  },
  "colors.neutral.a8": {
    "value": "var(--colors-neutral-a8)",
    "variable": "var(--colors-neutral-a8)"
  },
  "colors.neutral.a9": {
    "value": "var(--colors-neutral-a9)",
    "variable": "var(--colors-neutral-a9)"
  },
  "colors.neutral.a10": {
    "value": "var(--colors-neutral-a10)",
    "variable": "var(--colors-neutral-a10)"
  },
  "colors.neutral.a11": {
    "value": "var(--colors-neutral-a11)",
    "variable": "var(--colors-neutral-a11)"
  },
  "colors.neutral.a12": {
    "value": "var(--colors-neutral-a12)",
    "variable": "var(--colors-neutral-a12)"
  },
  "colors.neutral.default": {
    "value": "var(--colors-neutral-default)",
    "variable": "var(--colors-neutral-default)"
  },
  "colors.neutral.emphasized": {
    "value": "var(--colors-neutral-emphasized)",
    "variable": "var(--colors-neutral-emphasized)"
  },
  "colors.neutral.fg": {
    "value": "var(--colors-neutral-fg)",
    "variable": "var(--colors-neutral-fg)"
  },
  "colors.neutral.text": {
    "value": "var(--colors-neutral-text)",
    "variable": "var(--colors-neutral-text)"
  },
  "colors.green.1": {
    "value": "var(--colors-green-1)",
    "variable": "var(--colors-green-1)"
  },
  "colors.green.2": {
    "value": "var(--colors-green-2)",
    "variable": "var(--colors-green-2)"
  },
  "colors.green.3": {
    "value": "var(--colors-green-3)",
    "variable": "var(--colors-green-3)"
  },
  "colors.green.4": {
    "value": "var(--colors-green-4)",
    "variable": "var(--colors-green-4)"
  },
  "colors.green.5": {
    "value": "var(--colors-green-5)",
    "variable": "var(--colors-green-5)"
  },
  "colors.green.6": {
    "value": "var(--colors-green-6)",
    "variable": "var(--colors-green-6)"
  },
  "colors.green.7": {
    "value": "var(--colors-green-7)",
    "variable": "var(--colors-green-7)"
  },
  "colors.green.8": {
    "value": "var(--colors-green-8)",
    "variable": "var(--colors-green-8)"
  },
  "colors.green.9": {
    "value": "var(--colors-green-9)",
    "variable": "var(--colors-green-9)"
  },
  "colors.green.10": {
    "value": "var(--colors-green-10)",
    "variable": "var(--colors-green-10)"
  },
  "colors.green.11": {
    "value": "var(--colors-green-11)",
    "variable": "var(--colors-green-11)"
  },
  "colors.green.12": {
    "value": "var(--colors-green-12)",
    "variable": "var(--colors-green-12)"
  },
  "colors.green.a1": {
    "value": "var(--colors-green-a1)",
    "variable": "var(--colors-green-a1)"
  },
  "colors.green.a2": {
    "value": "var(--colors-green-a2)",
    "variable": "var(--colors-green-a2)"
  },
  "colors.green.a3": {
    "value": "var(--colors-green-a3)",
    "variable": "var(--colors-green-a3)"
  },
  "colors.green.a4": {
    "value": "var(--colors-green-a4)",
    "variable": "var(--colors-green-a4)"
  },
  "colors.green.a5": {
    "value": "var(--colors-green-a5)",
    "variable": "var(--colors-green-a5)"
  },
  "colors.green.a6": {
    "value": "var(--colors-green-a6)",
    "variable": "var(--colors-green-a6)"
  },
  "colors.green.a7": {
    "value": "var(--colors-green-a7)",
    "variable": "var(--colors-green-a7)"
  },
  "colors.green.a8": {
    "value": "var(--colors-green-a8)",
    "variable": "var(--colors-green-a8)"
  },
  "colors.green.a9": {
    "value": "var(--colors-green-a9)",
    "variable": "var(--colors-green-a9)"
  },
  "colors.green.a10": {
    "value": "var(--colors-green-a10)",
    "variable": "var(--colors-green-a10)"
  },
  "colors.green.a11": {
    "value": "var(--colors-green-a11)",
    "variable": "var(--colors-green-a11)"
  },
  "colors.green.a12": {
    "value": "var(--colors-green-a12)",
    "variable": "var(--colors-green-a12)"
  },
  "colors.green.default": {
    "value": "var(--colors-green-default)",
    "variable": "var(--colors-green-default)"
  },
  "colors.green.emphasized": {
    "value": "var(--colors-green-emphasized)",
    "variable": "var(--colors-green-emphasized)"
  },
  "colors.green.fg": {
    "value": "var(--colors-green-fg)",
    "variable": "var(--colors-green-fg)"
  },
  "colors.green.text": {
    "value": "var(--colors-green-text)",
    "variable": "var(--colors-green-text)"
  },
  "colors.tomato.1": {
    "value": "var(--colors-tomato-1)",
    "variable": "var(--colors-tomato-1)"
  },
  "colors.tomato.2": {
    "value": "var(--colors-tomato-2)",
    "variable": "var(--colors-tomato-2)"
  },
  "colors.tomato.3": {
    "value": "var(--colors-tomato-3)",
    "variable": "var(--colors-tomato-3)"
  },
  "colors.tomato.4": {
    "value": "var(--colors-tomato-4)",
    "variable": "var(--colors-tomato-4)"
  },
  "colors.tomato.5": {
    "value": "var(--colors-tomato-5)",
    "variable": "var(--colors-tomato-5)"
  },
  "colors.tomato.6": {
    "value": "var(--colors-tomato-6)",
    "variable": "var(--colors-tomato-6)"
  },
  "colors.tomato.7": {
    "value": "var(--colors-tomato-7)",
    "variable": "var(--colors-tomato-7)"
  },
  "colors.tomato.8": {
    "value": "var(--colors-tomato-8)",
    "variable": "var(--colors-tomato-8)"
  },
  "colors.tomato.9": {
    "value": "var(--colors-tomato-9)",
    "variable": "var(--colors-tomato-9)"
  },
  "colors.tomato.10": {
    "value": "var(--colors-tomato-10)",
    "variable": "var(--colors-tomato-10)"
  },
  "colors.tomato.11": {
    "value": "var(--colors-tomato-11)",
    "variable": "var(--colors-tomato-11)"
  },
  "colors.tomato.12": {
    "value": "var(--colors-tomato-12)",
    "variable": "var(--colors-tomato-12)"
  },
  "colors.tomato.a1": {
    "value": "var(--colors-tomato-a1)",
    "variable": "var(--colors-tomato-a1)"
  },
  "colors.tomato.a2": {
    "value": "var(--colors-tomato-a2)",
    "variable": "var(--colors-tomato-a2)"
  },
  "colors.tomato.a3": {
    "value": "var(--colors-tomato-a3)",
    "variable": "var(--colors-tomato-a3)"
  },
  "colors.tomato.a4": {
    "value": "var(--colors-tomato-a4)",
    "variable": "var(--colors-tomato-a4)"
  },
  "colors.tomato.a5": {
    "value": "var(--colors-tomato-a5)",
    "variable": "var(--colors-tomato-a5)"
  },
  "colors.tomato.a6": {
    "value": "var(--colors-tomato-a6)",
    "variable": "var(--colors-tomato-a6)"
  },
  "colors.tomato.a7": {
    "value": "var(--colors-tomato-a7)",
    "variable": "var(--colors-tomato-a7)"
  },
  "colors.tomato.a8": {
    "value": "var(--colors-tomato-a8)",
    "variable": "var(--colors-tomato-a8)"
  },
  "colors.tomato.a9": {
    "value": "var(--colors-tomato-a9)",
    "variable": "var(--colors-tomato-a9)"
  },
  "colors.tomato.a10": {
    "value": "var(--colors-tomato-a10)",
    "variable": "var(--colors-tomato-a10)"
  },
  "colors.tomato.a11": {
    "value": "var(--colors-tomato-a11)",
    "variable": "var(--colors-tomato-a11)"
  },
  "colors.tomato.a12": {
    "value": "var(--colors-tomato-a12)",
    "variable": "var(--colors-tomato-a12)"
  },
  "colors.tomato.default": {
    "value": "var(--colors-tomato-default)",
    "variable": "var(--colors-tomato-default)"
  },
  "colors.tomato.emphasized": {
    "value": "var(--colors-tomato-emphasized)",
    "variable": "var(--colors-tomato-emphasized)"
  },
  "colors.tomato.fg": {
    "value": "var(--colors-tomato-fg)",
    "variable": "var(--colors-tomato-fg)"
  },
  "colors.tomato.text": {
    "value": "var(--colors-tomato-text)",
    "variable": "var(--colors-tomato-text)"
  },
  "colors.sky.1": {
    "value": "var(--colors-sky-1)",
    "variable": "var(--colors-sky-1)"
  },
  "colors.sky.2": {
    "value": "var(--colors-sky-2)",
    "variable": "var(--colors-sky-2)"
  },
  "colors.sky.3": {
    "value": "var(--colors-sky-3)",
    "variable": "var(--colors-sky-3)"
  },
  "colors.sky.4": {
    "value": "var(--colors-sky-4)",
    "variable": "var(--colors-sky-4)"
  },
  "colors.sky.5": {
    "value": "var(--colors-sky-5)",
    "variable": "var(--colors-sky-5)"
  },
  "colors.sky.6": {
    "value": "var(--colors-sky-6)",
    "variable": "var(--colors-sky-6)"
  },
  "colors.sky.7": {
    "value": "var(--colors-sky-7)",
    "variable": "var(--colors-sky-7)"
  },
  "colors.sky.8": {
    "value": "var(--colors-sky-8)",
    "variable": "var(--colors-sky-8)"
  },
  "colors.sky.9": {
    "value": "var(--colors-sky-9)",
    "variable": "var(--colors-sky-9)"
  },
  "colors.sky.10": {
    "value": "var(--colors-sky-10)",
    "variable": "var(--colors-sky-10)"
  },
  "colors.sky.11": {
    "value": "var(--colors-sky-11)",
    "variable": "var(--colors-sky-11)"
  },
  "colors.sky.12": {
    "value": "var(--colors-sky-12)",
    "variable": "var(--colors-sky-12)"
  },
  "colors.sky.a1": {
    "value": "var(--colors-sky-a1)",
    "variable": "var(--colors-sky-a1)"
  },
  "colors.sky.a2": {
    "value": "var(--colors-sky-a2)",
    "variable": "var(--colors-sky-a2)"
  },
  "colors.sky.a3": {
    "value": "var(--colors-sky-a3)",
    "variable": "var(--colors-sky-a3)"
  },
  "colors.sky.a4": {
    "value": "var(--colors-sky-a4)",
    "variable": "var(--colors-sky-a4)"
  },
  "colors.sky.a5": {
    "value": "var(--colors-sky-a5)",
    "variable": "var(--colors-sky-a5)"
  },
  "colors.sky.a6": {
    "value": "var(--colors-sky-a6)",
    "variable": "var(--colors-sky-a6)"
  },
  "colors.sky.a7": {
    "value": "var(--colors-sky-a7)",
    "variable": "var(--colors-sky-a7)"
  },
  "colors.sky.a8": {
    "value": "var(--colors-sky-a8)",
    "variable": "var(--colors-sky-a8)"
  },
  "colors.sky.a9": {
    "value": "var(--colors-sky-a9)",
    "variable": "var(--colors-sky-a9)"
  },
  "colors.sky.a10": {
    "value": "var(--colors-sky-a10)",
    "variable": "var(--colors-sky-a10)"
  },
  "colors.sky.a11": {
    "value": "var(--colors-sky-a11)",
    "variable": "var(--colors-sky-a11)"
  },
  "colors.sky.a12": {
    "value": "var(--colors-sky-a12)",
    "variable": "var(--colors-sky-a12)"
  },
  "colors.sky.default": {
    "value": "var(--colors-sky-default)",
    "variable": "var(--colors-sky-default)"
  },
  "colors.sky.emphasized": {
    "value": "var(--colors-sky-emphasized)",
    "variable": "var(--colors-sky-emphasized)"
  },
  "colors.sky.fg": {
    "value": "var(--colors-sky-fg)",
    "variable": "var(--colors-sky-fg)"
  },
  "colors.sky.text": {
    "value": "var(--colors-sky-text)",
    "variable": "var(--colors-sky-text)"
  },
  "colors.yellow.1": {
    "value": "var(--colors-yellow-1)",
    "variable": "var(--colors-yellow-1)"
  },
  "colors.yellow.2": {
    "value": "var(--colors-yellow-2)",
    "variable": "var(--colors-yellow-2)"
  },
  "colors.yellow.3": {
    "value": "var(--colors-yellow-3)",
    "variable": "var(--colors-yellow-3)"
  },
  "colors.yellow.4": {
    "value": "var(--colors-yellow-4)",
    "variable": "var(--colors-yellow-4)"
  },
  "colors.yellow.5": {
    "value": "var(--colors-yellow-5)",
    "variable": "var(--colors-yellow-5)"
  },
  "colors.yellow.6": {
    "value": "var(--colors-yellow-6)",
    "variable": "var(--colors-yellow-6)"
  },
  "colors.yellow.7": {
    "value": "var(--colors-yellow-7)",
    "variable": "var(--colors-yellow-7)"
  },
  "colors.yellow.8": {
    "value": "var(--colors-yellow-8)",
    "variable": "var(--colors-yellow-8)"
  },
  "colors.yellow.9": {
    "value": "var(--colors-yellow-9)",
    "variable": "var(--colors-yellow-9)"
  },
  "colors.yellow.10": {
    "value": "var(--colors-yellow-10)",
    "variable": "var(--colors-yellow-10)"
  },
  "colors.yellow.11": {
    "value": "var(--colors-yellow-11)",
    "variable": "var(--colors-yellow-11)"
  },
  "colors.yellow.12": {
    "value": "var(--colors-yellow-12)",
    "variable": "var(--colors-yellow-12)"
  },
  "colors.yellow.a1": {
    "value": "var(--colors-yellow-a1)",
    "variable": "var(--colors-yellow-a1)"
  },
  "colors.yellow.a2": {
    "value": "var(--colors-yellow-a2)",
    "variable": "var(--colors-yellow-a2)"
  },
  "colors.yellow.a3": {
    "value": "var(--colors-yellow-a3)",
    "variable": "var(--colors-yellow-a3)"
  },
  "colors.yellow.a4": {
    "value": "var(--colors-yellow-a4)",
    "variable": "var(--colors-yellow-a4)"
  },
  "colors.yellow.a5": {
    "value": "var(--colors-yellow-a5)",
    "variable": "var(--colors-yellow-a5)"
  },
  "colors.yellow.a6": {
    "value": "var(--colors-yellow-a6)",
    "variable": "var(--colors-yellow-a6)"
  },
  "colors.yellow.a7": {
    "value": "var(--colors-yellow-a7)",
    "variable": "var(--colors-yellow-a7)"
  },
  "colors.yellow.a8": {
    "value": "var(--colors-yellow-a8)",
    "variable": "var(--colors-yellow-a8)"
  },
  "colors.yellow.a9": {
    "value": "var(--colors-yellow-a9)",
    "variable": "var(--colors-yellow-a9)"
  },
  "colors.yellow.a10": {
    "value": "var(--colors-yellow-a10)",
    "variable": "var(--colors-yellow-a10)"
  },
  "colors.yellow.a11": {
    "value": "var(--colors-yellow-a11)",
    "variable": "var(--colors-yellow-a11)"
  },
  "colors.yellow.a12": {
    "value": "var(--colors-yellow-a12)",
    "variable": "var(--colors-yellow-a12)"
  },
  "colors.yellow.default": {
    "value": "var(--colors-yellow-default)",
    "variable": "var(--colors-yellow-default)"
  },
  "colors.yellow.emphasized": {
    "value": "var(--colors-yellow-emphasized)",
    "variable": "var(--colors-yellow-emphasized)"
  },
  "colors.yellow.fg": {
    "value": "var(--colors-yellow-fg)",
    "variable": "var(--colors-yellow-fg)"
  },
  "colors.yellow.text": {
    "value": "var(--colors-yellow-text)",
    "variable": "var(--colors-yellow-text)"
  },
  "colors.blue.1": {
    "value": "var(--colors-blue-1)",
    "variable": "var(--colors-blue-1)"
  },
  "colors.blue.2": {
    "value": "var(--colors-blue-2)",
    "variable": "var(--colors-blue-2)"
  },
  "colors.blue.3": {
    "value": "var(--colors-blue-3)",
    "variable": "var(--colors-blue-3)"
  },
  "colors.blue.4": {
    "value": "var(--colors-blue-4)",
    "variable": "var(--colors-blue-4)"
  },
  "colors.blue.5": {
    "value": "var(--colors-blue-5)",
    "variable": "var(--colors-blue-5)"
  },
  "colors.blue.6": {
    "value": "var(--colors-blue-6)",
    "variable": "var(--colors-blue-6)"
  },
  "colors.blue.7": {
    "value": "var(--colors-blue-7)",
    "variable": "var(--colors-blue-7)"
  },
  "colors.blue.8": {
    "value": "var(--colors-blue-8)",
    "variable": "var(--colors-blue-8)"
  },
  "colors.blue.9": {
    "value": "var(--colors-blue-9)",
    "variable": "var(--colors-blue-9)"
  },
  "colors.blue.10": {
    "value": "var(--colors-blue-10)",
    "variable": "var(--colors-blue-10)"
  },
  "colors.blue.11": {
    "value": "var(--colors-blue-11)",
    "variable": "var(--colors-blue-11)"
  },
  "colors.blue.12": {
    "value": "var(--colors-blue-12)",
    "variable": "var(--colors-blue-12)"
  },
  "colors.blue.a1": {
    "value": "var(--colors-blue-a1)",
    "variable": "var(--colors-blue-a1)"
  },
  "colors.blue.a2": {
    "value": "var(--colors-blue-a2)",
    "variable": "var(--colors-blue-a2)"
  },
  "colors.blue.a3": {
    "value": "var(--colors-blue-a3)",
    "variable": "var(--colors-blue-a3)"
  },
  "colors.blue.a4": {
    "value": "var(--colors-blue-a4)",
    "variable": "var(--colors-blue-a4)"
  },
  "colors.blue.a5": {
    "value": "var(--colors-blue-a5)",
    "variable": "var(--colors-blue-a5)"
  },
  "colors.blue.a6": {
    "value": "var(--colors-blue-a6)",
    "variable": "var(--colors-blue-a6)"
  },
  "colors.blue.a7": {
    "value": "var(--colors-blue-a7)",
    "variable": "var(--colors-blue-a7)"
  },
  "colors.blue.a8": {
    "value": "var(--colors-blue-a8)",
    "variable": "var(--colors-blue-a8)"
  },
  "colors.blue.a9": {
    "value": "var(--colors-blue-a9)",
    "variable": "var(--colors-blue-a9)"
  },
  "colors.blue.a10": {
    "value": "var(--colors-blue-a10)",
    "variable": "var(--colors-blue-a10)"
  },
  "colors.blue.a11": {
    "value": "var(--colors-blue-a11)",
    "variable": "var(--colors-blue-a11)"
  },
  "colors.blue.a12": {
    "value": "var(--colors-blue-a12)",
    "variable": "var(--colors-blue-a12)"
  },
  "colors.blue.default": {
    "value": "var(--colors-blue-default)",
    "variable": "var(--colors-blue-default)"
  },
  "colors.blue.emphasized": {
    "value": "var(--colors-blue-emphasized)",
    "variable": "var(--colors-blue-emphasized)"
  },
  "colors.blue.fg": {
    "value": "var(--colors-blue-fg)",
    "variable": "var(--colors-blue-fg)"
  },
  "colors.blue.text": {
    "value": "var(--colors-blue-text)",
    "variable": "var(--colors-blue-text)"
  },
  "colors.cyan.1": {
    "value": "var(--colors-cyan-1)",
    "variable": "var(--colors-cyan-1)"
  },
  "colors.cyan.2": {
    "value": "var(--colors-cyan-2)",
    "variable": "var(--colors-cyan-2)"
  },
  "colors.cyan.3": {
    "value": "var(--colors-cyan-3)",
    "variable": "var(--colors-cyan-3)"
  },
  "colors.cyan.4": {
    "value": "var(--colors-cyan-4)",
    "variable": "var(--colors-cyan-4)"
  },
  "colors.cyan.5": {
    "value": "var(--colors-cyan-5)",
    "variable": "var(--colors-cyan-5)"
  },
  "colors.cyan.6": {
    "value": "var(--colors-cyan-6)",
    "variable": "var(--colors-cyan-6)"
  },
  "colors.cyan.7": {
    "value": "var(--colors-cyan-7)",
    "variable": "var(--colors-cyan-7)"
  },
  "colors.cyan.8": {
    "value": "var(--colors-cyan-8)",
    "variable": "var(--colors-cyan-8)"
  },
  "colors.cyan.9": {
    "value": "var(--colors-cyan-9)",
    "variable": "var(--colors-cyan-9)"
  },
  "colors.cyan.10": {
    "value": "var(--colors-cyan-10)",
    "variable": "var(--colors-cyan-10)"
  },
  "colors.cyan.11": {
    "value": "var(--colors-cyan-11)",
    "variable": "var(--colors-cyan-11)"
  },
  "colors.cyan.12": {
    "value": "var(--colors-cyan-12)",
    "variable": "var(--colors-cyan-12)"
  },
  "colors.cyan.a1": {
    "value": "var(--colors-cyan-a1)",
    "variable": "var(--colors-cyan-a1)"
  },
  "colors.cyan.a2": {
    "value": "var(--colors-cyan-a2)",
    "variable": "var(--colors-cyan-a2)"
  },
  "colors.cyan.a3": {
    "value": "var(--colors-cyan-a3)",
    "variable": "var(--colors-cyan-a3)"
  },
  "colors.cyan.a4": {
    "value": "var(--colors-cyan-a4)",
    "variable": "var(--colors-cyan-a4)"
  },
  "colors.cyan.a5": {
    "value": "var(--colors-cyan-a5)",
    "variable": "var(--colors-cyan-a5)"
  },
  "colors.cyan.a6": {
    "value": "var(--colors-cyan-a6)",
    "variable": "var(--colors-cyan-a6)"
  },
  "colors.cyan.a7": {
    "value": "var(--colors-cyan-a7)",
    "variable": "var(--colors-cyan-a7)"
  },
  "colors.cyan.a8": {
    "value": "var(--colors-cyan-a8)",
    "variable": "var(--colors-cyan-a8)"
  },
  "colors.cyan.a9": {
    "value": "var(--colors-cyan-a9)",
    "variable": "var(--colors-cyan-a9)"
  },
  "colors.cyan.a10": {
    "value": "var(--colors-cyan-a10)",
    "variable": "var(--colors-cyan-a10)"
  },
  "colors.cyan.a11": {
    "value": "var(--colors-cyan-a11)",
    "variable": "var(--colors-cyan-a11)"
  },
  "colors.cyan.a12": {
    "value": "var(--colors-cyan-a12)",
    "variable": "var(--colors-cyan-a12)"
  },
  "colors.cyan.default": {
    "value": "var(--colors-cyan-default)",
    "variable": "var(--colors-cyan-default)"
  },
  "colors.cyan.emphasized": {
    "value": "var(--colors-cyan-emphasized)",
    "variable": "var(--colors-cyan-emphasized)"
  },
  "colors.cyan.fg": {
    "value": "var(--colors-cyan-fg)",
    "variable": "var(--colors-cyan-fg)"
  },
  "colors.cyan.text": {
    "value": "var(--colors-cyan-text)",
    "variable": "var(--colors-cyan-text)"
  },
  "colors.pink.1": {
    "value": "var(--colors-pink-1)",
    "variable": "var(--colors-pink-1)"
  },
  "colors.pink.2": {
    "value": "var(--colors-pink-2)",
    "variable": "var(--colors-pink-2)"
  },
  "colors.pink.3": {
    "value": "var(--colors-pink-3)",
    "variable": "var(--colors-pink-3)"
  },
  "colors.pink.4": {
    "value": "var(--colors-pink-4)",
    "variable": "var(--colors-pink-4)"
  },
  "colors.pink.5": {
    "value": "var(--colors-pink-5)",
    "variable": "var(--colors-pink-5)"
  },
  "colors.pink.6": {
    "value": "var(--colors-pink-6)",
    "variable": "var(--colors-pink-6)"
  },
  "colors.pink.7": {
    "value": "var(--colors-pink-7)",
    "variable": "var(--colors-pink-7)"
  },
  "colors.pink.8": {
    "value": "var(--colors-pink-8)",
    "variable": "var(--colors-pink-8)"
  },
  "colors.pink.9": {
    "value": "var(--colors-pink-9)",
    "variable": "var(--colors-pink-9)"
  },
  "colors.pink.10": {
    "value": "var(--colors-pink-10)",
    "variable": "var(--colors-pink-10)"
  },
  "colors.pink.11": {
    "value": "var(--colors-pink-11)",
    "variable": "var(--colors-pink-11)"
  },
  "colors.pink.12": {
    "value": "var(--colors-pink-12)",
    "variable": "var(--colors-pink-12)"
  },
  "colors.pink.a1": {
    "value": "var(--colors-pink-a1)",
    "variable": "var(--colors-pink-a1)"
  },
  "colors.pink.a2": {
    "value": "var(--colors-pink-a2)",
    "variable": "var(--colors-pink-a2)"
  },
  "colors.pink.a3": {
    "value": "var(--colors-pink-a3)",
    "variable": "var(--colors-pink-a3)"
  },
  "colors.pink.a4": {
    "value": "var(--colors-pink-a4)",
    "variable": "var(--colors-pink-a4)"
  },
  "colors.pink.a5": {
    "value": "var(--colors-pink-a5)",
    "variable": "var(--colors-pink-a5)"
  },
  "colors.pink.a6": {
    "value": "var(--colors-pink-a6)",
    "variable": "var(--colors-pink-a6)"
  },
  "colors.pink.a7": {
    "value": "var(--colors-pink-a7)",
    "variable": "var(--colors-pink-a7)"
  },
  "colors.pink.a8": {
    "value": "var(--colors-pink-a8)",
    "variable": "var(--colors-pink-a8)"
  },
  "colors.pink.a9": {
    "value": "var(--colors-pink-a9)",
    "variable": "var(--colors-pink-a9)"
  },
  "colors.pink.a10": {
    "value": "var(--colors-pink-a10)",
    "variable": "var(--colors-pink-a10)"
  },
  "colors.pink.a11": {
    "value": "var(--colors-pink-a11)",
    "variable": "var(--colors-pink-a11)"
  },
  "colors.pink.a12": {
    "value": "var(--colors-pink-a12)",
    "variable": "var(--colors-pink-a12)"
  },
  "colors.pink.default": {
    "value": "var(--colors-pink-default)",
    "variable": "var(--colors-pink-default)"
  },
  "colors.pink.emphasized": {
    "value": "var(--colors-pink-emphasized)",
    "variable": "var(--colors-pink-emphasized)"
  },
  "colors.pink.fg": {
    "value": "var(--colors-pink-fg)",
    "variable": "var(--colors-pink-fg)"
  },
  "colors.pink.text": {
    "value": "var(--colors-pink-text)",
    "variable": "var(--colors-pink-text)"
  },
  "colors.bg.canvas": {
    "value": "var(--colors-bg-canvas)",
    "variable": "var(--colors-bg-canvas)"
  },
  "colors.bg.default": {
    "value": "var(--colors-bg-default)",
    "variable": "var(--colors-bg-default)"
  },
  "colors.bg.light": {
    "value": "var(--colors-bg-light)",
    "variable": "var(--colors-bg-light)"
  },
  "colors.bg.subtle": {
    "value": "var(--colors-bg-subtle)",
    "variable": "var(--colors-bg-subtle)"
  },
  "colors.bg.muted": {
    "value": "var(--colors-bg-muted)",
    "variable": "var(--colors-bg-muted)"
  },
  "colors.bg.emphasized": {
    "value": "var(--colors-bg-emphasized)",
    "variable": "var(--colors-bg-emphasized)"
  },
  "colors.bg.hover": {
    "value": "var(--colors-bg-hover)",
    "variable": "var(--colors-bg-hover)"
  },
  "colors.bg.hoverWhite": {
    "value": "var(--colors-bg-hover-white)",
    "variable": "var(--colors-bg-hover-white)"
  },
  "colors.bg.disabled": {
    "value": "var(--colors-bg-disabled)",
    "variable": "var(--colors-bg-disabled)"
  },
  "colors.bg.success": {
    "value": "var(--colors-bg-success)",
    "variable": "var(--colors-bg-success)"
  },
  "colors.bg.warning": {
    "value": "var(--colors-bg-warning)",
    "variable": "var(--colors-bg-warning)"
  },
  "colors.bg.error": {
    "value": "var(--colors-bg-error)",
    "variable": "var(--colors-bg-error)"
  },
  "colors.bg.danger": {
    "value": "var(--colors-bg-danger)",
    "variable": "var(--colors-bg-danger)"
  },
  "colors.bg.info": {
    "value": "var(--colors-bg-info)",
    "variable": "var(--colors-bg-info)"
  },
  "colors.bg.subtleSoft": {
    "value": "var(--colors-bg-subtle-soft)",
    "variable": "var(--colors-bg-subtle-soft)"
  },
  "colors.bg.neutral.default": {
    "value": "var(--colors-bg-neutral-default)",
    "variable": "var(--colors-bg-neutral-default)"
  },
  "colors.bg.neutral.light": {
    "value": "var(--colors-bg-neutral-light)",
    "variable": "var(--colors-bg-neutral-light)"
  },
  "colors.bg.neutral.subtle": {
    "value": "var(--colors-bg-neutral-subtle)",
    "variable": "var(--colors-bg-neutral-subtle)"
  },
  "colors.bg.neutral.muted": {
    "value": "var(--colors-bg-neutral-muted)",
    "variable": "var(--colors-bg-neutral-muted)"
  },
  "colors.bg.neutral.emphasized": {
    "value": "var(--colors-bg-neutral-emphasized)",
    "variable": "var(--colors-bg-neutral-emphasized)"
  },
  "colors.bg.neutral.hover": {
    "value": "var(--colors-bg-neutral-hover)",
    "variable": "var(--colors-bg-neutral-hover)"
  },
  "colors.bg.neutral.hoverWhite": {
    "value": "var(--colors-bg-neutral-hover-white)",
    "variable": "var(--colors-bg-neutral-hover-white)"
  },
  "colors.bg.neutral.disabled": {
    "value": "var(--colors-bg-neutral-disabled)",
    "variable": "var(--colors-bg-neutral-disabled)"
  },
  "colors.bg.neutral.success": {
    "value": "var(--colors-bg-neutral-success)",
    "variable": "var(--colors-bg-neutral-success)"
  },
  "colors.bg.neutral.warning": {
    "value": "var(--colors-bg-neutral-warning)",
    "variable": "var(--colors-bg-neutral-warning)"
  },
  "colors.bg.neutral.error": {
    "value": "var(--colors-bg-neutral-error)",
    "variable": "var(--colors-bg-neutral-error)"
  },
  "colors.bg.neutral.danger": {
    "value": "var(--colors-bg-neutral-danger)",
    "variable": "var(--colors-bg-neutral-danger)"
  },
  "colors.bg.neutral.info": {
    "value": "var(--colors-bg-neutral-info)",
    "variable": "var(--colors-bg-neutral-info)"
  },
  "colors.bg.neutral.subtleSoft": {
    "value": "var(--colors-bg-neutral-subtle-soft)",
    "variable": "var(--colors-bg-neutral-subtle-soft)"
  },
  "colors.bg.accent.light": {
    "value": "var(--colors-bg-accent-light)",
    "variable": "var(--colors-bg-accent-light)"
  },
  "colors.bg.accent.subtle": {
    "value": "var(--colors-bg-accent-subtle)",
    "variable": "var(--colors-bg-accent-subtle)"
  },
  "colors.bg.accent.muted": {
    "value": "var(--colors-bg-accent-muted)",
    "variable": "var(--colors-bg-accent-muted)"
  },
  "colors.bg.accent.default": {
    "value": "var(--colors-bg-accent-default)",
    "variable": "var(--colors-bg-accent-default)"
  },
  "colors.bg.accent.emphasized": {
    "value": "var(--colors-bg-accent-emphasized)",
    "variable": "var(--colors-bg-accent-emphasized)"
  },
  "colors.bg.accent.hover": {
    "value": "var(--colors-bg-accent-hover)",
    "variable": "var(--colors-bg-accent-hover)"
  },
  "colors.bg.accent.disabled": {
    "value": "var(--colors-bg-accent-disabled)",
    "variable": "var(--colors-bg-accent-disabled)"
  },
  "colors.bg.onaccent.default": {
    "value": "var(--colors-bg-onaccent-default)",
    "variable": "var(--colors-bg-onaccent-default)"
  },
  "colors.bg.onaccent.hover": {
    "value": "var(--colors-bg-onaccent-hover)",
    "variable": "var(--colors-bg-onaccent-hover)"
  },
  "colors.bg.onaccent.hoverAlpha": {
    "value": "var(--colors-bg-onaccent-hover-alpha)",
    "variable": "var(--colors-bg-onaccent-hover-alpha)"
  },
  "colors.bg.onaccent.disabled": {
    "value": "var(--colors-bg-onaccent-disabled)",
    "variable": "var(--colors-bg-onaccent-disabled)"
  },
  "colors.bg.severity.critical": {
    "value": "var(--colors-bg-severity-critical)",
    "variable": "var(--colors-bg-severity-critical)"
  },
  "colors.bg.severity.high": {
    "value": "var(--colors-bg-severity-high)",
    "variable": "var(--colors-bg-severity-high)"
  },
  "colors.bg.severity.medium": {
    "value": "var(--colors-bg-severity-medium)",
    "variable": "var(--colors-bg-severity-medium)"
  },
  "colors.bg.severity.low": {
    "value": "var(--colors-bg-severity-low)",
    "variable": "var(--colors-bg-severity-low)"
  },
  "colors.bg.vulnerability.vulnerable": {
    "value": "var(--colors-bg-vulnerability-vulnerable)",
    "variable": "var(--colors-bg-vulnerability-vulnerable)"
  },
  "colors.bg.vulnerability.passed": {
    "value": "var(--colors-bg-vulnerability-passed)",
    "variable": "var(--colors-bg-vulnerability-passed)"
  },
  "colors.bg.vulnerability.cold": {
    "value": "var(--colors-bg-vulnerability-cold)",
    "variable": "var(--colors-bg-vulnerability-cold)"
  },
  "colors.bg.vulnerability.hot": {
    "value": "var(--colors-bg-vulnerability-hot)",
    "variable": "var(--colors-bg-vulnerability-hot)"
  },
  "colors.bg.status.duplicate": {
    "value": "var(--colors-bg-status-duplicate)",
    "variable": "var(--colors-bg-status-duplicate)"
  },
  "colors.bg.status.resolved": {
    "value": "var(--colors-bg-status-resolved)",
    "variable": "var(--colors-bg-status-resolved)"
  },
  "colors.bg.status.unresolved": {
    "value": "var(--colors-bg-status-unresolved)",
    "variable": "var(--colors-bg-status-unresolved)"
  },
  "colors.bg.status.new": {
    "value": "var(--colors-bg-status-new)",
    "variable": "var(--colors-bg-status-new)"
  },
  "colors.bg.status.inProgress": {
    "value": "var(--colors-bg-status-in-progress)",
    "variable": "var(--colors-bg-status-in-progress)"
  },
  "colors.bg.node.orange": {
    "value": "var(--colors-bg-node-orange)",
    "variable": "var(--colors-bg-node-orange)"
  },
  "colors.bg.node.pink": {
    "value": "var(--colors-bg-node-pink)",
    "variable": "var(--colors-bg-node-pink)"
  },
  "colors.bg.node.purple": {
    "value": "var(--colors-bg-node-purple)",
    "variable": "var(--colors-bg-node-purple)"
  },
  "colors.bg.graphs.orange": {
    "value": "var(--colors-bg-graphs-orange)",
    "variable": "var(--colors-bg-graphs-orange)"
  },
  "colors.bg.graphs.sky": {
    "value": "var(--colors-bg-graphs-sky)",
    "variable": "var(--colors-bg-graphs-sky)"
  },
  "colors.bg.graphs.pink": {
    "value": "var(--colors-bg-graphs-pink)",
    "variable": "var(--colors-bg-graphs-pink)"
  },
  "colors.bg.graphs.purple": {
    "value": "var(--colors-bg-graphs-purple)",
    "variable": "var(--colors-bg-graphs-purple)"
  },
  "colors.bg.graphs.green": {
    "value": "var(--colors-bg-graphs-green)",
    "variable": "var(--colors-bg-graphs-green)"
  },
  "colors.bg.graphs.yellow": {
    "value": "var(--colors-bg-graphs-yellow)",
    "variable": "var(--colors-bg-graphs-yellow)"
  },
  "colors.bg.graphs.red": {
    "value": "var(--colors-bg-graphs-red)",
    "variable": "var(--colors-bg-graphs-red)"
  },
  "colors.bg.graphs.gray": {
    "value": "var(--colors-bg-graphs-gray)",
    "variable": "var(--colors-bg-graphs-gray)"
  },
  "colors.bg.graphs.mint": {
    "value": "var(--colors-bg-graphs-mint)",
    "variable": "var(--colors-bg-graphs-mint)"
  },
  "colors.bg.graphs.ochre": {
    "value": "var(--colors-bg-graphs-ochre)",
    "variable": "var(--colors-bg-graphs-ochre)"
  },
  "colors.bg.graphs.forest": {
    "value": "var(--colors-bg-graphs-forest)",
    "variable": "var(--colors-bg-graphs-forest)"
  },
  "colors.bg.graphs.pale": {
    "value": "var(--colors-bg-graphs-pale)",
    "variable": "var(--colors-bg-graphs-pale)"
  },
  "colors.bg.graphs.sage": {
    "value": "var(--colors-bg-graphs-sage)",
    "variable": "var(--colors-bg-graphs-sage)"
  },
  "colors.bg.graphs.foam": {
    "value": "var(--colors-bg-graphs-foam)",
    "variable": "var(--colors-bg-graphs-foam)"
  },
  "colors.bg.graphs.scarlet": {
    "value": "var(--colors-bg-graphs-scarlet)",
    "variable": "var(--colors-bg-graphs-scarlet)"
  },
  "colors.bg.graphs.slate": {
    "value": "var(--colors-bg-graphs-slate)",
    "variable": "var(--colors-bg-graphs-slate)"
  },
  "colors.bg.graphs.sand": {
    "value": "var(--colors-bg-graphs-sand)",
    "variable": "var(--colors-bg-graphs-sand)"
  },
  "colors.bg.graphs.ink": {
    "value": "var(--colors-bg-graphs-ink)",
    "variable": "var(--colors-bg-graphs-ink)"
  },
  "colors.bg.graphs.blue": {
    "value": "var(--colors-bg-graphs-blue)",
    "variable": "var(--colors-bg-graphs-blue)"
  },
  "colors.bg.graphs.low": {
    "value": "var(--colors-bg-graphs-low)",
    "variable": "var(--colors-bg-graphs-low)"
  },
  "colors.bg.graphs.medium": {
    "value": "var(--colors-bg-graphs-medium)",
    "variable": "var(--colors-bg-graphs-medium)"
  },
  "colors.bg.graphs.high": {
    "value": "var(--colors-bg-graphs-high)",
    "variable": "var(--colors-bg-graphs-high)"
  },
  "colors.bg.graphs.critical": {
    "value": "var(--colors-bg-graphs-critical)",
    "variable": "var(--colors-bg-graphs-critical)"
  },
  "colors.bg.entity.assets": {
    "value": "var(--colors-bg-entity-assets)",
    "variable": "var(--colors-bg-entity-assets)"
  },
  "colors.bg.entity.pr": {
    "value": "var(--colors-bg-entity-pr)",
    "variable": "var(--colors-bg-entity-pr)"
  },
  "colors.bg.entity.entryPoint": {
    "value": "var(--colors-bg-entity-entry-point)",
    "variable": "var(--colors-bg-entity-entry-point)"
  },
  "colors.bg.entity.signal": {
    "value": "var(--colors-bg-entity-signal)",
    "variable": "var(--colors-bg-entity-signal)"
  },
  "colors.bg.entity.finding": {
    "value": "var(--colors-bg-entity-finding)",
    "variable": "var(--colors-bg-entity-finding)"
  },
  "colors.bg.entity.operation": {
    "value": "var(--colors-bg-entity-operation)",
    "variable": "var(--colors-bg-entity-operation)"
  },
  "colors.bg.moss.subtle": {
    "value": "var(--colors-bg-moss-subtle)",
    "variable": "var(--colors-bg-moss-subtle)"
  },
  "colors.bg.moss.muted": {
    "value": "var(--colors-bg-moss-muted)",
    "variable": "var(--colors-bg-moss-muted)"
  },
  "colors.bg.moss.default": {
    "value": "var(--colors-bg-moss-default)",
    "variable": "var(--colors-bg-moss-default)"
  },
  "colors.bg.decorative.gray": {
    "value": "var(--colors-bg-decorative-gray)",
    "variable": "var(--colors-bg-decorative-gray)"
  },
  "colors.bg.decorative.blue": {
    "value": "var(--colors-bg-decorative-blue)",
    "variable": "var(--colors-bg-decorative-blue)"
  },
  "colors.bg.decorative.purple": {
    "value": "var(--colors-bg-decorative-purple)",
    "variable": "var(--colors-bg-decorative-purple)"
  },
  "colors.bg.decorative.yellow": {
    "value": "var(--colors-bg-decorative-yellow)",
    "variable": "var(--colors-bg-decorative-yellow)"
  },
  "colors.bg.decorative.red": {
    "value": "var(--colors-bg-decorative-red)",
    "variable": "var(--colors-bg-decorative-red)"
  },
  "colors.bg.decorative.green": {
    "value": "var(--colors-bg-decorative-green)",
    "variable": "var(--colors-bg-decorative-green)"
  },
  "colors.bg.decorative.pink": {
    "value": "var(--colors-bg-decorative-pink)",
    "variable": "var(--colors-bg-decorative-pink)"
  },
  "colors.bg.decorative.orange": {
    "value": "var(--colors-bg-decorative-orange)",
    "variable": "var(--colors-bg-decorative-orange)"
  },
  "colors.bg.decorative.cyan": {
    "value": "var(--colors-bg-decorative-cyan)",
    "variable": "var(--colors-bg-decorative-cyan)"
  },
  "colors.bg.decorative.darkGreen": {
    "value": "var(--colors-bg-decorative-dark-green)",
    "variable": "var(--colors-bg-decorative-dark-green)"
  },
  "colors.bg.tooltip": {
    "value": "var(--colors-bg-tooltip)",
    "variable": "var(--colors-bg-tooltip)"
  },
  "colors.bg.tooltipChip": {
    "value": "var(--colors-bg-tooltip-chip)",
    "variable": "var(--colors-bg-tooltip-chip)"
  },
  "colors.fg.default": {
    "value": "var(--colors-fg-default)",
    "variable": "var(--colors-fg-default)"
  },
  "colors.fg.subtle": {
    "value": "var(--colors-fg-subtle)",
    "variable": "var(--colors-fg-subtle)"
  },
  "colors.fg.muted": {
    "value": "var(--colors-fg-muted)",
    "variable": "var(--colors-fg-muted)"
  },
  "colors.fg.disabled": {
    "value": "var(--colors-fg-disabled)",
    "variable": "var(--colors-fg-disabled)"
  },
  "colors.fg.success": {
    "value": "var(--colors-fg-success)",
    "variable": "var(--colors-fg-success)"
  },
  "colors.fg.warning": {
    "value": "var(--colors-fg-warning)",
    "variable": "var(--colors-fg-warning)"
  },
  "colors.fg.error": {
    "value": "var(--colors-fg-error)",
    "variable": "var(--colors-fg-error)"
  },
  "colors.fg.emphasized": {
    "value": "var(--colors-fg-emphasized)",
    "variable": "var(--colors-fg-emphasized)"
  },
  "colors.fg.emphasizedMuted": {
    "value": "var(--colors-fg-emphasized-muted)",
    "variable": "var(--colors-fg-emphasized-muted)"
  },
  "colors.fg.info": {
    "value": "var(--colors-fg-info)",
    "variable": "var(--colors-fg-info)"
  },
  "colors.fg.neutral.subtle": {
    "value": "var(--colors-fg-neutral-subtle)",
    "variable": "var(--colors-fg-neutral-subtle)"
  },
  "colors.fg.neutral.muted": {
    "value": "var(--colors-fg-neutral-muted)",
    "variable": "var(--colors-fg-neutral-muted)"
  },
  "colors.fg.neutral.default": {
    "value": "var(--colors-fg-neutral-default)",
    "variable": "var(--colors-fg-neutral-default)"
  },
  "colors.fg.neutral.disabled": {
    "value": "var(--colors-fg-neutral-disabled)",
    "variable": "var(--colors-fg-neutral-disabled)"
  },
  "colors.fg.neutral.success": {
    "value": "var(--colors-fg-neutral-success)",
    "variable": "var(--colors-fg-neutral-success)"
  },
  "colors.fg.neutral.warning": {
    "value": "var(--colors-fg-neutral-warning)",
    "variable": "var(--colors-fg-neutral-warning)"
  },
  "colors.fg.neutral.error": {
    "value": "var(--colors-fg-neutral-error)",
    "variable": "var(--colors-fg-neutral-error)"
  },
  "colors.fg.neutral.emphasized": {
    "value": "var(--colors-fg-neutral-emphasized)",
    "variable": "var(--colors-fg-neutral-emphasized)"
  },
  "colors.fg.neutral.emphasizedMuted": {
    "value": "var(--colors-fg-neutral-emphasized-muted)",
    "variable": "var(--colors-fg-neutral-emphasized-muted)"
  },
  "colors.fg.neutral.info": {
    "value": "var(--colors-fg-neutral-info)",
    "variable": "var(--colors-fg-neutral-info)"
  },
  "colors.fg.accent.subtle": {
    "value": "var(--colors-fg-accent-subtle)",
    "variable": "var(--colors-fg-accent-subtle)"
  },
  "colors.fg.accent.muted": {
    "value": "var(--colors-fg-accent-muted)",
    "variable": "var(--colors-fg-accent-muted)"
  },
  "colors.fg.accent.default": {
    "value": "var(--colors-fg-accent-default)",
    "variable": "var(--colors-fg-accent-default)"
  },
  "colors.fg.accent.emphasized": {
    "value": "var(--colors-fg-accent-emphasized)",
    "variable": "var(--colors-fg-accent-emphasized)"
  },
  "colors.fg.accent.disabled": {
    "value": "var(--colors-fg-accent-disabled)",
    "variable": "var(--colors-fg-accent-disabled)"
  },
  "colors.fg.onaccent.subtle": {
    "value": "var(--colors-fg-onaccent-subtle)",
    "variable": "var(--colors-fg-onaccent-subtle)"
  },
  "colors.fg.onaccent.muted": {
    "value": "var(--colors-fg-onaccent-muted)",
    "variable": "var(--colors-fg-onaccent-muted)"
  },
  "colors.fg.onaccent.default": {
    "value": "var(--colors-fg-onaccent-default)",
    "variable": "var(--colors-fg-onaccent-default)"
  },
  "colors.fg.onaccent.emphasized": {
    "value": "var(--colors-fg-onaccent-emphasized)",
    "variable": "var(--colors-fg-onaccent-emphasized)"
  },
  "colors.fg.onaccent.disabled": {
    "value": "var(--colors-fg-onaccent-disabled)",
    "variable": "var(--colors-fg-onaccent-disabled)"
  },
  "colors.fg.severity.critical": {
    "value": "var(--colors-fg-severity-critical)",
    "variable": "var(--colors-fg-severity-critical)"
  },
  "colors.fg.severity.low": {
    "value": "var(--colors-fg-severity-low)",
    "variable": "var(--colors-fg-severity-low)"
  },
  "colors.fg.severity.high": {
    "value": "var(--colors-fg-severity-high)",
    "variable": "var(--colors-fg-severity-high)"
  },
  "colors.fg.severity.medium": {
    "value": "var(--colors-fg-severity-medium)",
    "variable": "var(--colors-fg-severity-medium)"
  },
  "colors.fg.status.duplicate": {
    "value": "var(--colors-fg-status-duplicate)",
    "variable": "var(--colors-fg-status-duplicate)"
  },
  "colors.fg.status.unresolved": {
    "value": "var(--colors-fg-status-unresolved)",
    "variable": "var(--colors-fg-status-unresolved)"
  },
  "colors.fg.status.resolved": {
    "value": "var(--colors-fg-status-resolved)",
    "variable": "var(--colors-fg-status-resolved)"
  },
  "colors.fg.status.inProgress": {
    "value": "var(--colors-fg-status-in-progress)",
    "variable": "var(--colors-fg-status-in-progress)"
  },
  "colors.fg.status.new": {
    "value": "var(--colors-fg-status-new)",
    "variable": "var(--colors-fg-status-new)"
  },
  "colors.fg.vulnerability.vulnerable": {
    "value": "var(--colors-fg-vulnerability-vulnerable)",
    "variable": "var(--colors-fg-vulnerability-vulnerable)"
  },
  "colors.fg.vulnerability.passed": {
    "value": "var(--colors-fg-vulnerability-passed)",
    "variable": "var(--colors-fg-vulnerability-passed)"
  },
  "colors.fg.vulnerability.hot": {
    "value": "var(--colors-fg-vulnerability-hot)",
    "variable": "var(--colors-fg-vulnerability-hot)"
  },
  "colors.fg.vulnerability.cold": {
    "value": "var(--colors-fg-vulnerability-cold)",
    "variable": "var(--colors-fg-vulnerability-cold)"
  },
  "colors.fg.entity.assets": {
    "value": "var(--colors-fg-entity-assets)",
    "variable": "var(--colors-fg-entity-assets)"
  },
  "colors.fg.entity.pr": {
    "value": "var(--colors-fg-entity-pr)",
    "variable": "var(--colors-fg-entity-pr)"
  },
  "colors.fg.entity.entryPoint": {
    "value": "var(--colors-fg-entity-entry-point)",
    "variable": "var(--colors-fg-entity-entry-point)"
  },
  "colors.fg.entity.signal": {
    "value": "var(--colors-fg-entity-signal)",
    "variable": "var(--colors-fg-entity-signal)"
  },
  "colors.fg.entity.finding": {
    "value": "var(--colors-fg-entity-finding)",
    "variable": "var(--colors-fg-entity-finding)"
  },
  "colors.fg.entity.operation": {
    "value": "var(--colors-fg-entity-operation)",
    "variable": "var(--colors-fg-entity-operation)"
  },
  "colors.fg.moss.default": {
    "value": "var(--colors-fg-moss-default)",
    "variable": "var(--colors-fg-moss-default)"
  },
  "colors.fg.decorative.gray": {
    "value": "var(--colors-fg-decorative-gray)",
    "variable": "var(--colors-fg-decorative-gray)"
  },
  "colors.fg.decorative.blue": {
    "value": "var(--colors-fg-decorative-blue)",
    "variable": "var(--colors-fg-decorative-blue)"
  },
  "colors.fg.decorative.purple": {
    "value": "var(--colors-fg-decorative-purple)",
    "variable": "var(--colors-fg-decorative-purple)"
  },
  "colors.fg.decorative.yellow": {
    "value": "var(--colors-fg-decorative-yellow)",
    "variable": "var(--colors-fg-decorative-yellow)"
  },
  "colors.fg.decorative.red": {
    "value": "var(--colors-fg-decorative-red)",
    "variable": "var(--colors-fg-decorative-red)"
  },
  "colors.fg.decorative.green": {
    "value": "var(--colors-fg-decorative-green)",
    "variable": "var(--colors-fg-decorative-green)"
  },
  "colors.fg.decorative.pink": {
    "value": "var(--colors-fg-decorative-pink)",
    "variable": "var(--colors-fg-decorative-pink)"
  },
  "colors.fg.decorative.orange": {
    "value": "var(--colors-fg-decorative-orange)",
    "variable": "var(--colors-fg-decorative-orange)"
  },
  "colors.fg.decorative.cyan": {
    "value": "var(--colors-fg-decorative-cyan)",
    "variable": "var(--colors-fg-decorative-cyan)"
  },
  "colors.fg.decorative.darkGreen": {
    "value": "var(--colors-fg-decorative-dark-green)",
    "variable": "var(--colors-fg-decorative-dark-green)"
  },
  "colors.fg.tooltip.default": {
    "value": "var(--colors-fg-tooltip-default)",
    "variable": "var(--colors-fg-tooltip-default)"
  },
  "colors.fg.tooltip.muted": {
    "value": "var(--colors-fg-tooltip-muted)",
    "variable": "var(--colors-fg-tooltip-muted)"
  },
  "colors.fg.tooltip.subtle": {
    "value": "var(--colors-fg-tooltip-subtle)",
    "variable": "var(--colors-fg-tooltip-subtle)"
  },
  "colors.border.outline": {
    "value": "var(--colors-border-outline)",
    "variable": "var(--colors-border-outline)"
  },
  "colors.border.default": {
    "value": "var(--colors-border-default)",
    "variable": "var(--colors-border-default)"
  },
  "colors.border.subtle": {
    "value": "var(--colors-border-subtle)",
    "variable": "var(--colors-border-subtle)"
  },
  "colors.border.muted": {
    "value": "var(--colors-border-muted)",
    "variable": "var(--colors-border-muted)"
  },
  "colors.border.disabled": {
    "value": "var(--colors-border-disabled)",
    "variable": "var(--colors-border-disabled)"
  },
  "colors.border.success": {
    "value": "var(--colors-border-success)",
    "variable": "var(--colors-border-success)"
  },
  "colors.border.warning": {
    "value": "var(--colors-border-warning)",
    "variable": "var(--colors-border-warning)"
  },
  "colors.border.error": {
    "value": "var(--colors-border-error)",
    "variable": "var(--colors-border-error)"
  },
  "colors.border.emphasized": {
    "value": "var(--colors-border-emphasized)",
    "variable": "var(--colors-border-emphasized)"
  },
  "colors.border.focus": {
    "value": "var(--colors-border-focus)",
    "variable": "var(--colors-border-focus)"
  },
  "colors.border.info": {
    "value": "var(--colors-border-info)",
    "variable": "var(--colors-border-info)"
  },
  "colors.border.neutral.subtle": {
    "value": "var(--colors-border-neutral-subtle)",
    "variable": "var(--colors-border-neutral-subtle)"
  },
  "colors.border.neutral.muted": {
    "value": "var(--colors-border-neutral-muted)",
    "variable": "var(--colors-border-neutral-muted)"
  },
  "colors.border.neutral.default": {
    "value": "var(--colors-border-neutral-default)",
    "variable": "var(--colors-border-neutral-default)"
  },
  "colors.border.neutral.focus": {
    "value": "var(--colors-border-neutral-focus)",
    "variable": "var(--colors-border-neutral-focus)"
  },
  "colors.border.neutral.disabled": {
    "value": "var(--colors-border-neutral-disabled)",
    "variable": "var(--colors-border-neutral-disabled)"
  },
  "colors.border.neutral.success": {
    "value": "var(--colors-border-neutral-success)",
    "variable": "var(--colors-border-neutral-success)"
  },
  "colors.border.neutral.warning": {
    "value": "var(--colors-border-neutral-warning)",
    "variable": "var(--colors-border-neutral-warning)"
  },
  "colors.border.neutral.error": {
    "value": "var(--colors-border-neutral-error)",
    "variable": "var(--colors-border-neutral-error)"
  },
  "colors.border.neutral.emphasized": {
    "value": "var(--colors-border-neutral-emphasized)",
    "variable": "var(--colors-border-neutral-emphasized)"
  },
  "colors.border.neutral.info": {
    "value": "var(--colors-border-neutral-info)",
    "variable": "var(--colors-border-neutral-info)"
  },
  "colors.border.accent.subtle": {
    "value": "var(--colors-border-accent-subtle)",
    "variable": "var(--colors-border-accent-subtle)"
  },
  "colors.border.accent.muted": {
    "value": "var(--colors-border-accent-muted)",
    "variable": "var(--colors-border-accent-muted)"
  },
  "colors.border.accent.default": {
    "value": "var(--colors-border-accent-default)",
    "variable": "var(--colors-border-accent-default)"
  },
  "colors.border.accent.focus": {
    "value": "var(--colors-border-accent-focus)",
    "variable": "var(--colors-border-accent-focus)"
  },
  "colors.border.accent.ring": {
    "value": "var(--colors-border-accent-ring)",
    "variable": "var(--colors-border-accent-ring)"
  },
  "colors.border.accent.hover": {
    "value": "var(--colors-border-accent-hover)",
    "variable": "var(--colors-border-accent-hover)"
  },
  "colors.border.accent.disabled": {
    "value": "var(--colors-border-accent-disabled)",
    "variable": "var(--colors-border-accent-disabled)"
  },
  "colors.border.onaccent.muted": {
    "value": "var(--colors-border-onaccent-muted)",
    "variable": "var(--colors-border-onaccent-muted)"
  },
  "colors.border.onaccent.default": {
    "value": "var(--colors-border-onaccent-default)",
    "variable": "var(--colors-border-onaccent-default)"
  },
  "colors.border.onaccent.hover": {
    "value": "var(--colors-border-onaccent-hover)",
    "variable": "var(--colors-border-onaccent-hover)"
  },
  "colors.border.onaccent.disabled": {
    "value": "var(--colors-border-onaccent-disabled)",
    "variable": "var(--colors-border-onaccent-disabled)"
  },
  "colors.border.severity.critical": {
    "value": "var(--colors-border-severity-critical)",
    "variable": "var(--colors-border-severity-critical)"
  },
  "colors.border.severity.high": {
    "value": "var(--colors-border-severity-high)",
    "variable": "var(--colors-border-severity-high)"
  },
  "colors.border.severity.medium": {
    "value": "var(--colors-border-severity-medium)",
    "variable": "var(--colors-border-severity-medium)"
  },
  "colors.border.severity.low": {
    "value": "var(--colors-border-severity-low)",
    "variable": "var(--colors-border-severity-low)"
  },
  "colors.border.status.duplicate": {
    "value": "var(--colors-border-status-duplicate)",
    "variable": "var(--colors-border-status-duplicate)"
  },
  "colors.border.status.resolved": {
    "value": "var(--colors-border-status-resolved)",
    "variable": "var(--colors-border-status-resolved)"
  },
  "colors.border.status.unresolved": {
    "value": "var(--colors-border-status-unresolved)",
    "variable": "var(--colors-border-status-unresolved)"
  },
  "colors.border.status.new": {
    "value": "var(--colors-border-status-new)",
    "variable": "var(--colors-border-status-new)"
  },
  "colors.border.status.inProgress": {
    "value": "var(--colors-border-status-in-progress)",
    "variable": "var(--colors-border-status-in-progress)"
  },
  "colors.border.vulnerability.critical": {
    "value": "var(--colors-border-vulnerability-critical)",
    "variable": "var(--colors-border-vulnerability-critical)"
  },
  "colors.border.vulnerability.safe": {
    "value": "var(--colors-border-vulnerability-safe)",
    "variable": "var(--colors-border-vulnerability-safe)"
  },
  "colors.border.vulnerability.hot": {
    "value": "var(--colors-border-vulnerability-hot)",
    "variable": "var(--colors-border-vulnerability-hot)"
  },
  "colors.border.vulnerability.cold": {
    "value": "var(--colors-border-vulnerability-cold)",
    "variable": "var(--colors-border-vulnerability-cold)"
  },
  "colors.border.entity.assets": {
    "value": "var(--colors-border-entity-assets)",
    "variable": "var(--colors-border-entity-assets)"
  },
  "colors.border.entity.pr": {
    "value": "var(--colors-border-entity-pr)",
    "variable": "var(--colors-border-entity-pr)"
  },
  "colors.border.entity.entryPoint": {
    "value": "var(--colors-border-entity-entry-point)",
    "variable": "var(--colors-border-entity-entry-point)"
  },
  "colors.border.entity.signal": {
    "value": "var(--colors-border-entity-signal)",
    "variable": "var(--colors-border-entity-signal)"
  },
  "colors.border.entity.finding": {
    "value": "var(--colors-border-entity-finding)",
    "variable": "var(--colors-border-entity-finding)"
  },
  "colors.border.entity.operation": {
    "value": "var(--colors-border-entity-operation)",
    "variable": "var(--colors-border-entity-operation)"
  },
  "colors.border.moss.default": {
    "value": "var(--colors-border-moss-default)",
    "variable": "var(--colors-border-moss-default)"
  },
  "colors.border.moss.subtle": {
    "value": "var(--colors-border-moss-subtle)",
    "variable": "var(--colors-border-moss-subtle)"
  },
  "colors.border.decorative.gray": {
    "value": "var(--colors-border-decorative-gray)",
    "variable": "var(--colors-border-decorative-gray)"
  },
  "colors.border.decorative.blue": {
    "value": "var(--colors-border-decorative-blue)",
    "variable": "var(--colors-border-decorative-blue)"
  },
  "colors.border.decorative.purple": {
    "value": "var(--colors-border-decorative-purple)",
    "variable": "var(--colors-border-decorative-purple)"
  },
  "colors.border.decorative.yellow": {
    "value": "var(--colors-border-decorative-yellow)",
    "variable": "var(--colors-border-decorative-yellow)"
  },
  "colors.border.decorative.red": {
    "value": "var(--colors-border-decorative-red)",
    "variable": "var(--colors-border-decorative-red)"
  },
  "colors.border.decorative.green": {
    "value": "var(--colors-border-decorative-green)",
    "variable": "var(--colors-border-decorative-green)"
  },
  "colors.border.decorative.pink": {
    "value": "var(--colors-border-decorative-pink)",
    "variable": "var(--colors-border-decorative-pink)"
  },
  "colors.border.decorative.orange": {
    "value": "var(--colors-border-decorative-orange)",
    "variable": "var(--colors-border-decorative-orange)"
  },
  "colors.border.decorative.cyan": {
    "value": "var(--colors-border-decorative-cyan)",
    "variable": "var(--colors-border-decorative-cyan)"
  },
  "colors.border.decorative.darkGreen": {
    "value": "var(--colors-border-decorative-dark-green)",
    "variable": "var(--colors-border-decorative-dark-green)"
  },
  "colors.border.tooltip": {
    "value": "var(--colors-border-tooltip)",
    "variable": "var(--colors-border-tooltip)"
  },
  "colors.border.tooltipDivider": {
    "value": "var(--colors-border-tooltip-divider)",
    "variable": "var(--colors-border-tooltip-divider)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.light.1": {
    "value": "var(--colors-color-palette-light-1)",
    "variable": "var(--colors-color-palette-light-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--colors-color-palette-1)",
    "variable": "var(--colors-color-palette-1)"
  },
  "colors.colorPalette.light.2": {
    "value": "var(--colors-color-palette-light-2)",
    "variable": "var(--colors-color-palette-light-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--colors-color-palette-2)",
    "variable": "var(--colors-color-palette-2)"
  },
  "colors.colorPalette.light.3": {
    "value": "var(--colors-color-palette-light-3)",
    "variable": "var(--colors-color-palette-light-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--colors-color-palette-3)",
    "variable": "var(--colors-color-palette-3)"
  },
  "colors.colorPalette.light.4": {
    "value": "var(--colors-color-palette-light-4)",
    "variable": "var(--colors-color-palette-light-4)"
  },
  "colors.colorPalette.4": {
    "value": "var(--colors-color-palette-4)",
    "variable": "var(--colors-color-palette-4)"
  },
  "colors.colorPalette.light.5": {
    "value": "var(--colors-color-palette-light-5)",
    "variable": "var(--colors-color-palette-light-5)"
  },
  "colors.colorPalette.5": {
    "value": "var(--colors-color-palette-5)",
    "variable": "var(--colors-color-palette-5)"
  },
  "colors.colorPalette.light.6": {
    "value": "var(--colors-color-palette-light-6)",
    "variable": "var(--colors-color-palette-light-6)"
  },
  "colors.colorPalette.6": {
    "value": "var(--colors-color-palette-6)",
    "variable": "var(--colors-color-palette-6)"
  },
  "colors.colorPalette.light.7": {
    "value": "var(--colors-color-palette-light-7)",
    "variable": "var(--colors-color-palette-light-7)"
  },
  "colors.colorPalette.7": {
    "value": "var(--colors-color-palette-7)",
    "variable": "var(--colors-color-palette-7)"
  },
  "colors.colorPalette.light.8": {
    "value": "var(--colors-color-palette-light-8)",
    "variable": "var(--colors-color-palette-light-8)"
  },
  "colors.colorPalette.8": {
    "value": "var(--colors-color-palette-8)",
    "variable": "var(--colors-color-palette-8)"
  },
  "colors.colorPalette.light.9": {
    "value": "var(--colors-color-palette-light-9)",
    "variable": "var(--colors-color-palette-light-9)"
  },
  "colors.colorPalette.9": {
    "value": "var(--colors-color-palette-9)",
    "variable": "var(--colors-color-palette-9)"
  },
  "colors.colorPalette.light.10": {
    "value": "var(--colors-color-palette-light-10)",
    "variable": "var(--colors-color-palette-light-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--colors-color-palette-10)",
    "variable": "var(--colors-color-palette-10)"
  },
  "colors.colorPalette.light.11": {
    "value": "var(--colors-color-palette-light-11)",
    "variable": "var(--colors-color-palette-light-11)"
  },
  "colors.colorPalette.11": {
    "value": "var(--colors-color-palette-11)",
    "variable": "var(--colors-color-palette-11)"
  },
  "colors.colorPalette.light.12": {
    "value": "var(--colors-color-palette-light-12)",
    "variable": "var(--colors-color-palette-light-12)"
  },
  "colors.colorPalette.12": {
    "value": "var(--colors-color-palette-12)",
    "variable": "var(--colors-color-palette-12)"
  },
  "colors.colorPalette.light.a1": {
    "value": "var(--colors-color-palette-light-a1)",
    "variable": "var(--colors-color-palette-light-a1)"
  },
  "colors.colorPalette.a1": {
    "value": "var(--colors-color-palette-a1)",
    "variable": "var(--colors-color-palette-a1)"
  },
  "colors.colorPalette.light.a2": {
    "value": "var(--colors-color-palette-light-a2)",
    "variable": "var(--colors-color-palette-light-a2)"
  },
  "colors.colorPalette.a2": {
    "value": "var(--colors-color-palette-a2)",
    "variable": "var(--colors-color-palette-a2)"
  },
  "colors.colorPalette.light.a3": {
    "value": "var(--colors-color-palette-light-a3)",
    "variable": "var(--colors-color-palette-light-a3)"
  },
  "colors.colorPalette.a3": {
    "value": "var(--colors-color-palette-a3)",
    "variable": "var(--colors-color-palette-a3)"
  },
  "colors.colorPalette.light.a4": {
    "value": "var(--colors-color-palette-light-a4)",
    "variable": "var(--colors-color-palette-light-a4)"
  },
  "colors.colorPalette.a4": {
    "value": "var(--colors-color-palette-a4)",
    "variable": "var(--colors-color-palette-a4)"
  },
  "colors.colorPalette.light.a5": {
    "value": "var(--colors-color-palette-light-a5)",
    "variable": "var(--colors-color-palette-light-a5)"
  },
  "colors.colorPalette.a5": {
    "value": "var(--colors-color-palette-a5)",
    "variable": "var(--colors-color-palette-a5)"
  },
  "colors.colorPalette.light.a6": {
    "value": "var(--colors-color-palette-light-a6)",
    "variable": "var(--colors-color-palette-light-a6)"
  },
  "colors.colorPalette.a6": {
    "value": "var(--colors-color-palette-a6)",
    "variable": "var(--colors-color-palette-a6)"
  },
  "colors.colorPalette.light.a7": {
    "value": "var(--colors-color-palette-light-a7)",
    "variable": "var(--colors-color-palette-light-a7)"
  },
  "colors.colorPalette.a7": {
    "value": "var(--colors-color-palette-a7)",
    "variable": "var(--colors-color-palette-a7)"
  },
  "colors.colorPalette.light.a8": {
    "value": "var(--colors-color-palette-light-a8)",
    "variable": "var(--colors-color-palette-light-a8)"
  },
  "colors.colorPalette.a8": {
    "value": "var(--colors-color-palette-a8)",
    "variable": "var(--colors-color-palette-a8)"
  },
  "colors.colorPalette.light.a9": {
    "value": "var(--colors-color-palette-light-a9)",
    "variable": "var(--colors-color-palette-light-a9)"
  },
  "colors.colorPalette.a9": {
    "value": "var(--colors-color-palette-a9)",
    "variable": "var(--colors-color-palette-a9)"
  },
  "colors.colorPalette.light.a10": {
    "value": "var(--colors-color-palette-light-a10)",
    "variable": "var(--colors-color-palette-light-a10)"
  },
  "colors.colorPalette.a10": {
    "value": "var(--colors-color-palette-a10)",
    "variable": "var(--colors-color-palette-a10)"
  },
  "colors.colorPalette.light.a11": {
    "value": "var(--colors-color-palette-light-a11)",
    "variable": "var(--colors-color-palette-light-a11)"
  },
  "colors.colorPalette.a11": {
    "value": "var(--colors-color-palette-a11)",
    "variable": "var(--colors-color-palette-a11)"
  },
  "colors.colorPalette.light.a12": {
    "value": "var(--colors-color-palette-light-a12)",
    "variable": "var(--colors-color-palette-light-a12)"
  },
  "colors.colorPalette.a12": {
    "value": "var(--colors-color-palette-a12)",
    "variable": "var(--colors-color-palette-a12)"
  },
  "colors.colorPalette.dark.1": {
    "value": "var(--colors-color-palette-dark-1)",
    "variable": "var(--colors-color-palette-dark-1)"
  },
  "colors.colorPalette.dark.2": {
    "value": "var(--colors-color-palette-dark-2)",
    "variable": "var(--colors-color-palette-dark-2)"
  },
  "colors.colorPalette.dark.3": {
    "value": "var(--colors-color-palette-dark-3)",
    "variable": "var(--colors-color-palette-dark-3)"
  },
  "colors.colorPalette.dark.4": {
    "value": "var(--colors-color-palette-dark-4)",
    "variable": "var(--colors-color-palette-dark-4)"
  },
  "colors.colorPalette.dark.5": {
    "value": "var(--colors-color-palette-dark-5)",
    "variable": "var(--colors-color-palette-dark-5)"
  },
  "colors.colorPalette.dark.6": {
    "value": "var(--colors-color-palette-dark-6)",
    "variable": "var(--colors-color-palette-dark-6)"
  },
  "colors.colorPalette.dark.7": {
    "value": "var(--colors-color-palette-dark-7)",
    "variable": "var(--colors-color-palette-dark-7)"
  },
  "colors.colorPalette.dark.8": {
    "value": "var(--colors-color-palette-dark-8)",
    "variable": "var(--colors-color-palette-dark-8)"
  },
  "colors.colorPalette.dark.9": {
    "value": "var(--colors-color-palette-dark-9)",
    "variable": "var(--colors-color-palette-dark-9)"
  },
  "colors.colorPalette.dark.10": {
    "value": "var(--colors-color-palette-dark-10)",
    "variable": "var(--colors-color-palette-dark-10)"
  },
  "colors.colorPalette.dark.11": {
    "value": "var(--colors-color-palette-dark-11)",
    "variable": "var(--colors-color-palette-dark-11)"
  },
  "colors.colorPalette.dark.12": {
    "value": "var(--colors-color-palette-dark-12)",
    "variable": "var(--colors-color-palette-dark-12)"
  },
  "colors.colorPalette.dark.a1": {
    "value": "var(--colors-color-palette-dark-a1)",
    "variable": "var(--colors-color-palette-dark-a1)"
  },
  "colors.colorPalette.dark.a2": {
    "value": "var(--colors-color-palette-dark-a2)",
    "variable": "var(--colors-color-palette-dark-a2)"
  },
  "colors.colorPalette.dark.a3": {
    "value": "var(--colors-color-palette-dark-a3)",
    "variable": "var(--colors-color-palette-dark-a3)"
  },
  "colors.colorPalette.dark.a4": {
    "value": "var(--colors-color-palette-dark-a4)",
    "variable": "var(--colors-color-palette-dark-a4)"
  },
  "colors.colorPalette.dark.a5": {
    "value": "var(--colors-color-palette-dark-a5)",
    "variable": "var(--colors-color-palette-dark-a5)"
  },
  "colors.colorPalette.dark.a6": {
    "value": "var(--colors-color-palette-dark-a6)",
    "variable": "var(--colors-color-palette-dark-a6)"
  },
  "colors.colorPalette.dark.a7": {
    "value": "var(--colors-color-palette-dark-a7)",
    "variable": "var(--colors-color-palette-dark-a7)"
  },
  "colors.colorPalette.dark.a8": {
    "value": "var(--colors-color-palette-dark-a8)",
    "variable": "var(--colors-color-palette-dark-a8)"
  },
  "colors.colorPalette.dark.a9": {
    "value": "var(--colors-color-palette-dark-a9)",
    "variable": "var(--colors-color-palette-dark-a9)"
  },
  "colors.colorPalette.dark.a10": {
    "value": "var(--colors-color-palette-dark-a10)",
    "variable": "var(--colors-color-palette-dark-a10)"
  },
  "colors.colorPalette.dark.a11": {
    "value": "var(--colors-color-palette-dark-a11)",
    "variable": "var(--colors-color-palette-dark-a11)"
  },
  "colors.colorPalette.dark.a12": {
    "value": "var(--colors-color-palette-dark-a12)",
    "variable": "var(--colors-color-palette-dark-a12)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.emphasized": {
    "value": "var(--colors-color-palette-emphasized)",
    "variable": "var(--colors-color-palette-emphasized)"
  },
  "colors.colorPalette.fg": {
    "value": "var(--colors-color-palette-fg)",
    "variable": "var(--colors-color-palette-fg)"
  },
  "colors.colorPalette.text": {
    "value": "var(--colors-color-palette-text)",
    "variable": "var(--colors-color-palette-text)"
  },
  "colors.colorPalette.surface": {
    "value": "var(--colors-color-palette-surface)",
    "variable": "var(--colors-color-palette-surface)"
  },
  "colors.colorPalette.indicator": {
    "value": "var(--colors-color-palette-indicator)",
    "variable": "var(--colors-color-palette-indicator)"
  },
  "colors.colorPalette.track": {
    "value": "var(--colors-color-palette-track)",
    "variable": "var(--colors-color-palette-track)"
  },
  "colors.colorPalette.alpha": {
    "value": "var(--colors-color-palette-alpha)",
    "variable": "var(--colors-color-palette-alpha)"
  },
  "colors.colorPalette.alphaEmphasized": {
    "value": "var(--colors-color-palette-alpha-emphasized)",
    "variable": "var(--colors-color-palette-alpha-emphasized)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--colors-color-palette-canvas)",
    "variable": "var(--colors-color-palette-canvas)"
  },
  "colors.colorPalette.light": {
    "value": "var(--colors-color-palette-light)",
    "variable": "var(--colors-color-palette-light)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.muted": {
    "value": "var(--colors-color-palette-muted)",
    "variable": "var(--colors-color-palette-muted)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.hoverWhite": {
    "value": "var(--colors-color-palette-hover-white)",
    "variable": "var(--colors-color-palette-hover-white)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--colors-color-palette-warning)",
    "variable": "var(--colors-color-palette-warning)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.danger": {
    "value": "var(--colors-color-palette-danger)",
    "variable": "var(--colors-color-palette-danger)"
  },
  "colors.colorPalette.info": {
    "value": "var(--colors-color-palette-info)",
    "variable": "var(--colors-color-palette-info)"
  },
  "colors.colorPalette.subtleSoft": {
    "value": "var(--colors-color-palette-subtle-soft)",
    "variable": "var(--colors-color-palette-subtle-soft)"
  },
  "colors.colorPalette.neutral.default": {
    "value": "var(--colors-color-palette-neutral-default)",
    "variable": "var(--colors-color-palette-neutral-default)"
  },
  "colors.colorPalette.neutral.light": {
    "value": "var(--colors-color-palette-neutral-light)",
    "variable": "var(--colors-color-palette-neutral-light)"
  },
  "colors.colorPalette.neutral.subtle": {
    "value": "var(--colors-color-palette-neutral-subtle)",
    "variable": "var(--colors-color-palette-neutral-subtle)"
  },
  "colors.colorPalette.neutral.muted": {
    "value": "var(--colors-color-palette-neutral-muted)",
    "variable": "var(--colors-color-palette-neutral-muted)"
  },
  "colors.colorPalette.neutral.emphasized": {
    "value": "var(--colors-color-palette-neutral-emphasized)",
    "variable": "var(--colors-color-palette-neutral-emphasized)"
  },
  "colors.colorPalette.neutral.hover": {
    "value": "var(--colors-color-palette-neutral-hover)",
    "variable": "var(--colors-color-palette-neutral-hover)"
  },
  "colors.colorPalette.neutral.hoverWhite": {
    "value": "var(--colors-color-palette-neutral-hover-white)",
    "variable": "var(--colors-color-palette-neutral-hover-white)"
  },
  "colors.colorPalette.neutral.disabled": {
    "value": "var(--colors-color-palette-neutral-disabled)",
    "variable": "var(--colors-color-palette-neutral-disabled)"
  },
  "colors.colorPalette.neutral.success": {
    "value": "var(--colors-color-palette-neutral-success)",
    "variable": "var(--colors-color-palette-neutral-success)"
  },
  "colors.colorPalette.neutral.warning": {
    "value": "var(--colors-color-palette-neutral-warning)",
    "variable": "var(--colors-color-palette-neutral-warning)"
  },
  "colors.colorPalette.neutral.error": {
    "value": "var(--colors-color-palette-neutral-error)",
    "variable": "var(--colors-color-palette-neutral-error)"
  },
  "colors.colorPalette.neutral.danger": {
    "value": "var(--colors-color-palette-neutral-danger)",
    "variable": "var(--colors-color-palette-neutral-danger)"
  },
  "colors.colorPalette.neutral.info": {
    "value": "var(--colors-color-palette-neutral-info)",
    "variable": "var(--colors-color-palette-neutral-info)"
  },
  "colors.colorPalette.neutral.subtleSoft": {
    "value": "var(--colors-color-palette-neutral-subtle-soft)",
    "variable": "var(--colors-color-palette-neutral-subtle-soft)"
  },
  "colors.colorPalette.accent.light": {
    "value": "var(--colors-color-palette-accent-light)",
    "variable": "var(--colors-color-palette-accent-light)"
  },
  "colors.colorPalette.accent.subtle": {
    "value": "var(--colors-color-palette-accent-subtle)",
    "variable": "var(--colors-color-palette-accent-subtle)"
  },
  "colors.colorPalette.accent.muted": {
    "value": "var(--colors-color-palette-accent-muted)",
    "variable": "var(--colors-color-palette-accent-muted)"
  },
  "colors.colorPalette.accent.default": {
    "value": "var(--colors-color-palette-accent-default)",
    "variable": "var(--colors-color-palette-accent-default)"
  },
  "colors.colorPalette.accent.emphasized": {
    "value": "var(--colors-color-palette-accent-emphasized)",
    "variable": "var(--colors-color-palette-accent-emphasized)"
  },
  "colors.colorPalette.accent.hover": {
    "value": "var(--colors-color-palette-accent-hover)",
    "variable": "var(--colors-color-palette-accent-hover)"
  },
  "colors.colorPalette.accent.hoverAlpha": {
    "value": "var(--colors-color-palette-accent-hover-alpha)",
    "variable": "var(--colors-color-palette-accent-hover-alpha)"
  },
  "colors.colorPalette.hoverAlpha": {
    "value": "var(--colors-color-palette-hover-alpha)",
    "variable": "var(--colors-color-palette-hover-alpha)"
  },
  "colors.colorPalette.accent.disabled": {
    "value": "var(--colors-color-palette-accent-disabled)",
    "variable": "var(--colors-color-palette-accent-disabled)"
  },
  "colors.colorPalette.onaccent.default": {
    "value": "var(--colors-color-palette-onaccent-default)",
    "variable": "var(--colors-color-palette-onaccent-default)"
  },
  "colors.colorPalette.onaccent.hover": {
    "value": "var(--colors-color-palette-onaccent-hover)",
    "variable": "var(--colors-color-palette-onaccent-hover)"
  },
  "colors.colorPalette.onaccent.hoverAlpha": {
    "value": "var(--colors-color-palette-onaccent-hover-alpha)",
    "variable": "var(--colors-color-palette-onaccent-hover-alpha)"
  },
  "colors.colorPalette.onaccent.disabled": {
    "value": "var(--colors-color-palette-onaccent-disabled)",
    "variable": "var(--colors-color-palette-onaccent-disabled)"
  },
  "colors.colorPalette.severity.critical": {
    "value": "var(--colors-color-palette-severity-critical)",
    "variable": "var(--colors-color-palette-severity-critical)"
  },
  "colors.colorPalette.critical": {
    "value": "var(--colors-color-palette-critical)",
    "variable": "var(--colors-color-palette-critical)"
  },
  "colors.colorPalette.severity.high": {
    "value": "var(--colors-color-palette-severity-high)",
    "variable": "var(--colors-color-palette-severity-high)"
  },
  "colors.colorPalette.high": {
    "value": "var(--colors-color-palette-high)",
    "variable": "var(--colors-color-palette-high)"
  },
  "colors.colorPalette.severity.medium": {
    "value": "var(--colors-color-palette-severity-medium)",
    "variable": "var(--colors-color-palette-severity-medium)"
  },
  "colors.colorPalette.medium": {
    "value": "var(--colors-color-palette-medium)",
    "variable": "var(--colors-color-palette-medium)"
  },
  "colors.colorPalette.severity.low": {
    "value": "var(--colors-color-palette-severity-low)",
    "variable": "var(--colors-color-palette-severity-low)"
  },
  "colors.colorPalette.low": {
    "value": "var(--colors-color-palette-low)",
    "variable": "var(--colors-color-palette-low)"
  },
  "colors.colorPalette.vulnerability.vulnerable": {
    "value": "var(--colors-color-palette-vulnerability-vulnerable)",
    "variable": "var(--colors-color-palette-vulnerability-vulnerable)"
  },
  "colors.colorPalette.vulnerable": {
    "value": "var(--colors-color-palette-vulnerable)",
    "variable": "var(--colors-color-palette-vulnerable)"
  },
  "colors.colorPalette.vulnerability.passed": {
    "value": "var(--colors-color-palette-vulnerability-passed)",
    "variable": "var(--colors-color-palette-vulnerability-passed)"
  },
  "colors.colorPalette.passed": {
    "value": "var(--colors-color-palette-passed)",
    "variable": "var(--colors-color-palette-passed)"
  },
  "colors.colorPalette.vulnerability.cold": {
    "value": "var(--colors-color-palette-vulnerability-cold)",
    "variable": "var(--colors-color-palette-vulnerability-cold)"
  },
  "colors.colorPalette.cold": {
    "value": "var(--colors-color-palette-cold)",
    "variable": "var(--colors-color-palette-cold)"
  },
  "colors.colorPalette.vulnerability.hot": {
    "value": "var(--colors-color-palette-vulnerability-hot)",
    "variable": "var(--colors-color-palette-vulnerability-hot)"
  },
  "colors.colorPalette.hot": {
    "value": "var(--colors-color-palette-hot)",
    "variable": "var(--colors-color-palette-hot)"
  },
  "colors.colorPalette.status.duplicate": {
    "value": "var(--colors-color-palette-status-duplicate)",
    "variable": "var(--colors-color-palette-status-duplicate)"
  },
  "colors.colorPalette.duplicate": {
    "value": "var(--colors-color-palette-duplicate)",
    "variable": "var(--colors-color-palette-duplicate)"
  },
  "colors.colorPalette.status.resolved": {
    "value": "var(--colors-color-palette-status-resolved)",
    "variable": "var(--colors-color-palette-status-resolved)"
  },
  "colors.colorPalette.resolved": {
    "value": "var(--colors-color-palette-resolved)",
    "variable": "var(--colors-color-palette-resolved)"
  },
  "colors.colorPalette.status.unresolved": {
    "value": "var(--colors-color-palette-status-unresolved)",
    "variable": "var(--colors-color-palette-status-unresolved)"
  },
  "colors.colorPalette.unresolved": {
    "value": "var(--colors-color-palette-unresolved)",
    "variable": "var(--colors-color-palette-unresolved)"
  },
  "colors.colorPalette.status.new": {
    "value": "var(--colors-color-palette-status-new)",
    "variable": "var(--colors-color-palette-status-new)"
  },
  "colors.colorPalette.new": {
    "value": "var(--colors-color-palette-new)",
    "variable": "var(--colors-color-palette-new)"
  },
  "colors.colorPalette.status.inProgress": {
    "value": "var(--colors-color-palette-status-in-progress)",
    "variable": "var(--colors-color-palette-status-in-progress)"
  },
  "colors.colorPalette.inProgress": {
    "value": "var(--colors-color-palette-in-progress)",
    "variable": "var(--colors-color-palette-in-progress)"
  },
  "colors.colorPalette.node.orange": {
    "value": "var(--colors-color-palette-node-orange)",
    "variable": "var(--colors-color-palette-node-orange)"
  },
  "colors.colorPalette.orange": {
    "value": "var(--colors-color-palette-orange)",
    "variable": "var(--colors-color-palette-orange)"
  },
  "colors.colorPalette.node.pink": {
    "value": "var(--colors-color-palette-node-pink)",
    "variable": "var(--colors-color-palette-node-pink)"
  },
  "colors.colorPalette.pink": {
    "value": "var(--colors-color-palette-pink)",
    "variable": "var(--colors-color-palette-pink)"
  },
  "colors.colorPalette.node.purple": {
    "value": "var(--colors-color-palette-node-purple)",
    "variable": "var(--colors-color-palette-node-purple)"
  },
  "colors.colorPalette.purple": {
    "value": "var(--colors-color-palette-purple)",
    "variable": "var(--colors-color-palette-purple)"
  },
  "colors.colorPalette.graphs.orange": {
    "value": "var(--colors-color-palette-graphs-orange)",
    "variable": "var(--colors-color-palette-graphs-orange)"
  },
  "colors.colorPalette.graphs.sky": {
    "value": "var(--colors-color-palette-graphs-sky)",
    "variable": "var(--colors-color-palette-graphs-sky)"
  },
  "colors.colorPalette.sky": {
    "value": "var(--colors-color-palette-sky)",
    "variable": "var(--colors-color-palette-sky)"
  },
  "colors.colorPalette.graphs.pink": {
    "value": "var(--colors-color-palette-graphs-pink)",
    "variable": "var(--colors-color-palette-graphs-pink)"
  },
  "colors.colorPalette.graphs.purple": {
    "value": "var(--colors-color-palette-graphs-purple)",
    "variable": "var(--colors-color-palette-graphs-purple)"
  },
  "colors.colorPalette.graphs.green": {
    "value": "var(--colors-color-palette-graphs-green)",
    "variable": "var(--colors-color-palette-graphs-green)"
  },
  "colors.colorPalette.green": {
    "value": "var(--colors-color-palette-green)",
    "variable": "var(--colors-color-palette-green)"
  },
  "colors.colorPalette.graphs.yellow": {
    "value": "var(--colors-color-palette-graphs-yellow)",
    "variable": "var(--colors-color-palette-graphs-yellow)"
  },
  "colors.colorPalette.yellow": {
    "value": "var(--colors-color-palette-yellow)",
    "variable": "var(--colors-color-palette-yellow)"
  },
  "colors.colorPalette.graphs.red": {
    "value": "var(--colors-color-palette-graphs-red)",
    "variable": "var(--colors-color-palette-graphs-red)"
  },
  "colors.colorPalette.red": {
    "value": "var(--colors-color-palette-red)",
    "variable": "var(--colors-color-palette-red)"
  },
  "colors.colorPalette.graphs.gray": {
    "value": "var(--colors-color-palette-graphs-gray)",
    "variable": "var(--colors-color-palette-graphs-gray)"
  },
  "colors.colorPalette.gray": {
    "value": "var(--colors-color-palette-gray)",
    "variable": "var(--colors-color-palette-gray)"
  },
  "colors.colorPalette.graphs.mint": {
    "value": "var(--colors-color-palette-graphs-mint)",
    "variable": "var(--colors-color-palette-graphs-mint)"
  },
  "colors.colorPalette.mint": {
    "value": "var(--colors-color-palette-mint)",
    "variable": "var(--colors-color-palette-mint)"
  },
  "colors.colorPalette.graphs.ochre": {
    "value": "var(--colors-color-palette-graphs-ochre)",
    "variable": "var(--colors-color-palette-graphs-ochre)"
  },
  "colors.colorPalette.ochre": {
    "value": "var(--colors-color-palette-ochre)",
    "variable": "var(--colors-color-palette-ochre)"
  },
  "colors.colorPalette.graphs.forest": {
    "value": "var(--colors-color-palette-graphs-forest)",
    "variable": "var(--colors-color-palette-graphs-forest)"
  },
  "colors.colorPalette.forest": {
    "value": "var(--colors-color-palette-forest)",
    "variable": "var(--colors-color-palette-forest)"
  },
  "colors.colorPalette.graphs.pale": {
    "value": "var(--colors-color-palette-graphs-pale)",
    "variable": "var(--colors-color-palette-graphs-pale)"
  },
  "colors.colorPalette.pale": {
    "value": "var(--colors-color-palette-pale)",
    "variable": "var(--colors-color-palette-pale)"
  },
  "colors.colorPalette.graphs.sage": {
    "value": "var(--colors-color-palette-graphs-sage)",
    "variable": "var(--colors-color-palette-graphs-sage)"
  },
  "colors.colorPalette.sage": {
    "value": "var(--colors-color-palette-sage)",
    "variable": "var(--colors-color-palette-sage)"
  },
  "colors.colorPalette.graphs.foam": {
    "value": "var(--colors-color-palette-graphs-foam)",
    "variable": "var(--colors-color-palette-graphs-foam)"
  },
  "colors.colorPalette.foam": {
    "value": "var(--colors-color-palette-foam)",
    "variable": "var(--colors-color-palette-foam)"
  },
  "colors.colorPalette.graphs.scarlet": {
    "value": "var(--colors-color-palette-graphs-scarlet)",
    "variable": "var(--colors-color-palette-graphs-scarlet)"
  },
  "colors.colorPalette.scarlet": {
    "value": "var(--colors-color-palette-scarlet)",
    "variable": "var(--colors-color-palette-scarlet)"
  },
  "colors.colorPalette.graphs.slate": {
    "value": "var(--colors-color-palette-graphs-slate)",
    "variable": "var(--colors-color-palette-graphs-slate)"
  },
  "colors.colorPalette.slate": {
    "value": "var(--colors-color-palette-slate)",
    "variable": "var(--colors-color-palette-slate)"
  },
  "colors.colorPalette.graphs.sand": {
    "value": "var(--colors-color-palette-graphs-sand)",
    "variable": "var(--colors-color-palette-graphs-sand)"
  },
  "colors.colorPalette.sand": {
    "value": "var(--colors-color-palette-sand)",
    "variable": "var(--colors-color-palette-sand)"
  },
  "colors.colorPalette.graphs.ink": {
    "value": "var(--colors-color-palette-graphs-ink)",
    "variable": "var(--colors-color-palette-graphs-ink)"
  },
  "colors.colorPalette.ink": {
    "value": "var(--colors-color-palette-ink)",
    "variable": "var(--colors-color-palette-ink)"
  },
  "colors.colorPalette.graphs.blue": {
    "value": "var(--colors-color-palette-graphs-blue)",
    "variable": "var(--colors-color-palette-graphs-blue)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--colors-color-palette-blue)",
    "variable": "var(--colors-color-palette-blue)"
  },
  "colors.colorPalette.graphs.low": {
    "value": "var(--colors-color-palette-graphs-low)",
    "variable": "var(--colors-color-palette-graphs-low)"
  },
  "colors.colorPalette.graphs.medium": {
    "value": "var(--colors-color-palette-graphs-medium)",
    "variable": "var(--colors-color-palette-graphs-medium)"
  },
  "colors.colorPalette.graphs.high": {
    "value": "var(--colors-color-palette-graphs-high)",
    "variable": "var(--colors-color-palette-graphs-high)"
  },
  "colors.colorPalette.graphs.critical": {
    "value": "var(--colors-color-palette-graphs-critical)",
    "variable": "var(--colors-color-palette-graphs-critical)"
  },
  "colors.colorPalette.entity.assets": {
    "value": "var(--colors-color-palette-entity-assets)",
    "variable": "var(--colors-color-palette-entity-assets)"
  },
  "colors.colorPalette.assets": {
    "value": "var(--colors-color-palette-assets)",
    "variable": "var(--colors-color-palette-assets)"
  },
  "colors.colorPalette.entity.pr": {
    "value": "var(--colors-color-palette-entity-pr)",
    "variable": "var(--colors-color-palette-entity-pr)"
  },
  "colors.colorPalette.pr": {
    "value": "var(--colors-color-palette-pr)",
    "variable": "var(--colors-color-palette-pr)"
  },
  "colors.colorPalette.entity.entryPoint": {
    "value": "var(--colors-color-palette-entity-entry-point)",
    "variable": "var(--colors-color-palette-entity-entry-point)"
  },
  "colors.colorPalette.entryPoint": {
    "value": "var(--colors-color-palette-entry-point)",
    "variable": "var(--colors-color-palette-entry-point)"
  },
  "colors.colorPalette.entity.signal": {
    "value": "var(--colors-color-palette-entity-signal)",
    "variable": "var(--colors-color-palette-entity-signal)"
  },
  "colors.colorPalette.signal": {
    "value": "var(--colors-color-palette-signal)",
    "variable": "var(--colors-color-palette-signal)"
  },
  "colors.colorPalette.entity.finding": {
    "value": "var(--colors-color-palette-entity-finding)",
    "variable": "var(--colors-color-palette-entity-finding)"
  },
  "colors.colorPalette.finding": {
    "value": "var(--colors-color-palette-finding)",
    "variable": "var(--colors-color-palette-finding)"
  },
  "colors.colorPalette.entity.operation": {
    "value": "var(--colors-color-palette-entity-operation)",
    "variable": "var(--colors-color-palette-entity-operation)"
  },
  "colors.colorPalette.operation": {
    "value": "var(--colors-color-palette-operation)",
    "variable": "var(--colors-color-palette-operation)"
  },
  "colors.colorPalette.moss.subtle": {
    "value": "var(--colors-color-palette-moss-subtle)",
    "variable": "var(--colors-color-palette-moss-subtle)"
  },
  "colors.colorPalette.moss.muted": {
    "value": "var(--colors-color-palette-moss-muted)",
    "variable": "var(--colors-color-palette-moss-muted)"
  },
  "colors.colorPalette.moss.default": {
    "value": "var(--colors-color-palette-moss-default)",
    "variable": "var(--colors-color-palette-moss-default)"
  },
  "colors.colorPalette.decorative.gray": {
    "value": "var(--colors-color-palette-decorative-gray)",
    "variable": "var(--colors-color-palette-decorative-gray)"
  },
  "colors.colorPalette.decorative.blue": {
    "value": "var(--colors-color-palette-decorative-blue)",
    "variable": "var(--colors-color-palette-decorative-blue)"
  },
  "colors.colorPalette.decorative.purple": {
    "value": "var(--colors-color-palette-decorative-purple)",
    "variable": "var(--colors-color-palette-decorative-purple)"
  },
  "colors.colorPalette.decorative.yellow": {
    "value": "var(--colors-color-palette-decorative-yellow)",
    "variable": "var(--colors-color-palette-decorative-yellow)"
  },
  "colors.colorPalette.decorative.red": {
    "value": "var(--colors-color-palette-decorative-red)",
    "variable": "var(--colors-color-palette-decorative-red)"
  },
  "colors.colorPalette.decorative.green": {
    "value": "var(--colors-color-palette-decorative-green)",
    "variable": "var(--colors-color-palette-decorative-green)"
  },
  "colors.colorPalette.decorative.pink": {
    "value": "var(--colors-color-palette-decorative-pink)",
    "variable": "var(--colors-color-palette-decorative-pink)"
  },
  "colors.colorPalette.decorative.orange": {
    "value": "var(--colors-color-palette-decorative-orange)",
    "variable": "var(--colors-color-palette-decorative-orange)"
  },
  "colors.colorPalette.decorative.cyan": {
    "value": "var(--colors-color-palette-decorative-cyan)",
    "variable": "var(--colors-color-palette-decorative-cyan)"
  },
  "colors.colorPalette.cyan": {
    "value": "var(--colors-color-palette-cyan)",
    "variable": "var(--colors-color-palette-cyan)"
  },
  "colors.colorPalette.decorative.darkGreen": {
    "value": "var(--colors-color-palette-decorative-dark-green)",
    "variable": "var(--colors-color-palette-decorative-dark-green)"
  },
  "colors.colorPalette.darkGreen": {
    "value": "var(--colors-color-palette-dark-green)",
    "variable": "var(--colors-color-palette-dark-green)"
  },
  "colors.colorPalette.tooltip": {
    "value": "var(--colors-color-palette-tooltip)",
    "variable": "var(--colors-color-palette-tooltip)"
  },
  "colors.colorPalette.tooltipChip": {
    "value": "var(--colors-color-palette-tooltip-chip)",
    "variable": "var(--colors-color-palette-tooltip-chip)"
  },
  "colors.colorPalette.emphasizedMuted": {
    "value": "var(--colors-color-palette-emphasized-muted)",
    "variable": "var(--colors-color-palette-emphasized-muted)"
  },
  "colors.colorPalette.neutral.emphasizedMuted": {
    "value": "var(--colors-color-palette-neutral-emphasized-muted)",
    "variable": "var(--colors-color-palette-neutral-emphasized-muted)"
  },
  "colors.colorPalette.onaccent.subtle": {
    "value": "var(--colors-color-palette-onaccent-subtle)",
    "variable": "var(--colors-color-palette-onaccent-subtle)"
  },
  "colors.colorPalette.onaccent.muted": {
    "value": "var(--colors-color-palette-onaccent-muted)",
    "variable": "var(--colors-color-palette-onaccent-muted)"
  },
  "colors.colorPalette.onaccent.emphasized": {
    "value": "var(--colors-color-palette-onaccent-emphasized)",
    "variable": "var(--colors-color-palette-onaccent-emphasized)"
  },
  "colors.colorPalette.tooltip.default": {
    "value": "var(--colors-color-palette-tooltip-default)",
    "variable": "var(--colors-color-palette-tooltip-default)"
  },
  "colors.colorPalette.tooltip.muted": {
    "value": "var(--colors-color-palette-tooltip-muted)",
    "variable": "var(--colors-color-palette-tooltip-muted)"
  },
  "colors.colorPalette.tooltip.subtle": {
    "value": "var(--colors-color-palette-tooltip-subtle)",
    "variable": "var(--colors-color-palette-tooltip-subtle)"
  },
  "colors.colorPalette.outline": {
    "value": "var(--colors-color-palette-outline)",
    "variable": "var(--colors-color-palette-outline)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--colors-color-palette-focus)",
    "variable": "var(--colors-color-palette-focus)"
  },
  "colors.colorPalette.neutral.focus": {
    "value": "var(--colors-color-palette-neutral-focus)",
    "variable": "var(--colors-color-palette-neutral-focus)"
  },
  "colors.colorPalette.accent.focus": {
    "value": "var(--colors-color-palette-accent-focus)",
    "variable": "var(--colors-color-palette-accent-focus)"
  },
  "colors.colorPalette.accent.ring": {
    "value": "var(--colors-color-palette-accent-ring)",
    "variable": "var(--colors-color-palette-accent-ring)"
  },
  "colors.colorPalette.ring": {
    "value": "var(--colors-color-palette-ring)",
    "variable": "var(--colors-color-palette-ring)"
  },
  "colors.colorPalette.vulnerability.critical": {
    "value": "var(--colors-color-palette-vulnerability-critical)",
    "variable": "var(--colors-color-palette-vulnerability-critical)"
  },
  "colors.colorPalette.vulnerability.safe": {
    "value": "var(--colors-color-palette-vulnerability-safe)",
    "variable": "var(--colors-color-palette-vulnerability-safe)"
  },
  "colors.colorPalette.safe": {
    "value": "var(--colors-color-palette-safe)",
    "variable": "var(--colors-color-palette-safe)"
  },
  "colors.colorPalette.tooltipDivider": {
    "value": "var(--colors-color-palette-tooltip-divider)",
    "variable": "var(--colors-color-palette-tooltip-divider)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar